// googleFonts.js

const googleFonts = {
  "Roboto": {
    "link": "https://fonts.googleapis.com/css?family=Roboto:ital,wght@0,100;1,100;0,300;1,300;0,400;1,400;0,500;1,500;0,700;1,700;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Roboto', sans-serif"
  },
  "Open Sans": {
    "link": "https://fonts.googleapis.com/css?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&subset=latin&display=swap",
    "fontFamily": "'Open Sans', sans-serif"
  },
  "Noto Sans JP": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+JP:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans JP', sans-serif"
  },
  "Montserrat": {
    "link": "https://fonts.googleapis.com/css?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Montserrat', sans-serif"
  },
  "Lato": {
    "link": "https://fonts.googleapis.com/css?family=Lato:ital,wght@0,100;1,100;0,300;1,300;0,400;1,400;0,700;1,700;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Lato', sans-serif"
  },
  "Poppins": {
    "link": "https://fonts.googleapis.com/css?family=Poppins:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Poppins', sans-serif"
  },
  "Inter": {
    "link": "https://fonts.googleapis.com/css?family=Inter:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Inter', sans-serif"
  },
  "Roboto Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Roboto+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Roboto Condensed', sans-serif"
  },
  "Roboto Mono": {
    "link": "https://fonts.googleapis.com/css?family=Roboto+Mono:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Roboto Mono', sans-serif"
  },
  "Oswald": {
    "link": "https://fonts.googleapis.com/css?family=Oswald:wght@0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Oswald', sans-serif"
  },
  "Noto Sans": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans', sans-serif"
  },
  "Raleway": {
    "link": "https://fonts.googleapis.com/css?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Raleway', sans-serif"
  },
  "Ubuntu": {
    "link": "https://fonts.googleapis.com/css?family=Ubuntu:ital,wght@0,300;1,300;0,400;1,400;0,500;1,500;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Ubuntu', sans-serif"
  },
  "Nunito Sans": {
    "link": "https://fonts.googleapis.com/css?family=Nunito+Sans:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Nunito Sans', sans-serif"
  },
  "Roboto Slab": {
    "link": "https://fonts.googleapis.com/css?family=Roboto+Slab:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Roboto Slab', sans-serif"
  },
  "Rubik": {
    "link": "https://fonts.googleapis.com/css?family=Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Rubik', sans-serif"
  },
  "Playfair Display": {
    "link": "https://fonts.googleapis.com/css?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Playfair Display', sans-serif"
  },
  "Nunito": {
    "link": "https://fonts.googleapis.com/css?family=Nunito:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Nunito', sans-serif"
  },
  "Merriweather": {
    "link": "https://fonts.googleapis.com/css?family=Merriweather:ital,wght@0,300;1,300;0,400;1,400;0,700;1,700;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Merriweather', sans-serif"
  },
  "PT Sans": {
    "link": "https://fonts.googleapis.com/css?family=PT+Sans:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'PT Sans', sans-serif"
  },
  "Noto Sans KR": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+KR:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans KR', sans-serif"
  },
  "Noto Sans TC": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+TC:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans TC', sans-serif"
  },
  "Kanit": {
    "link": "https://fonts.googleapis.com/css?family=Kanit:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Kanit', sans-serif"
  },
  "Fira Sans": {
    "link": "https://fonts.googleapis.com/css?family=Fira+Sans:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Fira Sans', sans-serif"
  },
  "Lora": {
    "link": "https://fonts.googleapis.com/css?family=Lora:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Lora', sans-serif"
  },
  "Work Sans": {
    "link": "https://fonts.googleapis.com/css?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Work Sans', sans-serif"
  },
  "DM Sans": {
    "link": "https://fonts.googleapis.com/css?family=DM+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'DM Sans', sans-serif"
  },
  "Mulish": {
    "link": "https://fonts.googleapis.com/css?family=Mulish:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Mulish', sans-serif"
  },
  "Barlow": {
    "link": "https://fonts.googleapis.com/css?family=Barlow:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Barlow', sans-serif"
  },
  "IBM Plex Sans": {
    "link": "https://fonts.googleapis.com/css?family=IBM+Plex+Sans:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'IBM Plex Sans', sans-serif"
  },
  "Manrope": {
    "link": "https://fonts.googleapis.com/css?family=Manrope:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Manrope', sans-serif"
  },
  "Quicksand": {
    "link": "https://fonts.googleapis.com/css?family=Quicksand:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Quicksand', sans-serif"
  },
  "Inconsolata": {
    "link": "https://fonts.googleapis.com/css?family=Inconsolata:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Inconsolata', sans-serif"
  },
  "Heebo": {
    "link": "https://fonts.googleapis.com/css?family=Heebo:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Heebo', sans-serif"
  },
  "Titillium Web": {
    "link": "https://fonts.googleapis.com/css?family=Titillium+Web:ital,wght@0,200;1,200;0,300;1,300;0,400;1,400;0,600;1,600;0,700;1,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Titillium Web', sans-serif"
  },
  "PT Serif": {
    "link": "https://fonts.googleapis.com/css?family=PT+Serif:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'PT Serif', sans-serif"
  },
  "Noto Serif": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif', sans-serif"
  },
  "Libre Franklin": {
    "link": "https://fonts.googleapis.com/css?family=Libre+Franklin:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Libre Franklin', sans-serif"
  },
  "Karla": {
    "link": "https://fonts.googleapis.com/css?family=Karla:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,200;1,300;1,400;1,500;1,600;1,700;1,800&subset=latin&display=swap",
    "fontFamily": "'Karla', sans-serif"
  },
  "Mukta": {
    "link": "https://fonts.googleapis.com/css?family=Mukta:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Mukta', sans-serif"
  },
  "Nanum Gothic": {
    "link": "https://fonts.googleapis.com/css?family=Nanum+Gothic:wght@0,400;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Nanum Gothic', sans-serif"
  },
  "Noto Sans SC": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+SC:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans SC', sans-serif"
  },
  "Source Code Pro": {
    "link": "https://fonts.googleapis.com/css?family=Source+Code+Pro:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Source Code Pro', sans-serif"
  },
  "Josefin Sans": {
    "link": "https://fonts.googleapis.com/css?family=Josefin+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Josefin Sans', sans-serif"
  },
  "Arimo": {
    "link": "https://fonts.googleapis.com/css?family=Arimo:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Arimo', sans-serif"
  },
  "Dosis": {
    "link": "https://fonts.googleapis.com/css?family=Dosis:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Dosis', sans-serif"
  },
  "Libre Baskerville": {
    "link": "https://fonts.googleapis.com/css?family=Libre+Baskerville:ital,wght@0,400;1,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Libre Baskerville', sans-serif"
  },
  "Cairo": {
    "link": "https://fonts.googleapis.com/css?family=Cairo:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Cairo', sans-serif"
  },
  "PT Sans Narrow": {
    "link": "https://fonts.googleapis.com/css?family=PT+Sans+Narrow:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'PT Sans Narrow', sans-serif"
  },
  "Space Grotesk": {
    "link": "https://fonts.googleapis.com/css?family=Space+Grotesk:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Space Grotesk', sans-serif"
  },
  "Bitter": {
    "link": "https://fonts.googleapis.com/css?family=Bitter:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Bitter', sans-serif"
  },
  "Bebas Neue": {
    "link": "https://fonts.googleapis.com/css?family=Bebas+Neue:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bebas Neue', sans-serif"
  },
  "Jost": {
    "link": "https://fonts.googleapis.com/css?family=Jost:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Jost', sans-serif"
  },
  "Cabin": {
    "link": "https://fonts.googleapis.com/css?family=Cabin:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Cabin', sans-serif"
  },
  "Hind Siliguri": {
    "link": "https://fonts.googleapis.com/css?family=Hind+Siliguri:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Hind Siliguri', sans-serif"
  },
  "EB Garamond": {
    "link": "https://fonts.googleapis.com/css?family=EB+Garamond:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800&subset=latin&display=swap",
    "fontFamily": "'EB Garamond', sans-serif"
  },
  "Oxygen": {
    "link": "https://fonts.googleapis.com/css?family=Oxygen:wght@0,300;0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Oxygen', sans-serif"
  },
  "Overpass": {
    "link": "https://fonts.googleapis.com/css?family=Overpass:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Overpass', sans-serif"
  },
  "Dancing Script": {
    "link": "https://fonts.googleapis.com/css?family=Dancing+Script:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Dancing Script', sans-serif"
  },
  "Anton": {
    "link": "https://fonts.googleapis.com/css?family=Anton:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Anton', sans-serif"
  },
  "Exo 2": {
    "link": "https://fonts.googleapis.com/css?family=Exo+2:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Exo 2', sans-serif"
  },
  "Archivo": {
    "link": "https://fonts.googleapis.com/css?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Archivo', sans-serif"
  },
  "Outfit": {
    "link": "https://fonts.googleapis.com/css?family=Outfit:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Outfit', sans-serif"
  },
  "Teko": {
    "link": "https://fonts.googleapis.com/css?family=Teko:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Teko', sans-serif"
  },
  "Barlow Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Barlow+Condensed:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Barlow Condensed', sans-serif"
  },
  "Noto Serif JP": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+JP:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif JP', sans-serif"
  },
  "Hind": {
    "link": "https://fonts.googleapis.com/css?family=Hind:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Hind', sans-serif"
  },
  "Assistant": {
    "link": "https://fonts.googleapis.com/css?family=Assistant:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Assistant', sans-serif"
  },
  "Noto Sans HK": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+HK:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans HK', sans-serif"
  },
  "Pacifico": {
    "link": "https://fonts.googleapis.com/css?family=Pacifico:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Pacifico', sans-serif"
  },
  "Comfortaa": {
    "link": "https://fonts.googleapis.com/css?family=Comfortaa:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Comfortaa', sans-serif"
  },
  "Signika Negative": {
    "link": "https://fonts.googleapis.com/css?family=Signika+Negative:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Signika Negative', sans-serif"
  },
  "Lobster": {
    "link": "https://fonts.googleapis.com/css?family=Lobster:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Lobster', sans-serif"
  },
  "Abel": {
    "link": "https://fonts.googleapis.com/css?family=Abel:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Abel', sans-serif"
  },
  "Prompt": {
    "link": "https://fonts.googleapis.com/css?family=Prompt:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Prompt', sans-serif"
  },
  "Public Sans": {
    "link": "https://fonts.googleapis.com/css?family=Public+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Public Sans', sans-serif"
  },
  "Source Sans 3": {
    "link": "https://fonts.googleapis.com/css?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Source Sans 3', sans-serif"
  },
  "Figtree": {
    "link": "https://fonts.googleapis.com/css?family=Figtree:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Figtree', sans-serif"
  },
  "M PLUS Rounded 1c": {
    "link": "https://fonts.googleapis.com/css?family=M+PLUS+Rounded+1c:wght@0,100;0,300;0,400;0,500;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'M PLUS Rounded 1c', sans-serif"
  },
  "Crimson Text": {
    "link": "https://fonts.googleapis.com/css?family=Crimson+Text:ital,wght@0,400;1,400;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Crimson Text', sans-serif"
  },
  "Fjalla One": {
    "link": "https://fonts.googleapis.com/css?family=Fjalla+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Fjalla One', sans-serif"
  },
  "DM Serif Display": {
    "link": "https://fonts.googleapis.com/css?family=DM+Serif+Display:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'DM Serif Display', sans-serif"
  },
  "Caveat": {
    "link": "https://fonts.googleapis.com/css?family=Caveat:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Caveat', sans-serif"
  },
  "Varela Round": {
    "link": "https://fonts.googleapis.com/css?family=Varela+Round:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Varela Round', sans-serif"
  },
  "Red Hat Display": {
    "link": "https://fonts.googleapis.com/css?family=Red+Hat+Display:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Red Hat Display', sans-serif"
  },
  "IBM Plex Mono": {
    "link": "https://fonts.googleapis.com/css?family=IBM+Plex+Mono:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'IBM Plex Mono', sans-serif"
  },
  "Cormorant Garamond": {
    "link": "https://fonts.googleapis.com/css?family=Cormorant+Garamond:ital,wght@0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Cormorant Garamond', sans-serif"
  },
  "Arvo": {
    "link": "https://fonts.googleapis.com/css?family=Arvo:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Arvo', sans-serif"
  },
  "Zilla Slab": {
    "link": "https://fonts.googleapis.com/css?family=Zilla+Slab:ital,wght@0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Zilla Slab', sans-serif"
  },
  "Rajdhani": {
    "link": "https://fonts.googleapis.com/css?family=Rajdhani:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Rajdhani', sans-serif"
  },
  "IBM Plex Sans Arabic": {
    "link": "https://fonts.googleapis.com/css?family=IBM+Plex+Sans+Arabic:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'IBM Plex Sans Arabic', sans-serif"
  },
  "Maven Pro": {
    "link": "https://fonts.googleapis.com/css?family=Maven+Pro:wght@0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Maven Pro', sans-serif"
  },
  "Abril Fatface": {
    "link": "https://fonts.googleapis.com/css?family=Abril+Fatface:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Abril Fatface', sans-serif"
  },
  "Play": {
    "link": "https://fonts.googleapis.com/css?family=Play:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Play', sans-serif"
  },
  "Fira Sans Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Fira+Sans+Condensed:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Fira Sans Condensed', sans-serif"
  },
  "Lexend": {
    "link": "https://fonts.googleapis.com/css?family=Lexend:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Lexend', sans-serif"
  },
  "Slabo 27px": {
    "link": "https://fonts.googleapis.com/css?family=Slabo+27px:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Slabo 27px', sans-serif"
  },
  "Plus Jakarta Sans": {
    "link": "https://fonts.googleapis.com/css?family=Plus+Jakarta+Sans:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,200;1,300;1,400;1,500;1,600;1,700;1,800&subset=latin&display=swap",
    "fontFamily": "'Plus Jakarta Sans', sans-serif"
  },
  "Shadows Into Light": {
    "link": "https://fonts.googleapis.com/css?family=Shadows+Into+Light:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Shadows Into Light', sans-serif"
  },
  "Asap": {
    "link": "https://fonts.googleapis.com/css?family=Asap:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Asap', sans-serif"
  },
  "Tajawal": {
    "link": "https://fonts.googleapis.com/css?family=Tajawal:wght@0,200;0,300;0,400;0,500;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Tajawal', sans-serif"
  },
  "Barlow Semi Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Barlow+Semi+Condensed:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Barlow Semi Condensed', sans-serif"
  },
  "Chakra Petch": {
    "link": "https://fonts.googleapis.com/css?family=Chakra+Petch:ital,wght@0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Chakra Petch', sans-serif"
  },
  "Merriweather Sans": {
    "link": "https://fonts.googleapis.com/css?family=Merriweather+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&subset=latin&display=swap",
    "fontFamily": "'Merriweather Sans', sans-serif"
  },
  "IBM Plex Serif": {
    "link": "https://fonts.googleapis.com/css?family=IBM+Plex+Serif:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'IBM Plex Serif', sans-serif"
  },
  "Lilita One": {
    "link": "https://fonts.googleapis.com/css?family=Lilita+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Lilita One', sans-serif"
  },
  "Indie Flower": {
    "link": "https://fonts.googleapis.com/css?family=Indie+Flower:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Indie Flower', sans-serif"
  },
  "Archivo Black": {
    "link": "https://fonts.googleapis.com/css?family=Archivo+Black:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Archivo Black', sans-serif"
  },
  "Permanent Marker": {
    "link": "https://fonts.googleapis.com/css?family=Permanent+Marker:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Permanent Marker', sans-serif"
  },
  "Domine": {
    "link": "https://fonts.googleapis.com/css?family=Domine:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Domine', sans-serif"
  },
  "Questrial": {
    "link": "https://fonts.googleapis.com/css?family=Questrial:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Questrial', sans-serif"
  },
  "Nanum Gothic Coding": {
    "link": "https://fonts.googleapis.com/css?family=Nanum+Gothic+Coding:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Nanum Gothic Coding', sans-serif"
  },
  "Satisfy": {
    "link": "https://fonts.googleapis.com/css?family=Satisfy:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Satisfy', sans-serif"
  },
  "Source Serif 4": {
    "link": "https://fonts.googleapis.com/css?family=Source+Serif+4:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Source Serif 4', sans-serif"
  },
  "Signika": {
    "link": "https://fonts.googleapis.com/css?family=Signika:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Signika', sans-serif"
  },
  "Nanum Myeongjo": {
    "link": "https://fonts.googleapis.com/css?family=Nanum+Myeongjo:wght@0,400;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Nanum Myeongjo', sans-serif"
  },
  "M PLUS 1p": {
    "link": "https://fonts.googleapis.com/css?family=M+PLUS+1p:wght@0,100;0,300;0,400;0,500;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'M PLUS 1p', sans-serif"
  },
  "Sora": {
    "link": "https://fonts.googleapis.com/css?family=Sora:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Sora', sans-serif"
  },
  "Catamaran": {
    "link": "https://fonts.googleapis.com/css?family=Catamaran:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Catamaran', sans-serif"
  },
  "Hind Madurai": {
    "link": "https://fonts.googleapis.com/css?family=Hind+Madurai:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Hind Madurai', sans-serif"
  },
  "Yanone Kaffeesatz": {
    "link": "https://fonts.googleapis.com/css?family=Yanone+Kaffeesatz:wght@0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Yanone Kaffeesatz', sans-serif"
  },
  "Rowdies": {
    "link": "https://fonts.googleapis.com/css?family=Rowdies:wght@0,300;0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Rowdies', sans-serif"
  },
  "Urbanist": {
    "link": "https://fonts.googleapis.com/css?family=Urbanist:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Urbanist', sans-serif"
  },
  "Asap Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Asap+Condensed:ital,wght@0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Asap Condensed', sans-serif"
  },
  "Orbitron": {
    "link": "https://fonts.googleapis.com/css?family=Orbitron:wght@0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Orbitron', sans-serif"
  },
  "Sarabun": {
    "link": "https://fonts.googleapis.com/css?family=Sarabun:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800&subset=latin&display=swap",
    "fontFamily": "'Sarabun', sans-serif"
  },
  "Noto Kufi Arabic": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Kufi+Arabic:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Kufi Arabic', sans-serif"
  },
  "Vollkorn": {
    "link": "https://fonts.googleapis.com/css?family=Vollkorn:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Vollkorn', sans-serif"
  },
  "Roboto Flex": {
    "link": "https://fonts.googleapis.com/css?family=Roboto+Flex:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Roboto Flex', sans-serif"
  },
  "Noticia Text": {
    "link": "https://fonts.googleapis.com/css?family=Noticia+Text:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Noticia Text', sans-serif"
  },
  "Acme": {
    "link": "https://fonts.googleapis.com/css?family=Acme:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Acme', sans-serif"
  },
  "Russo One": {
    "link": "https://fonts.googleapis.com/css?family=Russo+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Russo One', sans-serif"
  },
  "Exo": {
    "link": "https://fonts.googleapis.com/css?family=Exo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Exo', sans-serif"
  },
  "Archivo Narrow": {
    "link": "https://fonts.googleapis.com/css?family=Archivo+Narrow:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Archivo Narrow', sans-serif"
  },
  "Montserrat Alternates": {
    "link": "https://fonts.googleapis.com/css?family=Montserrat+Alternates:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Montserrat Alternates', sans-serif"
  },
  "Bree Serif": {
    "link": "https://fonts.googleapis.com/css?family=Bree+Serif:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bree Serif', sans-serif"
  },
  "Cinzel": {
    "link": "https://fonts.googleapis.com/css?family=Cinzel:wght@0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Cinzel', sans-serif"
  },
  "Didact Gothic": {
    "link": "https://fonts.googleapis.com/css?family=Didact+Gothic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Didact Gothic', sans-serif"
  },
  "Frank Ruhl Libre": {
    "link": "https://fonts.googleapis.com/css?family=Frank+Ruhl+Libre:wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Frank Ruhl Libre', sans-serif"
  },
  "Amatic SC": {
    "link": "https://fonts.googleapis.com/css?family=Amatic+SC:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Amatic SC', sans-serif"
  },
  "Marcellus": {
    "link": "https://fonts.googleapis.com/css?family=Marcellus:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Marcellus', sans-serif"
  },
  "Alegreya": {
    "link": "https://fonts.googleapis.com/css?family=Alegreya:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Alegreya', sans-serif"
  },
  "Kalam": {
    "link": "https://fonts.googleapis.com/css?family=Kalam:wght@0,300;0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Kalam', sans-serif"
  },
  "Tinos": {
    "link": "https://fonts.googleapis.com/css?family=Tinos:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Tinos', sans-serif"
  },
  "Black Ops One": {
    "link": "https://fonts.googleapis.com/css?family=Black+Ops+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Black Ops One', sans-serif"
  },
  "ABeeZee": {
    "link": "https://fonts.googleapis.com/css?family=ABeeZee:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'ABeeZee', sans-serif"
  },
  "Alegreya Sans": {
    "link": "https://fonts.googleapis.com/css?family=Alegreya+Sans:ital,wght@0,100;1,100;0,300;1,300;0,400;1,400;0,500;1,500;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Alegreya Sans', sans-serif"
  },
  "Alfa Slab One": {
    "link": "https://fonts.googleapis.com/css?family=Alfa+Slab+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Alfa Slab One', sans-serif"
  },
  "Chivo": {
    "link": "https://fonts.googleapis.com/css?family=Chivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Chivo', sans-serif"
  },
  "Saira Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Saira+Condensed:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Saira Condensed', sans-serif"
  },
  "Patua One": {
    "link": "https://fonts.googleapis.com/css?family=Patua+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Patua One', sans-serif"
  },
  "Zeyada": {
    "link": "https://fonts.googleapis.com/css?family=Zeyada:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Zeyada', sans-serif"
  },
  "Crimson Pro": {
    "link": "https://fonts.googleapis.com/css?family=Crimson+Pro:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Crimson Pro', sans-serif"
  },
  "Changa": {
    "link": "https://fonts.googleapis.com/css?family=Changa:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Changa', sans-serif"
  },
  "Martel": {
    "link": "https://fonts.googleapis.com/css?family=Martel:wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Martel', sans-serif"
  },
  "Philosopher": {
    "link": "https://fonts.googleapis.com/css?family=Philosopher:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Philosopher', sans-serif"
  },
  "PT Sans Caption": {
    "link": "https://fonts.googleapis.com/css?family=PT+Sans+Caption:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'PT Sans Caption', sans-serif"
  },
  "Cormorant": {
    "link": "https://fonts.googleapis.com/css?family=Cormorant:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Cormorant', sans-serif"
  },
  "Great Vibes": {
    "link": "https://fonts.googleapis.com/css?family=Great+Vibes:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Great Vibes', sans-serif"
  },
  "Spectral": {
    "link": "https://fonts.googleapis.com/css?family=Spectral:ital,wght@0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800&subset=latin&display=swap",
    "fontFamily": "'Spectral', sans-serif"
  },
  "Amiri": {
    "link": "https://fonts.googleapis.com/css?family=Amiri:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Amiri', sans-serif"
  },
  "Courgette": {
    "link": "https://fonts.googleapis.com/css?family=Courgette:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Courgette', sans-serif"
  },
  "Concert One": {
    "link": "https://fonts.googleapis.com/css?family=Concert+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Concert One', sans-serif"
  },
  "Ubuntu Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Ubuntu+Condensed:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ubuntu Condensed', sans-serif"
  },
  "Righteous": {
    "link": "https://fonts.googleapis.com/css?family=Righteous:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Righteous', sans-serif"
  },
  "Cantarell": {
    "link": "https://fonts.googleapis.com/css?family=Cantarell:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Cantarell', sans-serif"
  },
  "Noto Sans Bengali": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Bengali:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Bengali', sans-serif"
  },
  "Lexend Deca": {
    "link": "https://fonts.googleapis.com/css?family=Lexend+Deca:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Lexend Deca', sans-serif"
  },
  "Lobster Two": {
    "link": "https://fonts.googleapis.com/css?family=Lobster+Two:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Lobster Two', sans-serif"
  },
  "Prata": {
    "link": "https://fonts.googleapis.com/css?family=Prata:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Prata', sans-serif"
  },
  "Passion One": {
    "link": "https://fonts.googleapis.com/css?family=Passion+One:wght@0,400;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Passion One', sans-serif"
  },
  "Encode Sans": {
    "link": "https://fonts.googleapis.com/css?family=Encode+Sans:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Encode Sans', sans-serif"
  },
  "Noto Sans Thai": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Thai:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Thai', sans-serif"
  },
  "Sawarabi Mincho": {
    "link": "https://fonts.googleapis.com/css?family=Sawarabi+Mincho:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sawarabi Mincho', sans-serif"
  },
  "Be Vietnam Pro": {
    "link": "https://fonts.googleapis.com/css?family=Be+Vietnam+Pro:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Be Vietnam Pro', sans-serif"
  },
  "Cardo": {
    "link": "https://fonts.googleapis.com/css?family=Cardo:ital,wght@0,400;1,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Cardo', sans-serif"
  },
  "Readex Pro": {
    "link": "https://fonts.googleapis.com/css?family=Readex+Pro:wght@0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Readex Pro', sans-serif"
  },
  "Noto Serif KR": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+KR:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif KR', sans-serif"
  },
  "Noto Sans Display": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Display:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Display', sans-serif"
  },
  "Oleo Script": {
    "link": "https://fonts.googleapis.com/css?family=Oleo+Script:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Oleo Script', sans-serif"
  },
  "Crete Round": {
    "link": "https://fonts.googleapis.com/css?family=Crete+Round:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Crete Round', sans-serif"
  },
  "Neuton": {
    "link": "https://fonts.googleapis.com/css?family=Neuton:ital,wght@0,200;0,300;0,400;1,400;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Neuton', sans-serif"
  },
  "Mate": {
    "link": "https://fonts.googleapis.com/css?family=Mate:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Mate', sans-serif"
  },
  "Old Standard TT": {
    "link": "https://fonts.googleapis.com/css?family=Old+Standard+TT:ital,wght@0,400;1,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Old Standard TT', sans-serif"
  },
  "Noto Serif TC": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+TC:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif TC', sans-serif"
  },
  "Sacramento": {
    "link": "https://fonts.googleapis.com/css?family=Sacramento:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sacramento', sans-serif"
  },
  "Titan One": {
    "link": "https://fonts.googleapis.com/css?family=Titan+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Titan One', sans-serif"
  },
  "Space Mono": {
    "link": "https://fonts.googleapis.com/css?family=Space+Mono:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Space Mono', sans-serif"
  },
  "Kaushan Script": {
    "link": "https://fonts.googleapis.com/css?family=Kaushan+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kaushan Script', sans-serif"
  },
  "Francois One": {
    "link": "https://fonts.googleapis.com/css?family=Francois+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Francois One', sans-serif"
  },
  "Saira": {
    "link": "https://fonts.googleapis.com/css?family=Saira:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Saira', sans-serif"
  },
  "Commissioner": {
    "link": "https://fonts.googleapis.com/css?family=Commissioner:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Commissioner', sans-serif"
  },
  "Unbounded": {
    "link": "https://fonts.googleapis.com/css?family=Unbounded:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Unbounded', sans-serif"
  },
  "Merienda": {
    "link": "https://fonts.googleapis.com/css?family=Merienda:wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Merienda', sans-serif"
  },
  "Khand": {
    "link": "https://fonts.googleapis.com/css?family=Khand:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Khand', sans-serif"
  },
  "Alata": {
    "link": "https://fonts.googleapis.com/css?family=Alata:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Alata', sans-serif"
  },
  "Bodoni Moda": {
    "link": "https://fonts.googleapis.com/css?family=Bodoni+Moda:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Bodoni Moda', sans-serif"
  },
  "El Messiri": {
    "link": "https://fonts.googleapis.com/css?family=El+Messiri:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'El Messiri', sans-serif"
  },
  "Paytone One": {
    "link": "https://fonts.googleapis.com/css?family=Paytone+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Paytone One', sans-serif"
  },
  "Yantramanav": {
    "link": "https://fonts.googleapis.com/css?family=Yantramanav:wght@0,100;0,300;0,400;0,500;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Yantramanav', sans-serif"
  },
  "Arsenal": {
    "link": "https://fonts.googleapis.com/css?family=Arsenal:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Arsenal', sans-serif"
  },
  "Gruppo": {
    "link": "https://fonts.googleapis.com/css?family=Gruppo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gruppo', sans-serif"
  },
  "Gothic A1": {
    "link": "https://fonts.googleapis.com/css?family=Gothic+A1:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Gothic A1', sans-serif"
  },
  "Alice": {
    "link": "https://fonts.googleapis.com/css?family=Alice:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Alice', sans-serif"
  },
  "IBM Plex Sans Condensed": {
    "link": "https://fonts.googleapis.com/css?family=IBM+Plex+Sans+Condensed:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'IBM Plex Sans Condensed', sans-serif"
  },
  "DM Serif Text": {
    "link": "https://fonts.googleapis.com/css?family=DM+Serif+Text:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'DM Serif Text', sans-serif"
  },
  "Gloria Hallelujah": {
    "link": "https://fonts.googleapis.com/css?family=Gloria+Hallelujah:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gloria Hallelujah', sans-serif"
  },
  "Quattrocento": {
    "link": "https://fonts.googleapis.com/css?family=Quattrocento:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Quattrocento', sans-serif"
  },
  "League Spartan": {
    "link": "https://fonts.googleapis.com/css?family=League+Spartan:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'League Spartan', sans-serif"
  },
  "Cuprum": {
    "link": "https://fonts.googleapis.com/css?family=Cuprum:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Cuprum', sans-serif"
  },
  "Fraunces": {
    "link": "https://fonts.googleapis.com/css?family=Fraunces:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Fraunces', sans-serif"
  },
  "Ubuntu Mono": {
    "link": "https://fonts.googleapis.com/css?family=Ubuntu+Mono:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Ubuntu Mono', sans-serif"
  },
  "Noto Naskh Arabic": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Naskh+Arabic:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Naskh Arabic', sans-serif"
  },
  "Architects Daughter": {
    "link": "https://fonts.googleapis.com/css?family=Architects+Daughter:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Architects Daughter', sans-serif"
  },
  "Antic Slab": {
    "link": "https://fonts.googleapis.com/css?family=Antic+Slab:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Antic Slab', sans-serif"
  },
  "Zen Maru Gothic": {
    "link": "https://fonts.googleapis.com/css?family=Zen+Maru+Gothic:wght@0,300;0,400;0,500;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Zen Maru Gothic', sans-serif"
  },
  "Pathway Gothic One": {
    "link": "https://fonts.googleapis.com/css?family=Pathway+Gothic+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Pathway Gothic One', sans-serif"
  },
  "Yellowtail": {
    "link": "https://fonts.googleapis.com/css?family=Yellowtail:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Yellowtail', sans-serif"
  },
  "Inter Tight": {
    "link": "https://fonts.googleapis.com/css?family=Inter+Tight:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Inter Tight', sans-serif"
  },
  "Luckiest Guy": {
    "link": "https://fonts.googleapis.com/css?family=Luckiest+Guy:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Luckiest Guy', sans-serif"
  },
  "Sawarabi Gothic": {
    "link": "https://fonts.googleapis.com/css?family=Sawarabi+Gothic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sawarabi Gothic', sans-serif"
  },
  "Noto Sans Mono": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Mono:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Mono', sans-serif"
  },
  "Advent Pro": {
    "link": "https://fonts.googleapis.com/css?family=Advent+Pro:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Advent Pro', sans-serif"
  },
  "Josefin Slab": {
    "link": "https://fonts.googleapis.com/css?family=Josefin+Slab:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Josefin Slab', sans-serif"
  },
  "Zen Kaku Gothic New": {
    "link": "https://fonts.googleapis.com/css?family=Zen+Kaku+Gothic+New:wght@0,300;0,400;0,500;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Zen Kaku Gothic New', sans-serif"
  },
  "Gelasio": {
    "link": "https://fonts.googleapis.com/css?family=Gelasio:ital,wght@0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Gelasio', sans-serif"
  },
  "Quattrocento Sans": {
    "link": "https://fonts.googleapis.com/css?family=Quattrocento+Sans:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Quattrocento Sans', sans-serif"
  },
  "Handlee": {
    "link": "https://fonts.googleapis.com/css?family=Handlee:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Handlee', sans-serif"
  },
  "Eczar": {
    "link": "https://fonts.googleapis.com/css?family=Eczar:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Eczar', sans-serif"
  },
  "Mate SC": {
    "link": "https://fonts.googleapis.com/css?family=Mate+SC:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mate SC', sans-serif"
  },
  "Alegreya Sans SC": {
    "link": "https://fonts.googleapis.com/css?family=Alegreya+Sans+SC:ital,wght@0,100;1,100;0,300;1,300;0,400;1,400;0,500;1,500;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Alegreya Sans SC', sans-serif"
  },
  "Unna": {
    "link": "https://fonts.googleapis.com/css?family=Unna:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Unna', sans-serif"
  },
  "Cookie": {
    "link": "https://fonts.googleapis.com/css?family=Cookie:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Cookie', sans-serif"
  },
  "Silkscreen": {
    "link": "https://fonts.googleapis.com/css?family=Silkscreen:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Silkscreen', sans-serif"
  },
  "Roboto Serif": {
    "link": "https://fonts.googleapis.com/css?family=Roboto+Serif:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Roboto Serif', sans-serif"
  },
  "Rokkitt": {
    "link": "https://fonts.googleapis.com/css?family=Rokkitt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Rokkitt', sans-serif"
  },
  "News Cycle": {
    "link": "https://fonts.googleapis.com/css?family=News+Cycle:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'News Cycle', sans-serif"
  },
  "Fira Sans Extra Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Fira+Sans+Extra+Condensed:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Fira Sans Extra Condensed', sans-serif"
  },
  "Macondo": {
    "link": "https://fonts.googleapis.com/css?family=Macondo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Macondo', sans-serif"
  },
  "Literata": {
    "link": "https://fonts.googleapis.com/css?family=Literata:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Literata', sans-serif"
  },
  "Poiret One": {
    "link": "https://fonts.googleapis.com/css?family=Poiret+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Poiret One', sans-serif"
  },
  "Tangerine": {
    "link": "https://fonts.googleapis.com/css?family=Tangerine:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Tangerine', sans-serif"
  },
  "Special Elite": {
    "link": "https://fonts.googleapis.com/css?family=Special+Elite:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Special Elite', sans-serif"
  },
  "Allura": {
    "link": "https://fonts.googleapis.com/css?family=Allura:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Allura', sans-serif"
  },
  "Tenor Sans": {
    "link": "https://fonts.googleapis.com/css?family=Tenor+Sans:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Tenor Sans', sans-serif"
  },
  "Baloo 2": {
    "link": "https://fonts.googleapis.com/css?family=Baloo+2:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Baloo 2', sans-serif"
  },
  "Sanchez": {
    "link": "https://fonts.googleapis.com/css?family=Sanchez:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Sanchez', sans-serif"
  },
  "Amaranth": {
    "link": "https://fonts.googleapis.com/css?family=Amaranth:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Amaranth', sans-serif"
  },
  "Rubik Bubbles": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Bubbles:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Bubbles', sans-serif"
  },
  "Sen": {
    "link": "https://fonts.googleapis.com/css?family=Sen:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Sen', sans-serif"
  },
  "Encode Sans Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Encode+Sans+Condensed:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Encode Sans Condensed', sans-serif"
  },
  "Yeseva One": {
    "link": "https://fonts.googleapis.com/css?family=Yeseva+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Yeseva One', sans-serif"
  },
  "Playfair Display SC": {
    "link": "https://fonts.googleapis.com/css?family=Playfair+Display+SC:ital,wght@0,400;1,400;0,700;1,700;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Playfair Display SC', sans-serif"
  },
  "Abhaya Libre": {
    "link": "https://fonts.googleapis.com/css?family=Abhaya+Libre:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Abhaya Libre', sans-serif"
  },
  "Staatliches": {
    "link": "https://fonts.googleapis.com/css?family=Staatliches:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Staatliches', sans-serif"
  },
  "Noto Sans Devanagari": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Devanagari:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Devanagari', sans-serif"
  },
  "Bungee": {
    "link": "https://fonts.googleapis.com/css?family=Bungee:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bungee', sans-serif"
  },
  "Mitr": {
    "link": "https://fonts.googleapis.com/css?family=Mitr:wght@0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Mitr', sans-serif"
  },
  "Patrick Hand": {
    "link": "https://fonts.googleapis.com/css?family=Patrick+Hand:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Patrick Hand', sans-serif"
  },
  "Bangers": {
    "link": "https://fonts.googleapis.com/css?family=Bangers:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bangers', sans-serif"
  },
  "Carter One": {
    "link": "https://fonts.googleapis.com/css?family=Carter+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Carter One', sans-serif"
  },
  "Courier Prime": {
    "link": "https://fonts.googleapis.com/css?family=Courier+Prime:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Courier Prime', sans-serif"
  },
  "Rubik Mono One": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Mono+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Mono One', sans-serif"
  },
  "JetBrains Mono": {
    "link": "https://fonts.googleapis.com/css?family=JetBrains+Mono:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&subset=latin&display=swap",
    "fontFamily": "'JetBrains Mono', sans-serif"
  },
  "Aleo": {
    "link": "https://fonts.googleapis.com/css?family=Aleo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Aleo', sans-serif"
  },
  "PT Mono": {
    "link": "https://fonts.googleapis.com/css?family=PT+Mono:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'PT Mono', sans-serif"
  },
  "Red Hat Text": {
    "link": "https://fonts.googleapis.com/css?family=Red+Hat+Text:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Red Hat Text', sans-serif"
  },
  "DM Mono": {
    "link": "https://fonts.googleapis.com/css?family=DM+Mono:ital,wght@0,300;1,300;0,400;1,400;0,500;1,500&subset=latin&display=swap",
    "fontFamily": "'DM Mono', sans-serif"
  },
  "Kosugi Maru": {
    "link": "https://fonts.googleapis.com/css?family=Kosugi+Maru:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kosugi Maru', sans-serif"
  },
  "Creepster": {
    "link": "https://fonts.googleapis.com/css?family=Creepster:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Creepster', sans-serif"
  },
  "Albert Sans": {
    "link": "https://fonts.googleapis.com/css?family=Albert+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Albert Sans', sans-serif"
  },
  "STIX Two Text": {
    "link": "https://fonts.googleapis.com/css?family=STIX+Two+Text:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'STIX Two Text', sans-serif"
  },
  "Taviraj": {
    "link": "https://fonts.googleapis.com/css?family=Taviraj:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Taviraj', sans-serif"
  },
  "Gudea": {
    "link": "https://fonts.googleapis.com/css?family=Gudea:ital,wght@0,400;1,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Gudea', sans-serif"
  },
  "Vidaloka": {
    "link": "https://fonts.googleapis.com/css?family=Vidaloka:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Vidaloka', sans-serif"
  },
  "Libre Barcode 39": {
    "link": "https://fonts.googleapis.com/css?family=Libre+Barcode+39:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Libre Barcode 39', sans-serif"
  },
  "Baskervville": {
    "link": "https://fonts.googleapis.com/css?family=Baskervville:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Baskervville', sans-serif"
  },
  "Fugaz One": {
    "link": "https://fonts.googleapis.com/css?family=Fugaz+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Fugaz One', sans-serif"
  },
  "Adamina": {
    "link": "https://fonts.googleapis.com/css?family=Adamina:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Adamina', sans-serif"
  },
  "Hind Vadodara": {
    "link": "https://fonts.googleapis.com/css?family=Hind+Vadodara:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Hind Vadodara', sans-serif"
  },
  "Yatra One": {
    "link": "https://fonts.googleapis.com/css?family=Yatra+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Yatra One', sans-serif"
  },
  "Faustina": {
    "link": "https://fonts.googleapis.com/css?family=Faustina:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&subset=latin&display=swap",
    "fontFamily": "'Faustina', sans-serif"
  },
  "Comic Neue": {
    "link": "https://fonts.googleapis.com/css?family=Comic+Neue:ital,wght@0,300;1,300;0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Comic Neue', sans-serif"
  },
  "Parisienne": {
    "link": "https://fonts.googleapis.com/css?family=Parisienne:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Parisienne', sans-serif"
  },
  "Homemade Apple": {
    "link": "https://fonts.googleapis.com/css?family=Homemade+Apple:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Homemade Apple', sans-serif"
  },
  "Unica One": {
    "link": "https://fonts.googleapis.com/css?family=Unica+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Unica One', sans-serif"
  },
  "Viga": {
    "link": "https://fonts.googleapis.com/css?family=Viga:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Viga', sans-serif"
  },
  "Saira Semi Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Saira+Semi+Condensed:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Saira Semi Condensed', sans-serif"
  },
  "Epilogue": {
    "link": "https://fonts.googleapis.com/css?family=Epilogue:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Epilogue', sans-serif"
  },
  "Mukta Malar": {
    "link": "https://fonts.googleapis.com/css?family=Mukta+Malar:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Mukta Malar', sans-serif"
  },
  "Bad Script": {
    "link": "https://fonts.googleapis.com/css?family=Bad+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bad Script', sans-serif"
  },
  "Ropa Sans": {
    "link": "https://fonts.googleapis.com/css?family=Ropa+Sans:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Ropa Sans', sans-serif"
  },
  "Cousine": {
    "link": "https://fonts.googleapis.com/css?family=Cousine:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Cousine', sans-serif"
  },
  "Secular One": {
    "link": "https://fonts.googleapis.com/css?family=Secular+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Secular One', sans-serif"
  },
  "Antonio": {
    "link": "https://fonts.googleapis.com/css?family=Antonio:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Antonio', sans-serif"
  },
  "Sofia": {
    "link": "https://fonts.googleapis.com/css?family=Sofia:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sofia', sans-serif"
  },
  "Ultra": {
    "link": "https://fonts.googleapis.com/css?family=Ultra:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ultra', sans-serif"
  },
  "Volkhov": {
    "link": "https://fonts.googleapis.com/css?family=Volkhov:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Volkhov', sans-serif"
  },
  "Petrona": {
    "link": "https://fonts.googleapis.com/css?family=Petrona:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Petrona', sans-serif"
  },
  "Libre Caslon Text": {
    "link": "https://fonts.googleapis.com/css?family=Libre+Caslon+Text:ital,wght@0,400;1,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Libre Caslon Text', sans-serif"
  },
  "Alex Brush": {
    "link": "https://fonts.googleapis.com/css?family=Alex+Brush:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Alex Brush', sans-serif"
  },
  "Neucha": {
    "link": "https://fonts.googleapis.com/css?family=Neucha:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Neucha', sans-serif"
  },
  "Audiowide": {
    "link": "https://fonts.googleapis.com/css?family=Audiowide:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Audiowide', sans-serif"
  },
  "Voltaire": {
    "link": "https://fonts.googleapis.com/css?family=Voltaire:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Voltaire', sans-serif"
  },
  "Marck Script": {
    "link": "https://fonts.googleapis.com/css?family=Marck+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Marck Script', sans-serif"
  },
  "Varela": {
    "link": "https://fonts.googleapis.com/css?family=Varela:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Varela', sans-serif"
  },
  "Fredoka": {
    "link": "https://fonts.googleapis.com/css?family=Fredoka:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Fredoka', sans-serif"
  },
  "Istok Web": {
    "link": "https://fonts.googleapis.com/css?family=Istok+Web:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Istok Web', sans-serif"
  },
  "Monoton": {
    "link": "https://fonts.googleapis.com/css?family=Monoton:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Monoton', sans-serif"
  },
  "Kumbh Sans": {
    "link": "https://fonts.googleapis.com/css?family=Kumbh+Sans:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Kumbh Sans', sans-serif"
  },
  "Krub": {
    "link": "https://fonts.googleapis.com/css?family=Krub:ital,wght@0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Krub', sans-serif"
  },
  "Forum": {
    "link": "https://fonts.googleapis.com/css?family=Forum:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Forum', sans-serif"
  },
  "Press Start 2P": {
    "link": "https://fonts.googleapis.com/css?family=Press+Start+2P:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Press Start 2P', sans-serif"
  },
  "Blinker": {
    "link": "https://fonts.googleapis.com/css?family=Blinker:wght@0,100;0,200;0,300;0,400;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Blinker', sans-serif"
  },
  "Lalezar": {
    "link": "https://fonts.googleapis.com/css?family=Lalezar:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Lalezar', sans-serif"
  },
  "Itim": {
    "link": "https://fonts.googleapis.com/css?family=Itim:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Itim', sans-serif"
  },
  "Noto Serif SC": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+SC:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif SC', sans-serif"
  },
  "Fira Mono": {
    "link": "https://fonts.googleapis.com/css?family=Fira+Mono:wght@0,400;0,500;0,700&subset=latin&display=swap",
    "fontFamily": "'Fira Mono', sans-serif"
  },
  "Syne": {
    "link": "https://fonts.googleapis.com/css?family=Syne:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Syne', sans-serif"
  },
  "Pridi": {
    "link": "https://fonts.googleapis.com/css?family=Pridi:wght@0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Pridi', sans-serif"
  },
  "Pangolin": {
    "link": "https://fonts.googleapis.com/css?family=Pangolin:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Pangolin', sans-serif"
  },
  "Bai Jamjuree": {
    "link": "https://fonts.googleapis.com/css?family=Bai+Jamjuree:ital,wght@0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Bai Jamjuree', sans-serif"
  },
  "Lusitana": {
    "link": "https://fonts.googleapis.com/css?family=Lusitana:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Lusitana', sans-serif"
  },
  "Mr Dafoe": {
    "link": "https://fonts.googleapis.com/css?family=Mr+Dafoe:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mr Dafoe', sans-serif"
  },
  "Shippori Mincho": {
    "link": "https://fonts.googleapis.com/css?family=Shippori+Mincho:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Shippori Mincho', sans-serif"
  },
  "Cabin Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Cabin+Condensed:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Cabin Condensed', sans-serif"
  },
  "Alef": {
    "link": "https://fonts.googleapis.com/css?family=Alef:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Alef', sans-serif"
  },
  "Monda": {
    "link": "https://fonts.googleapis.com/css?family=Monda:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Monda', sans-serif"
  },
  "Pragati Narrow": {
    "link": "https://fonts.googleapis.com/css?family=Pragati+Narrow:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Pragati Narrow', sans-serif"
  },
  "Anonymous Pro": {
    "link": "https://fonts.googleapis.com/css?family=Anonymous+Pro:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Anonymous Pro', sans-serif"
  },
  "Ruda": {
    "link": "https://fonts.googleapis.com/css?family=Ruda:wght@0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Ruda', sans-serif"
  },
  "Playball": {
    "link": "https://fonts.googleapis.com/css?family=Playball:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Playball', sans-serif"
  },
  "Sriracha": {
    "link": "https://fonts.googleapis.com/css?family=Sriracha:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sriracha', sans-serif"
  },
  "Reenie Beanie": {
    "link": "https://fonts.googleapis.com/css?family=Reenie+Beanie:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Reenie Beanie', sans-serif"
  },
  "Hammersmith One": {
    "link": "https://fonts.googleapis.com/css?family=Hammersmith+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Hammersmith One', sans-serif"
  },
  "Mada": {
    "link": "https://fonts.googleapis.com/css?family=Mada:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Mada', sans-serif"
  },
  "Khula": {
    "link": "https://fonts.googleapis.com/css?family=Khula:wght@0,300;0,400;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Khula', sans-serif"
  },
  "Nanum Pen Script": {
    "link": "https://fonts.googleapis.com/css?family=Nanum+Pen+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Nanum Pen Script', sans-serif"
  },
  "Castoro": {
    "link": "https://fonts.googleapis.com/css?family=Castoro:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Castoro', sans-serif"
  },
  "Julius Sans One": {
    "link": "https://fonts.googleapis.com/css?family=Julius+Sans+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Julius Sans One', sans-serif"
  },
  "Mandali": {
    "link": "https://fonts.googleapis.com/css?family=Mandali:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mandali', sans-serif"
  },
  "Sorts Mill Goudy": {
    "link": "https://fonts.googleapis.com/css?family=Sorts+Mill+Goudy:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Sorts Mill Goudy', sans-serif"
  },
  "Jaldi": {
    "link": "https://fonts.googleapis.com/css?family=Jaldi:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Jaldi', sans-serif"
  },
  "Rock Salt": {
    "link": "https://fonts.googleapis.com/css?family=Rock+Salt:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rock Salt', sans-serif"
  },
  "Atkinson Hyperlegible": {
    "link": "https://fonts.googleapis.com/css?family=Atkinson+Hyperlegible:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Atkinson Hyperlegible', sans-serif"
  },
  "Geologica": {
    "link": "https://fonts.googleapis.com/css?family=Geologica:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Geologica', sans-serif"
  },
  "Armata": {
    "link": "https://fonts.googleapis.com/css?family=Armata:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Armata', sans-serif"
  },
  "Gilda Display": {
    "link": "https://fonts.googleapis.com/css?family=Gilda+Display:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gilda Display', sans-serif"
  },
  "BenchNine": {
    "link": "https://fonts.googleapis.com/css?family=BenchNine:wght@0,300;0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'BenchNine', sans-serif"
  },
  "Koulen": {
    "link": "https://fonts.googleapis.com/css?family=Koulen:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Koulen', sans-serif"
  },
  "Sarala": {
    "link": "https://fonts.googleapis.com/css?family=Sarala:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Sarala', sans-serif"
  },
  "Alexandria": {
    "link": "https://fonts.googleapis.com/css?family=Alexandria:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Alexandria', sans-serif"
  },
  "Nothing You Could Do": {
    "link": "https://fonts.googleapis.com/css?family=Nothing+You+Could+Do:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Nothing You Could Do', sans-serif"
  },
  "Niramit": {
    "link": "https://fonts.googleapis.com/css?family=Niramit:ital,wght@0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Niramit', sans-serif"
  },
  "Londrina Solid": {
    "link": "https://fonts.googleapis.com/css?family=Londrina+Solid:wght@0,100;0,300;0,400;0,900&subset=latin&display=swap",
    "fontFamily": "'Londrina Solid', sans-serif"
  },
  "Share Tech Mono": {
    "link": "https://fonts.googleapis.com/css?family=Share+Tech+Mono:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Share Tech Mono', sans-serif"
  },
  "Noto Sans Tamil": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Tamil:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Tamil', sans-serif"
  },
  "Rufina": {
    "link": "https://fonts.googleapis.com/css?family=Rufina:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Rufina', sans-serif"
  },
  "Jura": {
    "link": "https://fonts.googleapis.com/css?family=Jura:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Jura', sans-serif"
  },
  "Libre Bodoni": {
    "link": "https://fonts.googleapis.com/css?family=Libre+Bodoni:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Libre Bodoni', sans-serif"
  },
  "Pontano Sans": {
    "link": "https://fonts.googleapis.com/css?family=Pontano+Sans:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Pontano Sans', sans-serif"
  },
  "Italianno": {
    "link": "https://fonts.googleapis.com/css?family=Italianno:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Italianno', sans-serif"
  },
  "Six Caps": {
    "link": "https://fonts.googleapis.com/css?family=Six+Caps:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Six Caps', sans-serif"
  },
  "Martel Sans": {
    "link": "https://fonts.googleapis.com/css?family=Martel+Sans:wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Martel Sans', sans-serif"
  },
  "Newsreader": {
    "link": "https://fonts.googleapis.com/css?family=Newsreader:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,200;1,300;1,400;1,500;1,600;1,700;1,800&subset=latin&display=swap",
    "fontFamily": "'Newsreader', sans-serif"
  },
  "Noto Serif Bengali": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Bengali:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Bengali', sans-serif"
  },
  "PT Serif Caption": {
    "link": "https://fonts.googleapis.com/css?family=PT+Serif+Caption:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'PT Serif Caption', sans-serif"
  },
  "Holtwood One SC": {
    "link": "https://fonts.googleapis.com/css?family=Holtwood+One+SC:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Holtwood One SC', sans-serif"
  },
  "League Gothic": {
    "link": "https://fonts.googleapis.com/css?family=League+Gothic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'League Gothic', sans-serif"
  },
  "Oxanium": {
    "link": "https://fonts.googleapis.com/css?family=Oxanium:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Oxanium', sans-serif"
  },
  "Damion": {
    "link": "https://fonts.googleapis.com/css?family=Damion:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Damion', sans-serif"
  },
  "Quantico": {
    "link": "https://fonts.googleapis.com/css?family=Quantico:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Quantico', sans-serif"
  },
  "Kurale": {
    "link": "https://fonts.googleapis.com/css?family=Kurale:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kurale', sans-serif"
  },
  "Andika": {
    "link": "https://fonts.googleapis.com/css?family=Andika:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Andika', sans-serif"
  },
  "Amita": {
    "link": "https://fonts.googleapis.com/css?family=Amita:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Amita', sans-serif"
  },
  "Reem Kufi": {
    "link": "https://fonts.googleapis.com/css?family=Reem+Kufi:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Reem Kufi', sans-serif"
  },
  "Actor": {
    "link": "https://fonts.googleapis.com/css?family=Actor:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Actor', sans-serif"
  },
  "Pinyon Script": {
    "link": "https://fonts.googleapis.com/css?family=Pinyon+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Pinyon Script', sans-serif"
  },
  "Electrolize": {
    "link": "https://fonts.googleapis.com/css?family=Electrolize:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Electrolize', sans-serif"
  },
  "Sansita": {
    "link": "https://fonts.googleapis.com/css?family=Sansita:ital,wght@0,400;1,400;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Sansita', sans-serif"
  },
  "Fira Code": {
    "link": "https://fonts.googleapis.com/css?family=Fira+Code:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Fira Code', sans-serif"
  },
  "Gochi Hand": {
    "link": "https://fonts.googleapis.com/css?family=Gochi+Hand:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gochi Hand', sans-serif"
  },
  "Economica": {
    "link": "https://fonts.googleapis.com/css?family=Economica:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Economica', sans-serif"
  },
  "Cutive Mono": {
    "link": "https://fonts.googleapis.com/css?family=Cutive+Mono:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Cutive Mono', sans-serif"
  },
  "Saira Extra Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Saira+Extra+Condensed:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Saira Extra Condensed', sans-serif"
  },
  "BIZ UDPGothic": {
    "link": "https://fonts.googleapis.com/css?family=BIZ+UDPGothic:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'BIZ UDPGothic', sans-serif"
  },
  "VT323": {
    "link": "https://fonts.googleapis.com/css?family=VT323:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'VT323', sans-serif"
  },
  "Palanquin": {
    "link": "https://fonts.googleapis.com/css?family=Palanquin:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Palanquin', sans-serif"
  },
  "Caveat Brush": {
    "link": "https://fonts.googleapis.com/css?family=Caveat+Brush:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Caveat Brush', sans-serif"
  },
  "Noto Sans Hebrew": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Hebrew:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Hebrew', sans-serif"
  },
  "Hind Guntur": {
    "link": "https://fonts.googleapis.com/css?family=Hind+Guntur:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Hind Guntur', sans-serif"
  },
  "Noto Sans Malayalam": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Malayalam:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Malayalam', sans-serif"
  },
  "Ramabhadra": {
    "link": "https://fonts.googleapis.com/css?family=Ramabhadra:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ramabhadra', sans-serif"
  },
  "Encode Sans Expanded": {
    "link": "https://fonts.googleapis.com/css?family=Encode+Sans+Expanded:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Encode Sans Expanded', sans-serif"
  },
  "Calistoga": {
    "link": "https://fonts.googleapis.com/css?family=Calistoga:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Calistoga', sans-serif"
  },
  "Changa One": {
    "link": "https://fonts.googleapis.com/css?family=Changa+One:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Changa One', sans-serif"
  },
  "Rammetto One": {
    "link": "https://fonts.googleapis.com/css?family=Rammetto+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rammetto One', sans-serif"
  },
  "Covered By Your Grace": {
    "link": "https://fonts.googleapis.com/css?family=Covered+By+Your+Grace:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Covered By Your Grace', sans-serif"
  },
  "Hanken Grotesk": {
    "link": "https://fonts.googleapis.com/css?family=Hanken+Grotesk:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Hanken Grotesk', sans-serif"
  },
  "Days One": {
    "link": "https://fonts.googleapis.com/css?family=Days+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Days One', sans-serif"
  },
  "Karma": {
    "link": "https://fonts.googleapis.com/css?family=Karma:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Karma', sans-serif"
  },
  "Playfair": {
    "link": "https://fonts.googleapis.com/css?family=Playfair:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Playfair', sans-serif"
  },
  "Basic": {
    "link": "https://fonts.googleapis.com/css?family=Basic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Basic', sans-serif"
  },
  "Berkshire Swash": {
    "link": "https://fonts.googleapis.com/css?family=Berkshire+Swash:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Berkshire Swash', sans-serif"
  },
  "Big Shoulders Display": {
    "link": "https://fonts.googleapis.com/css?family=Big+Shoulders+Display:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Big Shoulders Display', sans-serif"
  },
  "Nova Square": {
    "link": "https://fonts.googleapis.com/css?family=Nova+Square:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Nova Square', sans-serif"
  },
  "Sofia Sans Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Sofia+Sans+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Sofia Sans Condensed', sans-serif"
  },
  "Leckerli One": {
    "link": "https://fonts.googleapis.com/css?family=Leckerli+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Leckerli One', sans-serif"
  },
  "Trocchi": {
    "link": "https://fonts.googleapis.com/css?family=Trocchi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Trocchi', sans-serif"
  },
  "Short Stack": {
    "link": "https://fonts.googleapis.com/css?family=Short+Stack:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Short Stack', sans-serif"
  },
  "Cinzel Decorative": {
    "link": "https://fonts.googleapis.com/css?family=Cinzel+Decorative:wght@0,400;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Cinzel Decorative', sans-serif"
  },
  "Black Han Sans": {
    "link": "https://fonts.googleapis.com/css?family=Black+Han+Sans:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Black Han Sans', sans-serif"
  },
  "Lateef": {
    "link": "https://fonts.googleapis.com/css?family=Lateef:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Lateef', sans-serif"
  },
  "Sintony": {
    "link": "https://fonts.googleapis.com/css?family=Sintony:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Sintony', sans-serif"
  },
  "Racing Sans One": {
    "link": "https://fonts.googleapis.com/css?family=Racing+Sans+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Racing Sans One', sans-serif"
  },
  "Shrikhand": {
    "link": "https://fonts.googleapis.com/css?family=Shrikhand:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Shrikhand', sans-serif"
  },
  "Yrsa": {
    "link": "https://fonts.googleapis.com/css?family=Yrsa:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Yrsa', sans-serif"
  },
  "Candal": {
    "link": "https://fonts.googleapis.com/css?family=Candal:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Candal', sans-serif"
  },
  "Lemonada": {
    "link": "https://fonts.googleapis.com/css?family=Lemonada:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Lemonada', sans-serif"
  },
  "Averia Serif Libre": {
    "link": "https://fonts.googleapis.com/css?family=Averia+Serif+Libre:ital,wght@0,300;1,300;0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Averia Serif Libre', sans-serif"
  },
  "Glegoo": {
    "link": "https://fonts.googleapis.com/css?family=Glegoo:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Glegoo', sans-serif"
  },
  "Quintessential": {
    "link": "https://fonts.googleapis.com/css?family=Quintessential:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Quintessential', sans-serif"
  },
  "Mrs Saint Delafield": {
    "link": "https://fonts.googleapis.com/css?family=Mrs+Saint+Delafield:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mrs Saint Delafield', sans-serif"
  },
  "Kreon": {
    "link": "https://fonts.googleapis.com/css?family=Kreon:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Kreon', sans-serif"
  },
  "Alatsi": {
    "link": "https://fonts.googleapis.com/css?family=Alatsi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Alatsi', sans-serif"
  },
  "Cabin Sketch": {
    "link": "https://fonts.googleapis.com/css?family=Cabin+Sketch:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Cabin Sketch', sans-serif"
  },
  "Balsamiq Sans": {
    "link": "https://fonts.googleapis.com/css?family=Balsamiq+Sans:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Balsamiq Sans', sans-serif"
  },
  "Aclonica": {
    "link": "https://fonts.googleapis.com/css?family=Aclonica:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Aclonica', sans-serif"
  },
  "Vazirmatn": {
    "link": "https://fonts.googleapis.com/css?family=Vazirmatn:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Vazirmatn', sans-serif"
  },
  "Seaweed Script": {
    "link": "https://fonts.googleapis.com/css?family=Seaweed+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Seaweed Script', sans-serif"
  },
  "Charm": {
    "link": "https://fonts.googleapis.com/css?family=Charm:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Charm', sans-serif"
  },
  "Antic": {
    "link": "https://fonts.googleapis.com/css?family=Antic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Antic', sans-serif"
  },
  "Cormorant Infant": {
    "link": "https://fonts.googleapis.com/css?family=Cormorant+Infant:ital,wght@0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Cormorant Infant', sans-serif"
  },
  "Golos Text": {
    "link": "https://fonts.googleapis.com/css?family=Golos+Text:wght@0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Golos Text', sans-serif"
  },
  "Laila": {
    "link": "https://fonts.googleapis.com/css?family=Laila:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Laila', sans-serif"
  },
  "Chewy": {
    "link": "https://fonts.googleapis.com/css?family=Chewy:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Chewy', sans-serif"
  },
  "Rubik Moonrocks": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Moonrocks:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Moonrocks', sans-serif"
  },
  "Mali": {
    "link": "https://fonts.googleapis.com/css?family=Mali:ital,wght@0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Mali', sans-serif"
  },
  "Boogaloo": {
    "link": "https://fonts.googleapis.com/css?family=Boogaloo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Boogaloo', sans-serif"
  },
  "Coda": {
    "link": "https://fonts.googleapis.com/css?family=Coda:wght@0,400;0,800&subset=latin&display=swap",
    "fontFamily": "'Coda', sans-serif"
  },
  "Syncopate": {
    "link": "https://fonts.googleapis.com/css?family=Syncopate:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Syncopate', sans-serif"
  },
  "Shadows Into Light Two": {
    "link": "https://fonts.googleapis.com/css?family=Shadows+Into+Light+Two:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Shadows Into Light Two', sans-serif"
  },
  "Just Another Hand": {
    "link": "https://fonts.googleapis.com/css?family=Just+Another+Hand:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Just Another Hand', sans-serif"
  },
  "Sofia Sans": {
    "link": "https://fonts.googleapis.com/css?family=Sofia+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Sofia Sans', sans-serif"
  },
  "Arapey": {
    "link": "https://fonts.googleapis.com/css?family=Arapey:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Arapey', sans-serif"
  },
  "Lustria": {
    "link": "https://fonts.googleapis.com/css?family=Lustria:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Lustria', sans-serif"
  },
  "Julee": {
    "link": "https://fonts.googleapis.com/css?family=Julee:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Julee', sans-serif"
  },
  "Calligraffitti": {
    "link": "https://fonts.googleapis.com/css?family=Calligraffitti:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Calligraffitti', sans-serif"
  },
  "Fredericka the Great": {
    "link": "https://fonts.googleapis.com/css?family=Fredericka+the+Great:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Fredericka the Great', sans-serif"
  },
  "Nanum Brush Script": {
    "link": "https://fonts.googleapis.com/css?family=Nanum+Brush+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Nanum Brush Script', sans-serif"
  },
  "Cantata One": {
    "link": "https://fonts.googleapis.com/css?family=Cantata+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Cantata One', sans-serif"
  },
  "Darker Grotesque": {
    "link": "https://fonts.googleapis.com/css?family=Darker+Grotesque:wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Darker Grotesque', sans-serif"
  },
  "Radio Canada": {
    "link": "https://fonts.googleapis.com/css?family=Radio+Canada:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Radio Canada', sans-serif"
  },
  "Michroma": {
    "link": "https://fonts.googleapis.com/css?family=Michroma:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Michroma', sans-serif"
  },
  "Kiwi Maru": {
    "link": "https://fonts.googleapis.com/css?family=Kiwi+Maru:wght@0,300;0,400;0,500&subset=latin&display=swap",
    "fontFamily": "'Kiwi Maru', sans-serif"
  },
  "Anuphan": {
    "link": "https://fonts.googleapis.com/css?family=Anuphan:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Anuphan', sans-serif"
  },
  "Athiti": {
    "link": "https://fonts.googleapis.com/css?family=Athiti:wght@0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Athiti', sans-serif"
  },
  "Young Serif": {
    "link": "https://fonts.googleapis.com/css?family=Young+Serif:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Young Serif', sans-serif"
  },
  "Dela Gothic One": {
    "link": "https://fonts.googleapis.com/css?family=Dela+Gothic+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Dela Gothic One', sans-serif"
  },
  "Belleza": {
    "link": "https://fonts.googleapis.com/css?family=Belleza:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Belleza', sans-serif"
  },
  "Scada": {
    "link": "https://fonts.googleapis.com/css?family=Scada:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Scada', sans-serif"
  },
  "Aldrich": {
    "link": "https://fonts.googleapis.com/css?family=Aldrich:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Aldrich', sans-serif"
  },
  "Zen Old Mincho": {
    "link": "https://fonts.googleapis.com/css?family=Zen+Old+Mincho:wght@0,400;0,500;0,600;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Zen Old Mincho', sans-serif"
  },
  "Herr Von Muellerhoff": {
    "link": "https://fonts.googleapis.com/css?family=Herr+Von+Muellerhoff:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Herr Von Muellerhoff', sans-serif"
  },
  "Telex": {
    "link": "https://fonts.googleapis.com/css?family=Telex:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Telex', sans-serif"
  },
  "Baloo Bhaijaan 2": {
    "link": "https://fonts.googleapis.com/css?family=Baloo+Bhaijaan+2:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Baloo Bhaijaan 2', sans-serif"
  },
  "La Belle Aurore": {
    "link": "https://fonts.googleapis.com/css?family=La+Belle+Aurore:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'La Belle Aurore', sans-serif"
  },
  "Graduate": {
    "link": "https://fonts.googleapis.com/css?family=Graduate:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Graduate', sans-serif"
  },
  "Rozha One": {
    "link": "https://fonts.googleapis.com/css?family=Rozha+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rozha One', sans-serif"
  },
  "Delius": {
    "link": "https://fonts.googleapis.com/css?family=Delius:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Delius', sans-serif"
  },
  "Noto Serif Display": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Display:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Display', sans-serif"
  },
  "Allerta Stencil": {
    "link": "https://fonts.googleapis.com/css?family=Allerta+Stencil:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Allerta Stencil', sans-serif"
  },
  "Arizonia": {
    "link": "https://fonts.googleapis.com/css?family=Arizonia:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Arizonia', sans-serif"
  },
  "Bevan": {
    "link": "https://fonts.googleapis.com/css?family=Bevan:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Bevan', sans-serif"
  },
  "Arbutus Slab": {
    "link": "https://fonts.googleapis.com/css?family=Arbutus+Slab:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Arbutus Slab', sans-serif"
  },
  "Brygada 1918": {
    "link": "https://fonts.googleapis.com/css?family=Brygada+1918:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Brygada 1918', sans-serif"
  },
  "Overpass Mono": {
    "link": "https://fonts.googleapis.com/css?family=Overpass+Mono:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Overpass Mono', sans-serif"
  },
  "Squada One": {
    "link": "https://fonts.googleapis.com/css?family=Squada+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Squada One', sans-serif"
  },
  "K2D": {
    "link": "https://fonts.googleapis.com/css?family=K2D:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800&subset=latin&display=swap",
    "fontFamily": "'K2D', sans-serif"
  },
  "Suez One": {
    "link": "https://fonts.googleapis.com/css?family=Suez+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Suez One', sans-serif"
  },
  "Ephesis": {
    "link": "https://fonts.googleapis.com/css?family=Ephesis:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ephesis', sans-serif"
  },
  "BioRhyme": {
    "link": "https://fonts.googleapis.com/css?family=BioRhyme:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'BioRhyme', sans-serif"
  },
  "Pattaya": {
    "link": "https://fonts.googleapis.com/css?family=Pattaya:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Pattaya', sans-serif"
  },
  "Alumni Sans": {
    "link": "https://fonts.googleapis.com/css?family=Alumni+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Alumni Sans', sans-serif"
  },
  "Annie Use Your Telescope": {
    "link": "https://fonts.googleapis.com/css?family=Annie+Use+Your+Telescope:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Annie Use Your Telescope', sans-serif"
  },
  "Rancho": {
    "link": "https://fonts.googleapis.com/css?family=Rancho:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rancho', sans-serif"
  },
  "Kristi": {
    "link": "https://fonts.googleapis.com/css?family=Kristi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kristi', sans-serif"
  },
  "Corben": {
    "link": "https://fonts.googleapis.com/css?family=Corben:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Corben', sans-serif"
  },
  "Pathway Extreme": {
    "link": "https://fonts.googleapis.com/css?family=Pathway+Extreme:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Pathway Extreme', sans-serif"
  },
  "Krona One": {
    "link": "https://fonts.googleapis.com/css?family=Krona+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Krona One', sans-serif"
  },
  "Jua": {
    "link": "https://fonts.googleapis.com/css?family=Jua:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Jua', sans-serif"
  },
  "Nobile": {
    "link": "https://fonts.googleapis.com/css?family=Nobile:ital,wght@0,400;1,400;0,500;1,500;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Nobile', sans-serif"
  },
  "Maitree": {
    "link": "https://fonts.googleapis.com/css?family=Maitree:wght@0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Maitree', sans-serif"
  },
  "Coming Soon": {
    "link": "https://fonts.googleapis.com/css?family=Coming+Soon:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Coming Soon', sans-serif"
  },
  "Oranienbaum": {
    "link": "https://fonts.googleapis.com/css?family=Oranienbaum:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Oranienbaum', sans-serif"
  },
  "Grandstander": {
    "link": "https://fonts.googleapis.com/css?family=Grandstander:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Grandstander', sans-serif"
  },
  "Podkova": {
    "link": "https://fonts.googleapis.com/css?family=Podkova:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Podkova', sans-serif"
  },
  "Limelight": {
    "link": "https://fonts.googleapis.com/css?family=Limelight:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Limelight', sans-serif"
  },
  "Livvic": {
    "link": "https://fonts.googleapis.com/css?family=Livvic:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Livvic', sans-serif"
  },
  "B612 Mono": {
    "link": "https://fonts.googleapis.com/css?family=B612+Mono:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'B612 Mono', sans-serif"
  },
  "Marcellus SC": {
    "link": "https://fonts.googleapis.com/css?family=Marcellus+SC:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Marcellus SC', sans-serif"
  },
  "Ibarra Real Nova": {
    "link": "https://fonts.googleapis.com/css?family=Ibarra+Real+Nova:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Ibarra Real Nova', sans-serif"
  },
  "Wallpoet": {
    "link": "https://fonts.googleapis.com/css?family=Wallpoet:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Wallpoet', sans-serif"
  },
  "Palanquin Dark": {
    "link": "https://fonts.googleapis.com/css?family=Palanquin+Dark:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Palanquin Dark', sans-serif"
  },
  "Caudex": {
    "link": "https://fonts.googleapis.com/css?family=Caudex:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Caudex', sans-serif"
  },
  "Cedarville Cursive": {
    "link": "https://fonts.googleapis.com/css?family=Cedarville+Cursive:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Cedarville Cursive', sans-serif"
  },
  "Monsieur La Doulaise": {
    "link": "https://fonts.googleapis.com/css?family=Monsieur+La+Doulaise:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Monsieur La Doulaise', sans-serif"
  },
  "Georama": {
    "link": "https://fonts.googleapis.com/css?family=Georama:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Georama', sans-serif"
  },
  "Enriqueta": {
    "link": "https://fonts.googleapis.com/css?family=Enriqueta:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Enriqueta', sans-serif"
  },
  "Knewave": {
    "link": "https://fonts.googleapis.com/css?family=Knewave:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Knewave', sans-serif"
  },
  "Rye": {
    "link": "https://fonts.googleapis.com/css?family=Rye:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rye', sans-serif"
  },
  "Marmelad": {
    "link": "https://fonts.googleapis.com/css?family=Marmelad:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Marmelad', sans-serif"
  },
  "Alike": {
    "link": "https://fonts.googleapis.com/css?family=Alike:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Alike', sans-serif"
  },
  "Contrail One": {
    "link": "https://fonts.googleapis.com/css?family=Contrail+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Contrail One', sans-serif"
  },
  "Do Hyeon": {
    "link": "https://fonts.googleapis.com/css?family=Do+Hyeon:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Do Hyeon', sans-serif"
  },
  "Klee One": {
    "link": "https://fonts.googleapis.com/css?family=Klee+One:wght@0,400;0,600&subset=latin&display=swap",
    "fontFamily": "'Klee One', sans-serif"
  },
  "Markazi Text": {
    "link": "https://fonts.googleapis.com/css?family=Markazi+Text:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Markazi Text', sans-serif"
  },
  "Nixie One": {
    "link": "https://fonts.googleapis.com/css?family=Nixie+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Nixie One', sans-serif"
  },
  "Allerta": {
    "link": "https://fonts.googleapis.com/css?family=Allerta:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Allerta', sans-serif"
  },
  "Bowlby One": {
    "link": "https://fonts.googleapis.com/css?family=Bowlby+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bowlby One', sans-serif"
  },
  "Allison": {
    "link": "https://fonts.googleapis.com/css?family=Allison:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Allison', sans-serif"
  },
  "Alegreya SC": {
    "link": "https://fonts.googleapis.com/css?family=Alegreya+SC:ital,wght@0,400;1,400;0,500;1,500;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Alegreya SC', sans-serif"
  },
  "Averia Libre": {
    "link": "https://fonts.googleapis.com/css?family=Averia+Libre:ital,wght@0,300;1,300;0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Averia Libre', sans-serif"
  },
  "M PLUS 1": {
    "link": "https://fonts.googleapis.com/css?family=M+PLUS+1:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'M PLUS 1', sans-serif"
  },
  "Bowlby One SC": {
    "link": "https://fonts.googleapis.com/css?family=Bowlby+One+SC:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bowlby One SC', sans-serif"
  },
  "Akshar": {
    "link": "https://fonts.googleapis.com/css?family=Akshar:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Akshar', sans-serif"
  },
  "Overlock": {
    "link": "https://fonts.googleapis.com/css?family=Overlock:ital,wght@0,400;1,400;0,700;1,700;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Overlock', sans-serif"
  },
  "Grand Hotel": {
    "link": "https://fonts.googleapis.com/css?family=Grand+Hotel:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Grand Hotel', sans-serif"
  },
  "Bellefair": {
    "link": "https://fonts.googleapis.com/css?family=Bellefair:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bellefair', sans-serif"
  },
  "Niconne": {
    "link": "https://fonts.googleapis.com/css?family=Niconne:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Niconne', sans-serif"
  },
  "Pirata One": {
    "link": "https://fonts.googleapis.com/css?family=Pirata+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Pirata One', sans-serif"
  },
  "Bubblegum Sans": {
    "link": "https://fonts.googleapis.com/css?family=Bubblegum+Sans:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bubblegum Sans', sans-serif"
  },
  "Salsa": {
    "link": "https://fonts.googleapis.com/css?family=Salsa:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Salsa', sans-serif"
  },
  "IBM Plex Sans KR": {
    "link": "https://fonts.googleapis.com/css?family=IBM+Plex+Sans+KR:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'IBM Plex Sans KR', sans-serif"
  },
  "Schoolbell": {
    "link": "https://fonts.googleapis.com/css?family=Schoolbell:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Schoolbell', sans-serif"
  },
  "IBM Plex Sans Thai": {
    "link": "https://fonts.googleapis.com/css?family=IBM+Plex+Sans+Thai:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'IBM Plex Sans Thai', sans-serif"
  },
  "Henny Penny": {
    "link": "https://fonts.googleapis.com/css?family=Henny+Penny:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Henny Penny', sans-serif"
  },
  "Biryani": {
    "link": "https://fonts.googleapis.com/css?family=Biryani:wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Biryani', sans-serif"
  },
  "Rambla": {
    "link": "https://fonts.googleapis.com/css?family=Rambla:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Rambla', sans-serif"
  },
  "Kameron": {
    "link": "https://fonts.googleapis.com/css?family=Kameron:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Kameron', sans-serif"
  },
  "UnifrakturMaguntia": {
    "link": "https://fonts.googleapis.com/css?family=UnifrakturMaguntia:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'UnifrakturMaguntia', sans-serif"
  },
  "Judson": {
    "link": "https://fonts.googleapis.com/css?family=Judson:ital,wght@0,400;1,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Judson', sans-serif"
  },
  "Baloo Da 2": {
    "link": "https://fonts.googleapis.com/css?family=Baloo+Da+2:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Baloo Da 2', sans-serif"
  },
  "Yesteryear": {
    "link": "https://fonts.googleapis.com/css?family=Yesteryear:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Yesteryear', sans-serif"
  },
  "Amiko": {
    "link": "https://fonts.googleapis.com/css?family=Amiko:wght@0,400;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Amiko', sans-serif"
  },
  "Irish Grover": {
    "link": "https://fonts.googleapis.com/css?family=Irish+Grover:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Irish Grover', sans-serif"
  },
  "Zen Antique": {
    "link": "https://fonts.googleapis.com/css?family=Zen+Antique:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Zen Antique', sans-serif"
  },
  "Big Shoulders Text": {
    "link": "https://fonts.googleapis.com/css?family=Big+Shoulders+Text:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Big Shoulders Text', sans-serif"
  },
  "Spectral SC": {
    "link": "https://fonts.googleapis.com/css?family=Spectral+SC:ital,wght@0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800&subset=latin&display=swap",
    "fontFamily": "'Spectral SC', sans-serif"
  },
  "Kosugi": {
    "link": "https://fonts.googleapis.com/css?family=Kosugi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kosugi', sans-serif"
  },
  "Encode Sans Semi Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Encode+Sans+Semi+Condensed:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Encode Sans Semi Condensed', sans-serif"
  },
  "Proza Libre": {
    "link": "https://fonts.googleapis.com/css?family=Proza+Libre:ital,wght@0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800&subset=latin&display=swap",
    "fontFamily": "'Proza Libre', sans-serif"
  },
  "Trirong": {
    "link": "https://fonts.googleapis.com/css?family=Trirong:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Trirong', sans-serif"
  },
  "NTR": {
    "link": "https://fonts.googleapis.com/css?family=NTR:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'NTR', sans-serif"
  },
  "Kufam": {
    "link": "https://fonts.googleapis.com/css?family=Kufam:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Kufam', sans-serif"
  },
  "Halant": {
    "link": "https://fonts.googleapis.com/css?family=Halant:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Halant', sans-serif"
  },
  "Mallanna": {
    "link": "https://fonts.googleapis.com/css?family=Mallanna:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mallanna', sans-serif"
  },
  "Petit Formal Script": {
    "link": "https://fonts.googleapis.com/css?family=Petit+Formal+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Petit Formal Script', sans-serif"
  },
  "Rochester": {
    "link": "https://fonts.googleapis.com/css?family=Rochester:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rochester', sans-serif"
  },
  "Chonburi": {
    "link": "https://fonts.googleapis.com/css?family=Chonburi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Chonburi', sans-serif"
  },
  "B612": {
    "link": "https://fonts.googleapis.com/css?family=B612:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'B612', sans-serif"
  },
  "Gurajada": {
    "link": "https://fonts.googleapis.com/css?family=Gurajada:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gurajada', sans-serif"
  },
  "Noto Nastaliq Urdu": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Nastaliq+Urdu:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Nastaliq Urdu', sans-serif"
  },
  "Spinnaker": {
    "link": "https://fonts.googleapis.com/css?family=Spinnaker:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Spinnaker', sans-serif"
  },
  "Ovo": {
    "link": "https://fonts.googleapis.com/css?family=Ovo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ovo', sans-serif"
  },
  "Shippori Mincho B1": {
    "link": "https://fonts.googleapis.com/css?family=Shippori+Mincho+B1:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Shippori Mincho B1', sans-serif"
  },
  "David Libre": {
    "link": "https://fonts.googleapis.com/css?family=David+Libre:wght@0,400;0,500;0,700&subset=latin&display=swap",
    "fontFamily": "'David Libre', sans-serif"
  },
  "Aladin": {
    "link": "https://fonts.googleapis.com/css?family=Aladin:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Aladin', sans-serif"
  },
  "Coustard": {
    "link": "https://fonts.googleapis.com/css?family=Coustard:wght@0,400;0,900&subset=latin&display=swap",
    "fontFamily": "'Coustard', sans-serif"
  },
  "Average Sans": {
    "link": "https://fonts.googleapis.com/css?family=Average+Sans:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Average Sans', sans-serif"
  },
  "Miriam Libre": {
    "link": "https://fonts.googleapis.com/css?family=Miriam+Libre:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Miriam Libre', sans-serif"
  },
  "Magra": {
    "link": "https://fonts.googleapis.com/css?family=Magra:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Magra', sans-serif"
  },
  "Manjari": {
    "link": "https://fonts.googleapis.com/css?family=Manjari:wght@0,100;0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Manjari', sans-serif"
  },
  "Bungee Inline": {
    "link": "https://fonts.googleapis.com/css?family=Bungee+Inline:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bungee Inline', sans-serif"
  },
  "Qwigley": {
    "link": "https://fonts.googleapis.com/css?family=Qwigley:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Qwigley', sans-serif"
  },
  "Metrophobic": {
    "link": "https://fonts.googleapis.com/css?family=Metrophobic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Metrophobic', sans-serif"
  },
  "Kelly Slab": {
    "link": "https://fonts.googleapis.com/css?family=Kelly+Slab:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kelly Slab', sans-serif"
  },
  "Fanwood Text": {
    "link": "https://fonts.googleapis.com/css?family=Fanwood+Text:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Fanwood Text', sans-serif"
  },
  "Stardos Stencil": {
    "link": "https://fonts.googleapis.com/css?family=Stardos+Stencil:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Stardos Stencil', sans-serif"
  },
  "Instrument Sans": {
    "link": "https://fonts.googleapis.com/css?family=Instrument+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Instrument Sans', sans-serif"
  },
  "Love Ya Like A Sister": {
    "link": "https://fonts.googleapis.com/css?family=Love+Ya+Like+A+Sister:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Love Ya Like A Sister', sans-serif"
  },
  "Jockey One": {
    "link": "https://fonts.googleapis.com/css?family=Jockey+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Jockey One', sans-serif"
  },
  "Dawning of a New Day": {
    "link": "https://fonts.googleapis.com/css?family=Dawning+of+a+New+Day:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Dawning of a New Day', sans-serif"
  },
  "Inria Serif": {
    "link": "https://fonts.googleapis.com/css?family=Inria+Serif:ital,wght@0,300;1,300;0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Inria Serif', sans-serif"
  },
  "Sigmar One": {
    "link": "https://fonts.googleapis.com/css?family=Sigmar+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sigmar One', sans-serif"
  },
  "Fjord One": {
    "link": "https://fonts.googleapis.com/css?family=Fjord+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Fjord One', sans-serif"
  },
  "Rosario": {
    "link": "https://fonts.googleapis.com/css?family=Rosario:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Rosario', sans-serif"
  },
  "Mina": {
    "link": "https://fonts.googleapis.com/css?family=Mina:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Mina', sans-serif"
  },
  "Waiting for the Sunrise": {
    "link": "https://fonts.googleapis.com/css?family=Waiting+for+the+Sunrise:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Waiting for the Sunrise', sans-serif"
  },
  "Katibeh": {
    "link": "https://fonts.googleapis.com/css?family=Katibeh:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Katibeh', sans-serif"
  },
  "Thasadith": {
    "link": "https://fonts.googleapis.com/css?family=Thasadith:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Thasadith', sans-serif"
  },
  "Croissant One": {
    "link": "https://fonts.googleapis.com/css?family=Croissant+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Croissant One', sans-serif"
  },
  "Goudy Bookletter 1911": {
    "link": "https://fonts.googleapis.com/css?family=Goudy+Bookletter+1911:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Goudy Bookletter 1911', sans-serif"
  },
  "Average": {
    "link": "https://fonts.googleapis.com/css?family=Average:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Average', sans-serif"
  },
  "Cormorant SC": {
    "link": "https://fonts.googleapis.com/css?family=Cormorant+SC:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Cormorant SC', sans-serif"
  },
  "McLaren": {
    "link": "https://fonts.googleapis.com/css?family=McLaren:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'McLaren', sans-serif"
  },
  "Fauna One": {
    "link": "https://fonts.googleapis.com/css?family=Fauna+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Fauna One', sans-serif"
  },
  "Grenze Gotisch": {
    "link": "https://fonts.googleapis.com/css?family=Grenze+Gotisch:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Grenze Gotisch', sans-serif"
  },
  "Rasa": {
    "link": "https://fonts.googleapis.com/css?family=Rasa:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Rasa', sans-serif"
  },
  "Fahkwang": {
    "link": "https://fonts.googleapis.com/css?family=Fahkwang:ital,wght@0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Fahkwang', sans-serif"
  },
  "Vollkorn SC": {
    "link": "https://fonts.googleapis.com/css?family=Vollkorn+SC:wght@0,400;0,600;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Vollkorn SC', sans-serif"
  },
  "Hanuman": {
    "link": "https://fonts.googleapis.com/css?family=Hanuman:wght@0,100;0,300;0,400;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Hanuman', sans-serif"
  },
  "Arya": {
    "link": "https://fonts.googleapis.com/css?family=Arya:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Arya', sans-serif"
  },
  "Montserrat Subrayada": {
    "link": "https://fonts.googleapis.com/css?family=Montserrat+Subrayada:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Montserrat Subrayada', sans-serif"
  },
  "Gabriela": {
    "link": "https://fonts.googleapis.com/css?family=Gabriela:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gabriela', sans-serif"
  },
  "Chelsea Market": {
    "link": "https://fonts.googleapis.com/css?family=Chelsea+Market:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Chelsea Market', sans-serif"
  },
  "Italiana": {
    "link": "https://fonts.googleapis.com/css?family=Italiana:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Italiana', sans-serif"
  },
  "Gloock": {
    "link": "https://fonts.googleapis.com/css?family=Gloock:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gloock', sans-serif"
  },
  "Jomhuria": {
    "link": "https://fonts.googleapis.com/css?family=Jomhuria:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Jomhuria', sans-serif"
  },
  "Chivo Mono": {
    "link": "https://fonts.googleapis.com/css?family=Chivo+Mono:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Chivo Mono', sans-serif"
  },
  "Andada Pro": {
    "link": "https://fonts.googleapis.com/css?family=Andada+Pro:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800&subset=latin&display=swap",
    "fontFamily": "'Andada Pro', sans-serif"
  },
  "Aboreto": {
    "link": "https://fonts.googleapis.com/css?family=Aboreto:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Aboreto', sans-serif"
  },
  "Sniglet": {
    "link": "https://fonts.googleapis.com/css?family=Sniglet:wght@0,400;0,800&subset=latin&display=swap",
    "fontFamily": "'Sniglet', sans-serif"
  },
  "Carrois Gothic": {
    "link": "https://fonts.googleapis.com/css?family=Carrois+Gothic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Carrois Gothic', sans-serif"
  },
  "Norican": {
    "link": "https://fonts.googleapis.com/css?family=Norican:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Norican', sans-serif"
  },
  "Glory": {
    "link": "https://fonts.googleapis.com/css?family=Glory:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&subset=latin&display=swap",
    "fontFamily": "'Glory', sans-serif"
  },
  "Cambay": {
    "link": "https://fonts.googleapis.com/css?family=Cambay:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Cambay', sans-serif"
  },
  "Mansalva": {
    "link": "https://fonts.googleapis.com/css?family=Mansalva:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mansalva', sans-serif"
  },
  "Meddon": {
    "link": "https://fonts.googleapis.com/css?family=Meddon:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Meddon', sans-serif"
  },
  "Elsie": {
    "link": "https://fonts.googleapis.com/css?family=Elsie:wght@0,400;0,900&subset=latin&display=swap",
    "fontFamily": "'Elsie', sans-serif"
  },
  "Noto Sans Lao Looped": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Lao+Looped:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Lao Looped', sans-serif"
  },
  "Amethysta": {
    "link": "https://fonts.googleapis.com/css?family=Amethysta:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Amethysta', sans-serif"
  },
  "Over the Rainbow": {
    "link": "https://fonts.googleapis.com/css?family=Over+the+Rainbow:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Over the Rainbow', sans-serif"
  },
  "Schibsted Grotesk": {
    "link": "https://fonts.googleapis.com/css?family=Schibsted+Grotesk:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Schibsted Grotesk', sans-serif"
  },
  "Wix Madefor Text": {
    "link": "https://fonts.googleapis.com/css?family=Wix+Madefor+Text:ital,wght@0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800&subset=latin&display=swap",
    "fontFamily": "'Wix Madefor Text', sans-serif"
  },
  "Odibee Sans": {
    "link": "https://fonts.googleapis.com/css?family=Odibee+Sans:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Odibee Sans', sans-serif"
  },
  "Federo": {
    "link": "https://fonts.googleapis.com/css?family=Federo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Federo', sans-serif"
  },
  "Noto Sans NKo Unjoined": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+NKo+Unjoined:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans NKo Unjoined', sans-serif"
  },
  "Noto Sans Kannada": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Kannada:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Kannada', sans-serif"
  },
  "Bentham": {
    "link": "https://fonts.googleapis.com/css?family=Bentham:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bentham', sans-serif"
  },
  "Sofia Sans Extra Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Sofia+Sans+Extra+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Sofia Sans Extra Condensed', sans-serif"
  },
  "Capriola": {
    "link": "https://fonts.googleapis.com/css?family=Capriola:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Capriola', sans-serif"
  },
  "IM Fell English SC": {
    "link": "https://fonts.googleapis.com/css?family=IM+Fell+English+SC:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'IM Fell English SC', sans-serif"
  },
  "Cormorant Upright": {
    "link": "https://fonts.googleapis.com/css?family=Cormorant+Upright:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Cormorant Upright', sans-serif"
  },
  "Turret Road": {
    "link": "https://fonts.googleapis.com/css?family=Turret+Road:wght@0,200;0,300;0,400;0,500;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Turret Road', sans-serif"
  },
  "Ma Shan Zheng": {
    "link": "https://fonts.googleapis.com/css?family=Ma+Shan+Zheng:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ma Shan Zheng', sans-serif"
  },
  "Copse": {
    "link": "https://fonts.googleapis.com/css?family=Copse:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Copse', sans-serif"
  },
  "Tomorrow": {
    "link": "https://fonts.googleapis.com/css?family=Tomorrow:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Tomorrow', sans-serif"
  },
  "Style Script": {
    "link": "https://fonts.googleapis.com/css?family=Style+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Style Script', sans-serif"
  },
  "MuseoModerno": {
    "link": "https://fonts.googleapis.com/css?family=MuseoModerno:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'MuseoModerno', sans-serif"
  },
  "Zen Kaku Gothic Antique": {
    "link": "https://fonts.googleapis.com/css?family=Zen+Kaku+Gothic+Antique:wght@0,300;0,400;0,500;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Zen Kaku Gothic Antique', sans-serif"
  },
  "M PLUS 2": {
    "link": "https://fonts.googleapis.com/css?family=M+PLUS+2:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'M PLUS 2', sans-serif"
  },
  "Farro": {
    "link": "https://fonts.googleapis.com/css?family=Farro:wght@0,300;0,400;0,500;0,700&subset=latin&display=swap",
    "fontFamily": "'Farro', sans-serif"
  },
  "Poller One": {
    "link": "https://fonts.googleapis.com/css?family=Poller+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Poller One', sans-serif"
  },
  "Nova Mono": {
    "link": "https://fonts.googleapis.com/css?family=Nova+Mono:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Nova Mono', sans-serif"
  },
  "Oxygen Mono": {
    "link": "https://fonts.googleapis.com/css?family=Oxygen+Mono:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Oxygen Mono', sans-serif"
  },
  "Sevillana": {
    "link": "https://fonts.googleapis.com/css?family=Sevillana:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sevillana', sans-serif"
  },
  "Baloo Paaji 2": {
    "link": "https://fonts.googleapis.com/css?family=Baloo+Paaji+2:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Baloo Paaji 2', sans-serif"
  },
  "Kaisei Decol": {
    "link": "https://fonts.googleapis.com/css?family=Kaisei+Decol:wght@0,400;0,500;0,700&subset=latin&display=swap",
    "fontFamily": "'Kaisei Decol', sans-serif"
  },
  "Gabarito": {
    "link": "https://fonts.googleapis.com/css?family=Gabarito:wght@0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Gabarito', sans-serif"
  },
  "IM Fell English": {
    "link": "https://fonts.googleapis.com/css?family=IM+Fell+English:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'IM Fell English', sans-serif"
  },
  "Baloo Tamma 2": {
    "link": "https://fonts.googleapis.com/css?family=Baloo+Tamma+2:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Baloo Tamma 2', sans-serif"
  },
  "Molengo": {
    "link": "https://fonts.googleapis.com/css?family=Molengo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Molengo', sans-serif"
  },
  "Rakkas": {
    "link": "https://fonts.googleapis.com/css?family=Rakkas:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rakkas', sans-serif"
  },
  "Coiny": {
    "link": "https://fonts.googleapis.com/css?family=Coiny:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Coiny', sans-serif"
  },
  "Hepta Slab": {
    "link": "https://fonts.googleapis.com/css?family=Hepta+Slab:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Hepta Slab', sans-serif"
  },
  "Trykker": {
    "link": "https://fonts.googleapis.com/css?family=Trykker:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Trykker', sans-serif"
  },
  "Brawler": {
    "link": "https://fonts.googleapis.com/css?family=Brawler:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Brawler', sans-serif"
  },
  "Hahmlet": {
    "link": "https://fonts.googleapis.com/css?family=Hahmlet:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Hahmlet', sans-serif"
  },
  "Gravitas One": {
    "link": "https://fonts.googleapis.com/css?family=Gravitas+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gravitas One', sans-serif"
  },
  "Cambo": {
    "link": "https://fonts.googleapis.com/css?family=Cambo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Cambo', sans-serif"
  },
  "Share": {
    "link": "https://fonts.googleapis.com/css?family=Share:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Share', sans-serif"
  },
  "Aref Ruqaa": {
    "link": "https://fonts.googleapis.com/css?family=Aref+Ruqaa:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Aref Ruqaa', sans-serif"
  },
  "Della Respira": {
    "link": "https://fonts.googleapis.com/css?family=Della+Respira:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Della Respira', sans-serif"
  },
  "Inknut Antiqua": {
    "link": "https://fonts.googleapis.com/css?family=Inknut+Antiqua:wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Inknut Antiqua', sans-serif"
  },
  "Angkor": {
    "link": "https://fonts.googleapis.com/css?family=Angkor:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Angkor', sans-serif"
  },
  "Gluten": {
    "link": "https://fonts.googleapis.com/css?family=Gluten:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Gluten', sans-serif"
  },
  "Radley": {
    "link": "https://fonts.googleapis.com/css?family=Radley:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Radley', sans-serif"
  },
  "Antic Didone": {
    "link": "https://fonts.googleapis.com/css?family=Antic+Didone:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Antic Didone', sans-serif"
  },
  "Libre Barcode 39 Text": {
    "link": "https://fonts.googleapis.com/css?family=Libre+Barcode+39+Text:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Libre Barcode 39 Text', sans-serif"
  },
  "Noto Sans Gurmukhi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Gurmukhi:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Gurmukhi', sans-serif"
  },
  "Caladea": {
    "link": "https://fonts.googleapis.com/css?family=Caladea:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Caladea', sans-serif"
  },
  "Sue Ellen Francisco": {
    "link": "https://fonts.googleapis.com/css?family=Sue+Ellen+Francisco:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sue Ellen Francisco', sans-serif"
  },
  "Rouge Script": {
    "link": "https://fonts.googleapis.com/css?family=Rouge+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rouge Script', sans-serif"
  },
  "IM Fell DW Pica": {
    "link": "https://fonts.googleapis.com/css?family=IM+Fell+DW+Pica:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'IM Fell DW Pica', sans-serif"
  },
  "Kodchasan": {
    "link": "https://fonts.googleapis.com/css?family=Kodchasan:ital,wght@0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Kodchasan', sans-serif"
  },
  "Fondamento": {
    "link": "https://fonts.googleapis.com/css?family=Fondamento:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Fondamento', sans-serif"
  },
  "Marvel": {
    "link": "https://fonts.googleapis.com/css?family=Marvel:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Marvel', sans-serif"
  },
  "Germania One": {
    "link": "https://fonts.googleapis.com/css?family=Germania+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Germania One', sans-serif"
  },
  "Oooh Baby": {
    "link": "https://fonts.googleapis.com/css?family=Oooh+Baby:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Oooh Baby', sans-serif"
  },
  "Mouse Memoirs": {
    "link": "https://fonts.googleapis.com/css?family=Mouse+Memoirs:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mouse Memoirs', sans-serif"
  },
  "Noto Sans Armenian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Armenian:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Armenian', sans-serif"
  },
  "Quando": {
    "link": "https://fonts.googleapis.com/css?family=Quando:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Quando', sans-serif"
  },
  "Duru Sans": {
    "link": "https://fonts.googleapis.com/css?family=Duru+Sans:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Duru Sans', sans-serif"
  },
  "DotGothic16": {
    "link": "https://fonts.googleapis.com/css?family=DotGothic16:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'DotGothic16', sans-serif"
  },
  "Spline Sans": {
    "link": "https://fonts.googleapis.com/css?family=Spline+Sans:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Spline Sans', sans-serif"
  },
  "Lemon": {
    "link": "https://fonts.googleapis.com/css?family=Lemon:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Lemon', sans-serif"
  },
  "Bellota Text": {
    "link": "https://fonts.googleapis.com/css?family=Bellota+Text:ital,wght@0,300;1,300;0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Bellota Text', sans-serif"
  },
  "Xanh Mono": {
    "link": "https://fonts.googleapis.com/css?family=Xanh+Mono:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Xanh Mono', sans-serif"
  },
  "Mr De Haviland": {
    "link": "https://fonts.googleapis.com/css?family=Mr+De+Haviland:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mr De Haviland', sans-serif"
  },
  "RocknRoll One": {
    "link": "https://fonts.googleapis.com/css?family=RocknRoll+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'RocknRoll One', sans-serif"
  },
  "Sansita Swashed": {
    "link": "https://fonts.googleapis.com/css?family=Sansita+Swashed:wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Sansita Swashed', sans-serif"
  },
  "Baloo Thambi 2": {
    "link": "https://fonts.googleapis.com/css?family=Baloo+Thambi+2:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Baloo Thambi 2', sans-serif"
  },
  "Noto Sans Sinhala": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Sinhala:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Sinhala', sans-serif"
  },
  "Anek Malayalam": {
    "link": "https://fonts.googleapis.com/css?family=Anek+Malayalam:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Anek Malayalam', sans-serif"
  },
  "Tenali Ramakrishna": {
    "link": "https://fonts.googleapis.com/css?family=Tenali+Ramakrishna:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Tenali Ramakrishna', sans-serif"
  },
  "Inder": {
    "link": "https://fonts.googleapis.com/css?family=Inder:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Inder', sans-serif"
  },
  "Zen Kurenaido": {
    "link": "https://fonts.googleapis.com/css?family=Zen+Kurenaido:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Zen Kurenaido', sans-serif"
  },
  "Oregano": {
    "link": "https://fonts.googleapis.com/css?family=Oregano:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Oregano', sans-serif"
  },
  "Homenaje": {
    "link": "https://fonts.googleapis.com/css?family=Homenaje:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Homenaje', sans-serif"
  },
  "ZCOOL XiaoWei": {
    "link": "https://fonts.googleapis.com/css?family=ZCOOL+XiaoWei:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'ZCOOL XiaoWei', sans-serif"
  },
  "Azeret Mono": {
    "link": "https://fonts.googleapis.com/css?family=Azeret+Mono:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Azeret Mono', sans-serif"
  },
  "Besley": {
    "link": "https://fonts.googleapis.com/css?family=Besley:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Besley', sans-serif"
  },
  "Anaheim": {
    "link": "https://fonts.googleapis.com/css?family=Anaheim:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Anaheim', sans-serif"
  },
  "Kadwa": {
    "link": "https://fonts.googleapis.com/css?family=Kadwa:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Kadwa', sans-serif"
  },
  "Ms Madi": {
    "link": "https://fonts.googleapis.com/css?family=Ms+Madi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ms Madi', sans-serif"
  },
  "Gafata": {
    "link": "https://fonts.googleapis.com/css?family=Gafata:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gafata', sans-serif"
  },
  "Noto Sans Telugu": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Telugu:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Telugu', sans-serif"
  },
  "Headland One": {
    "link": "https://fonts.googleapis.com/css?family=Headland+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Headland One', sans-serif"
  },
  "Happy Monkey": {
    "link": "https://fonts.googleapis.com/css?family=Happy+Monkey:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Happy Monkey', sans-serif"
  },
  "Cutive": {
    "link": "https://fonts.googleapis.com/css?family=Cutive:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Cutive', sans-serif"
  },
  "Oleo Script Swash Caps": {
    "link": "https://fonts.googleapis.com/css?family=Oleo+Script+Swash+Caps:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Oleo Script Swash Caps', sans-serif"
  },
  "Onest": {
    "link": "https://fonts.googleapis.com/css?family=Onest:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Onest', sans-serif"
  },
  "Lekton": {
    "link": "https://fonts.googleapis.com/css?family=Lekton:ital,wght@0,400;1,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Lekton', sans-serif"
  },
  "Mukta Vaani": {
    "link": "https://fonts.googleapis.com/css?family=Mukta+Vaani:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Mukta Vaani', sans-serif"
  },
  "Skranji": {
    "link": "https://fonts.googleapis.com/css?family=Skranji:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Skranji', sans-serif"
  },
  "KoHo": {
    "link": "https://fonts.googleapis.com/css?family=KoHo:ital,wght@0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'KoHo', sans-serif"
  },
  "Alike Angular": {
    "link": "https://fonts.googleapis.com/css?family=Alike+Angular:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Alike Angular', sans-serif"
  },
  "Encode Sans Semi Expanded": {
    "link": "https://fonts.googleapis.com/css?family=Encode+Sans+Semi+Expanded:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Encode Sans Semi Expanded', sans-serif"
  },
  "Geo": {
    "link": "https://fonts.googleapis.com/css?family=Geo:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Geo', sans-serif"
  },
  "Mogra": {
    "link": "https://fonts.googleapis.com/css?family=Mogra:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mogra', sans-serif"
  },
  "Poly": {
    "link": "https://fonts.googleapis.com/css?family=Poly:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Poly', sans-serif"
  },
  "Mountains of Christmas": {
    "link": "https://fonts.googleapis.com/css?family=Mountains+of+Christmas:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Mountains of Christmas', sans-serif"
  },
  "Amarante": {
    "link": "https://fonts.googleapis.com/css?family=Amarante:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Amarante', sans-serif"
  },
  "Padauk": {
    "link": "https://fonts.googleapis.com/css?family=Padauk:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Padauk', sans-serif"
  },
  "Pompiere": {
    "link": "https://fonts.googleapis.com/css?family=Pompiere:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Pompiere', sans-serif"
  },
  "Sedgwick Ave": {
    "link": "https://fonts.googleapis.com/css?family=Sedgwick+Ave:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sedgwick Ave', sans-serif"
  },
  "Noto Sans Gujarati": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Gujarati:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Gujarati', sans-serif"
  },
  "Flamenco": {
    "link": "https://fonts.googleapis.com/css?family=Flamenco:wght@0,300;0,400&subset=latin&display=swap",
    "fontFamily": "'Flamenco', sans-serif"
  },
  "BIZ UDGothic": {
    "link": "https://fonts.googleapis.com/css?family=BIZ+UDGothic:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'BIZ UDGothic', sans-serif"
  },
  "Hurricane": {
    "link": "https://fonts.googleapis.com/css?family=Hurricane:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Hurricane', sans-serif"
  },
  "Bungee Shade": {
    "link": "https://fonts.googleapis.com/css?family=Bungee+Shade:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bungee Shade', sans-serif"
  },
  "Abyssinica SIL": {
    "link": "https://fonts.googleapis.com/css?family=Abyssinica+SIL:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Abyssinica SIL', sans-serif"
  },
  "Lexend Zetta": {
    "link": "https://fonts.googleapis.com/css?family=Lexend+Zetta:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Lexend Zetta', sans-serif"
  },
  "Lexend Exa": {
    "link": "https://fonts.googleapis.com/css?family=Lexend+Exa:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Lexend Exa', sans-serif"
  },
  "Ruslan Display": {
    "link": "https://fonts.googleapis.com/css?family=Ruslan+Display:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ruslan Display', sans-serif"
  },
  "IBM Plex Sans JP": {
    "link": "https://fonts.googleapis.com/css?family=IBM+Plex+Sans+JP:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'IBM Plex Sans JP', sans-serif"
  },
  "Give You Glory": {
    "link": "https://fonts.googleapis.com/css?family=Give+You+Glory:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Give You Glory', sans-serif"
  },
  "Meie Script": {
    "link": "https://fonts.googleapis.com/css?family=Meie+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Meie Script', sans-serif"
  },
  "Yusei Magic": {
    "link": "https://fonts.googleapis.com/css?family=Yusei+Magic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Yusei Magic', sans-serif"
  },
  "Aguafina Script": {
    "link": "https://fonts.googleapis.com/css?family=Aguafina+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Aguafina Script', sans-serif"
  },
  "Sunflower": {
    "link": "https://fonts.googleapis.com/css?family=Sunflower:wght@0,300;0,500;0,700&subset=latin&display=swap",
    "fontFamily": "'Sunflower', sans-serif"
  },
  "Supermercado One": {
    "link": "https://fonts.googleapis.com/css?family=Supermercado+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Supermercado One', sans-serif"
  },
  "Noto Serif Devanagari": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Devanagari:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Devanagari', sans-serif"
  },
  "Monomaniac One": {
    "link": "https://fonts.googleapis.com/css?family=Monomaniac+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Monomaniac One', sans-serif"
  },
  "Prosto One": {
    "link": "https://fonts.googleapis.com/css?family=Prosto+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Prosto One', sans-serif"
  },
  "Fuggles": {
    "link": "https://fonts.googleapis.com/css?family=Fuggles:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Fuggles', sans-serif"
  },
  "Carme": {
    "link": "https://fonts.googleapis.com/css?family=Carme:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Carme', sans-serif"
  },
  "Bayon": {
    "link": "https://fonts.googleapis.com/css?family=Bayon:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bayon', sans-serif"
  },
  "Montaga": {
    "link": "https://fonts.googleapis.com/css?family=Montaga:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Montaga', sans-serif"
  },
  "Sumana": {
    "link": "https://fonts.googleapis.com/css?family=Sumana:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Sumana', sans-serif"
  },
  "Goblin One": {
    "link": "https://fonts.googleapis.com/css?family=Goblin+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Goblin One', sans-serif"
  },
  "Mako": {
    "link": "https://fonts.googleapis.com/css?family=Mako:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mako', sans-serif"
  },
  "Familjen Grotesk": {
    "link": "https://fonts.googleapis.com/css?family=Familjen+Grotesk:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Familjen Grotesk', sans-serif"
  },
  "Gotu": {
    "link": "https://fonts.googleapis.com/css?family=Gotu:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gotu', sans-serif"
  },
  "Libre Barcode 128": {
    "link": "https://fonts.googleapis.com/css?family=Libre+Barcode+128:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Libre Barcode 128', sans-serif"
  },
  "Just Me Again Down Here": {
    "link": "https://fonts.googleapis.com/css?family=Just+Me+Again+Down+Here:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Just Me Again Down Here', sans-serif"
  },
  "Original Surfer": {
    "link": "https://fonts.googleapis.com/css?family=Original+Surfer:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Original Surfer', sans-serif"
  },
  "Averia Sans Libre": {
    "link": "https://fonts.googleapis.com/css?family=Averia+Sans+Libre:ital,wght@0,300;1,300;0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Averia Sans Libre', sans-serif"
  },
  "Asul": {
    "link": "https://fonts.googleapis.com/css?family=Asul:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Asul', sans-serif"
  },
  "Gantari": {
    "link": "https://fonts.googleapis.com/css?family=Gantari:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Gantari', sans-serif"
  },
  "Allan": {
    "link": "https://fonts.googleapis.com/css?family=Allan:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Allan', sans-serif"
  },
  "Montez": {
    "link": "https://fonts.googleapis.com/css?family=Montez:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Montez', sans-serif"
  },
  "Expletus Sans": {
    "link": "https://fonts.googleapis.com/css?family=Expletus+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Expletus Sans', sans-serif"
  },
  "Madimi One": {
    "link": "https://fonts.googleapis.com/css?family=Madimi+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Madimi One', sans-serif"
  },
  "Truculenta": {
    "link": "https://fonts.googleapis.com/css?family=Truculenta:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Truculenta', sans-serif"
  },
  "Sail": {
    "link": "https://fonts.googleapis.com/css?family=Sail:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sail', sans-serif"
  },
  "Slabo 13px": {
    "link": "https://fonts.googleapis.com/css?family=Slabo+13px:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Slabo 13px', sans-serif"
  },
  "Mirza": {
    "link": "https://fonts.googleapis.com/css?family=Mirza:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Mirza', sans-serif"
  },
  "Euphoria Script": {
    "link": "https://fonts.googleapis.com/css?family=Euphoria+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Euphoria Script', sans-serif"
  },
  "Baloo Chettan 2": {
    "link": "https://fonts.googleapis.com/css?family=Baloo+Chettan+2:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Baloo Chettan 2', sans-serif"
  },
  "Walter Turncoat": {
    "link": "https://fonts.googleapis.com/css?family=Walter+Turncoat:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Walter Turncoat', sans-serif"
  },
  "Modak": {
    "link": "https://fonts.googleapis.com/css?family=Modak:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Modak', sans-serif"
  },
  "Hi Melody": {
    "link": "https://fonts.googleapis.com/css?family=Hi+Melody:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Hi Melody', sans-serif"
  },
  "Zen Antique Soft": {
    "link": "https://fonts.googleapis.com/css?family=Zen+Antique+Soft:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Zen Antique Soft', sans-serif"
  },
  "Numans": {
    "link": "https://fonts.googleapis.com/css?family=Numans:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Numans', sans-serif"
  },
  "Noto Sans Oriya": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Oriya:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Oriya', sans-serif"
  },
  "Suranna": {
    "link": "https://fonts.googleapis.com/css?family=Suranna:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Suranna', sans-serif"
  },
  "Noto Sans Georgian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Georgian:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Georgian', sans-serif"
  },
  "Syne Mono": {
    "link": "https://fonts.googleapis.com/css?family=Syne+Mono:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Syne Mono', sans-serif"
  },
  "Solway": {
    "link": "https://fonts.googleapis.com/css?family=Solway:wght@0,300;0,400;0,500;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Solway', sans-serif"
  },
  "Charmonman": {
    "link": "https://fonts.googleapis.com/css?family=Charmonman:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Charmonman', sans-serif"
  },
  "Manuale": {
    "link": "https://fonts.googleapis.com/css?family=Manuale:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&subset=latin&display=swap",
    "fontFamily": "'Manuale', sans-serif"
  },
  "Bricolage Grotesque": {
    "link": "https://fonts.googleapis.com/css?family=Bricolage+Grotesque:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Bricolage Grotesque', sans-serif"
  },
  "Timmana": {
    "link": "https://fonts.googleapis.com/css?family=Timmana:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Timmana', sans-serif"
  },
  "Noto Serif Thai": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Thai:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Thai', sans-serif"
  },
  "Vina Sans": {
    "link": "https://fonts.googleapis.com/css?family=Vina+Sans:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Vina Sans', sans-serif"
  },
  "Delius Unicase": {
    "link": "https://fonts.googleapis.com/css?family=Delius+Unicase:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Delius Unicase', sans-serif"
  },
  "Recursive": {
    "link": "https://fonts.googleapis.com/css?family=Recursive:wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Recursive', sans-serif"
  },
  "Harmattan": {
    "link": "https://fonts.googleapis.com/css?family=Harmattan:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Harmattan', sans-serif"
  },
  "Clicker Script": {
    "link": "https://fonts.googleapis.com/css?family=Clicker+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Clicker Script', sans-serif"
  },
  "Potta One": {
    "link": "https://fonts.googleapis.com/css?family=Potta+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Potta One', sans-serif"
  },
  "Goldman": {
    "link": "https://fonts.googleapis.com/css?family=Goldman:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Goldman', sans-serif"
  },
  "Noto Sans Meetei Mayek": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Meetei+Mayek:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Meetei Mayek', sans-serif"
  },
  "Libre Caslon Display": {
    "link": "https://fonts.googleapis.com/css?family=Libre+Caslon+Display:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Libre Caslon Display', sans-serif"
  },
  "BhuTuka Expanded One": {
    "link": "https://fonts.googleapis.com/css?family=BhuTuka+Expanded+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'BhuTuka Expanded One', sans-serif"
  },
  "Dongle": {
    "link": "https://fonts.googleapis.com/css?family=Dongle:wght@0,300;0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Dongle', sans-serif"
  },
  "Esteban": {
    "link": "https://fonts.googleapis.com/css?family=Esteban:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Esteban', sans-serif"
  },
  "Wix Madefor Display": {
    "link": "https://fonts.googleapis.com/css?family=Wix+Madefor+Display:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Wix Madefor Display', sans-serif"
  },
  "Mukta Mahee": {
    "link": "https://fonts.googleapis.com/css?family=Mukta+Mahee:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Mukta Mahee', sans-serif"
  },
  "Convergence": {
    "link": "https://fonts.googleapis.com/css?family=Convergence:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Convergence', sans-serif"
  },
  "Crafty Girls": {
    "link": "https://fonts.googleapis.com/css?family=Crafty+Girls:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Crafty Girls', sans-serif"
  },
  "Metamorphous": {
    "link": "https://fonts.googleapis.com/css?family=Metamorphous:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Metamorphous', sans-serif"
  },
  "BIZ UDPMincho": {
    "link": "https://fonts.googleapis.com/css?family=BIZ+UDPMincho:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'BIZ UDPMincho', sans-serif"
  },
  "Gugi": {
    "link": "https://fonts.googleapis.com/css?family=Gugi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gugi', sans-serif"
  },
  "Vesper Libre": {
    "link": "https://fonts.googleapis.com/css?family=Vesper+Libre:wght@0,400;0,500;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Vesper Libre', sans-serif"
  },
  "Freehand": {
    "link": "https://fonts.googleapis.com/css?family=Freehand:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Freehand', sans-serif"
  },
  "WindSong": {
    "link": "https://fonts.googleapis.com/css?family=WindSong:wght@0,400;0,500&subset=latin&display=swap",
    "fontFamily": "'WindSong', sans-serif"
  },
  "Kdam Thmor Pro": {
    "link": "https://fonts.googleapis.com/css?family=Kdam+Thmor+Pro:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kdam Thmor Pro', sans-serif"
  },
  "Codystar": {
    "link": "https://fonts.googleapis.com/css?family=Codystar:wght@0,300;0,400&subset=latin&display=swap",
    "fontFamily": "'Codystar', sans-serif"
  },
  "Megrim": {
    "link": "https://fonts.googleapis.com/css?family=Megrim:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Megrim', sans-serif"
  },
  "Notable": {
    "link": "https://fonts.googleapis.com/css?family=Notable:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Notable', sans-serif"
  },
  "Buenard": {
    "link": "https://fonts.googleapis.com/css?family=Buenard:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Buenard', sans-serif"
  },
  "Bakbak One": {
    "link": "https://fonts.googleapis.com/css?family=Bakbak+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bakbak One', sans-serif"
  },
  "Gaegu": {
    "link": "https://fonts.googleapis.com/css?family=Gaegu:wght@0,300;0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Gaegu', sans-serif"
  },
  "Shojumaru": {
    "link": "https://fonts.googleapis.com/css?family=Shojumaru:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Shojumaru', sans-serif"
  },
  "Tilt Warp": {
    "link": "https://fonts.googleapis.com/css?family=Tilt+Warp:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Tilt Warp', sans-serif"
  },
  "Sarpanch": {
    "link": "https://fonts.googleapis.com/css?family=Sarpanch:wght@0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Sarpanch', sans-serif"
  },
  "IM Fell Double Pica": {
    "link": "https://fonts.googleapis.com/css?family=IM+Fell+Double+Pica:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'IM Fell Double Pica', sans-serif"
  },
  "Noto Sans Symbols": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Symbols:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Symbols', sans-serif"
  },
  "Puritan": {
    "link": "https://fonts.googleapis.com/css?family=Puritan:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Puritan', sans-serif"
  },
  "Saira Stencil One": {
    "link": "https://fonts.googleapis.com/css?family=Saira+Stencil+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Saira Stencil One', sans-serif"
  },
  "Inria Sans": {
    "link": "https://fonts.googleapis.com/css?family=Inria+Sans:ital,wght@0,300;1,300;0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Inria Sans', sans-serif"
  },
  "Nerko One": {
    "link": "https://fonts.googleapis.com/css?family=Nerko+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Nerko One', sans-serif"
  },
  "Birthstone": {
    "link": "https://fonts.googleapis.com/css?family=Birthstone:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Birthstone', sans-serif"
  },
  "Orelega One": {
    "link": "https://fonts.googleapis.com/css?family=Orelega+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Orelega One', sans-serif"
  },
  "Whisper": {
    "link": "https://fonts.googleapis.com/css?family=Whisper:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Whisper', sans-serif"
  },
  "Overlock SC": {
    "link": "https://fonts.googleapis.com/css?family=Overlock+SC:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Overlock SC', sans-serif"
  },
  "Dynalight": {
    "link": "https://fonts.googleapis.com/css?family=Dynalight:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Dynalight', sans-serif"
  },
  "Lily Script One": {
    "link": "https://fonts.googleapis.com/css?family=Lily+Script+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Lily Script One', sans-serif"
  },
  "Scheherazade New": {
    "link": "https://fonts.googleapis.com/css?family=Scheherazade+New:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Scheherazade New', sans-serif"
  },
  "Mochiy Pop One": {
    "link": "https://fonts.googleapis.com/css?family=Mochiy+Pop+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mochiy Pop One', sans-serif"
  },
  "Scope One": {
    "link": "https://fonts.googleapis.com/css?family=Scope+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Scope One', sans-serif"
  },
  "Artifika": {
    "link": "https://fonts.googleapis.com/css?family=Artifika:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Artifika', sans-serif"
  },
  "Vibur": {
    "link": "https://fonts.googleapis.com/css?family=Vibur:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Vibur', sans-serif"
  },
  "Cormorant Unicase": {
    "link": "https://fonts.googleapis.com/css?family=Cormorant+Unicase:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Cormorant Unicase', sans-serif"
  },
  "Sulphur Point": {
    "link": "https://fonts.googleapis.com/css?family=Sulphur+Point:wght@0,300;0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Sulphur Point', sans-serif"
  },
  "Atma": {
    "link": "https://fonts.googleapis.com/css?family=Atma:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Atma', sans-serif"
  },
  "Tienne": {
    "link": "https://fonts.googleapis.com/css?family=Tienne:wght@0,400;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Tienne', sans-serif"
  },
  "Spicy Rice": {
    "link": "https://fonts.googleapis.com/css?family=Spicy+Rice:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Spicy Rice', sans-serif"
  },
  "Kranky": {
    "link": "https://fonts.googleapis.com/css?family=Kranky:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kranky', sans-serif"
  },
  "League Script": {
    "link": "https://fonts.googleapis.com/css?family=League+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'League Script', sans-serif"
  },
  "Bilbo Swash Caps": {
    "link": "https://fonts.googleapis.com/css?family=Bilbo+Swash+Caps:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bilbo Swash Caps', sans-serif"
  },
  "Grenze": {
    "link": "https://fonts.googleapis.com/css?family=Grenze:ital,wght@0,100;1,100;0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Grenze', sans-serif"
  },
  "Ceviche One": {
    "link": "https://fonts.googleapis.com/css?family=Ceviche+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ceviche One', sans-serif"
  },
  "Slackside One": {
    "link": "https://fonts.googleapis.com/css?family=Slackside+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Slackside One', sans-serif"
  },
  "Galada": {
    "link": "https://fonts.googleapis.com/css?family=Galada:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Galada', sans-serif"
  },
  "Barriecito": {
    "link": "https://fonts.googleapis.com/css?family=Barriecito:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Barriecito', sans-serif"
  },
  "ZCOOL QingKe HuangYou": {
    "link": "https://fonts.googleapis.com/css?family=ZCOOL+QingKe+HuangYou:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'ZCOOL QingKe HuangYou', sans-serif"
  },
  "Noto Sans Khojki": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Khojki:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Khojki', sans-serif"
  },
  "Finger Paint": {
    "link": "https://fonts.googleapis.com/css?family=Finger+Paint:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Finger Paint', sans-serif"
  },
  "Balthazar": {
    "link": "https://fonts.googleapis.com/css?family=Balthazar:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Balthazar', sans-serif"
  },
  "Shantell Sans": {
    "link": "https://fonts.googleapis.com/css?family=Shantell+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&subset=latin&display=swap",
    "fontFamily": "'Shantell Sans', sans-serif"
  },
  "Poltawski Nowy": {
    "link": "https://fonts.googleapis.com/css?family=Poltawski+Nowy:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Poltawski Nowy', sans-serif"
  },
  "Patrick Hand SC": {
    "link": "https://fonts.googleapis.com/css?family=Patrick+Hand+SC:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Patrick Hand SC', sans-serif"
  },
  "Kaisei Tokumin": {
    "link": "https://fonts.googleapis.com/css?family=Kaisei+Tokumin:wght@0,400;0,500;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Kaisei Tokumin', sans-serif"
  },
  "Almendra": {
    "link": "https://fonts.googleapis.com/css?family=Almendra:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Almendra', sans-serif"
  },
  "Wendy One": {
    "link": "https://fonts.googleapis.com/css?family=Wendy+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Wendy One', sans-serif"
  },
  "Bigshot One": {
    "link": "https://fonts.googleapis.com/css?family=Bigshot+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bigshot One', sans-serif"
  },
  "Baloo Bhai 2": {
    "link": "https://fonts.googleapis.com/css?family=Baloo+Bhai+2:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Baloo Bhai 2', sans-serif"
  },
  "Frijole": {
    "link": "https://fonts.googleapis.com/css?family=Frijole:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Frijole', sans-serif"
  },
  "Road Rage": {
    "link": "https://fonts.googleapis.com/css?family=Road+Rage:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Road Rage', sans-serif"
  },
  "Fresca": {
    "link": "https://fonts.googleapis.com/css?family=Fresca:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Fresca', sans-serif"
  },
  "Reggae One": {
    "link": "https://fonts.googleapis.com/css?family=Reggae+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Reggae One', sans-serif"
  },
  "Unkempt": {
    "link": "https://fonts.googleapis.com/css?family=Unkempt:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Unkempt', sans-serif"
  },
  "Share Tech": {
    "link": "https://fonts.googleapis.com/css?family=Share+Tech:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Share Tech', sans-serif"
  },
  "Rampart One": {
    "link": "https://fonts.googleapis.com/css?family=Rampart+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rampart One', sans-serif"
  },
  "Libre Barcode 39 Extended Text": {
    "link": "https://fonts.googleapis.com/css?family=Libre+Barcode+39+Extended+Text:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Libre Barcode 39 Extended Text', sans-serif"
  },
  "Red Rose": {
    "link": "https://fonts.googleapis.com/css?family=Red+Rose:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Red Rose', sans-serif"
  },
  "Trade Winds": {
    "link": "https://fonts.googleapis.com/css?family=Trade+Winds:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Trade Winds', sans-serif"
  },
  "Rubik Dirt": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Dirt:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Dirt', sans-serif"
  },
  "Slackey": {
    "link": "https://fonts.googleapis.com/css?family=Slackey:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Slackey', sans-serif"
  },
  "Bellota": {
    "link": "https://fonts.googleapis.com/css?family=Bellota:ital,wght@0,300;1,300;0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Bellota', sans-serif"
  },
  "Sofia Sans Semi Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Sofia+Sans+Semi+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Sofia Sans Semi Condensed', sans-serif"
  },
  "Hina Mincho": {
    "link": "https://fonts.googleapis.com/css?family=Hina+Mincho:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Hina Mincho', sans-serif"
  },
  "Eater": {
    "link": "https://fonts.googleapis.com/css?family=Eater:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Eater', sans-serif"
  },
  "Stick": {
    "link": "https://fonts.googleapis.com/css?family=Stick:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Stick', sans-serif"
  },
  "Doppio One": {
    "link": "https://fonts.googleapis.com/css?family=Doppio+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Doppio One', sans-serif"
  },
  "The Girl Next Door": {
    "link": "https://fonts.googleapis.com/css?family=The+Girl+Next+Door:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'The Girl Next Door', sans-serif"
  },
  "Montagu Slab": {
    "link": "https://fonts.googleapis.com/css?family=Montagu+Slab:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Montagu Slab', sans-serif"
  },
  "Vast Shadow": {
    "link": "https://fonts.googleapis.com/css?family=Vast+Shadow:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Vast Shadow', sans-serif"
  },
  "Baumans": {
    "link": "https://fonts.googleapis.com/css?family=Baumans:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Baumans', sans-serif"
  },
  "Orienta": {
    "link": "https://fonts.googleapis.com/css?family=Orienta:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Orienta', sans-serif"
  },
  "Dokdo": {
    "link": "https://fonts.googleapis.com/css?family=Dokdo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Dokdo', sans-serif"
  },
  "Viaoda Libre": {
    "link": "https://fonts.googleapis.com/css?family=Viaoda+Libre:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Viaoda Libre', sans-serif"
  },
  "Kaisei Opti": {
    "link": "https://fonts.googleapis.com/css?family=Kaisei+Opti:wght@0,400;0,500;0,700&subset=latin&display=swap",
    "fontFamily": "'Kaisei Opti', sans-serif"
  },
  "Baloo Tammudu 2": {
    "link": "https://fonts.googleapis.com/css?family=Baloo+Tammudu+2:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Baloo Tammudu 2', sans-serif"
  },
  "Noto Serif Malayalam": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Malayalam:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Malayalam', sans-serif"
  },
  "Noto Serif Hebrew": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Hebrew:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Hebrew', sans-serif"
  },
  "Mohave": {
    "link": "https://fonts.googleapis.com/css?family=Mohave:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Mohave', sans-serif"
  },
  "Freckle Face": {
    "link": "https://fonts.googleapis.com/css?family=Freckle+Face:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Freckle Face', sans-serif"
  },
  "Nokora": {
    "link": "https://fonts.googleapis.com/css?family=Nokora:wght@0,100;0,300;0,400;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Nokora', sans-serif"
  },
  "Ledger": {
    "link": "https://fonts.googleapis.com/css?family=Ledger:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ledger', sans-serif"
  },
  "Fragment Mono": {
    "link": "https://fonts.googleapis.com/css?family=Fragment+Mono:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Fragment Mono', sans-serif"
  },
  "Instrument Serif": {
    "link": "https://fonts.googleapis.com/css?family=Instrument+Serif:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Instrument Serif', sans-serif"
  },
  "Emilys Candy": {
    "link": "https://fonts.googleapis.com/css?family=Emilys+Candy:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Emilys Candy', sans-serif"
  },
  "Karantina": {
    "link": "https://fonts.googleapis.com/css?family=Karantina:wght@0,300;0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Karantina', sans-serif"
  },
  "Wire One": {
    "link": "https://fonts.googleapis.com/css?family=Wire+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Wire One', sans-serif"
  },
  "Imprima": {
    "link": "https://fonts.googleapis.com/css?family=Imprima:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Imprima', sans-serif"
  },
  "Bubbler One": {
    "link": "https://fonts.googleapis.com/css?family=Bubbler+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bubbler One', sans-serif"
  },
  "Londrina Outline": {
    "link": "https://fonts.googleapis.com/css?family=Londrina+Outline:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Londrina Outline', sans-serif"
  },
  "Battambang": {
    "link": "https://fonts.googleapis.com/css?family=Battambang:wght@0,100;0,300;0,400;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Battambang', sans-serif"
  },
  "Grape Nuts": {
    "link": "https://fonts.googleapis.com/css?family=Grape+Nuts:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Grape Nuts', sans-serif"
  },
  "Cherry Cream Soda": {
    "link": "https://fonts.googleapis.com/css?family=Cherry+Cream+Soda:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Cherry Cream Soda', sans-serif"
  },
  "Meera Inimai": {
    "link": "https://fonts.googleapis.com/css?family=Meera+Inimai:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Meera Inimai', sans-serif"
  },
  "Life Savers": {
    "link": "https://fonts.googleapis.com/css?family=Life+Savers:wght@0,400;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Life Savers', sans-serif"
  },
  "Fontdiner Swanky": {
    "link": "https://fonts.googleapis.com/css?family=Fontdiner+Swanky:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Fontdiner Swanky', sans-serif"
  },
  "Edu SA Beginner": {
    "link": "https://fonts.googleapis.com/css?family=Edu+SA+Beginner:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Edu SA Beginner', sans-serif"
  },
  "Ojuju": {
    "link": "https://fonts.googleapis.com/css?family=Ojuju:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Ojuju', sans-serif"
  },
  "Voces": {
    "link": "https://fonts.googleapis.com/css?family=Voces:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Voces', sans-serif"
  },
  "Loved by the King": {
    "link": "https://fonts.googleapis.com/css?family=Loved+by+the+King:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Loved by the King', sans-serif"
  },
  "Smooch Sans": {
    "link": "https://fonts.googleapis.com/css?family=Smooch+Sans:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Smooch Sans', sans-serif"
  },
  "Medula One": {
    "link": "https://fonts.googleapis.com/css?family=Medula+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Medula One', sans-serif"
  },
  "Nova Round": {
    "link": "https://fonts.googleapis.com/css?family=Nova+Round:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Nova Round', sans-serif"
  },
  "Comforter Brush": {
    "link": "https://fonts.googleapis.com/css?family=Comforter+Brush:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Comforter Brush', sans-serif"
  },
  "Iceland": {
    "link": "https://fonts.googleapis.com/css?family=Iceland:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Iceland', sans-serif"
  },
  "Ranga": {
    "link": "https://fonts.googleapis.com/css?family=Ranga:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Ranga', sans-serif"
  },
  "Raleway Dots": {
    "link": "https://fonts.googleapis.com/css?family=Raleway+Dots:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Raleway Dots', sans-serif"
  },
  "Zen Dots": {
    "link": "https://fonts.googleapis.com/css?family=Zen+Dots:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Zen Dots', sans-serif"
  },
  "Miniver": {
    "link": "https://fonts.googleapis.com/css?family=Miniver:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Miniver', sans-serif"
  },
  "MedievalSharp": {
    "link": "https://fonts.googleapis.com/css?family=MedievalSharp:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'MedievalSharp', sans-serif"
  },
  "Anek Latin": {
    "link": "https://fonts.googleapis.com/css?family=Anek+Latin:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Anek Latin', sans-serif"
  },
  "Akaya Kanadaka": {
    "link": "https://fonts.googleapis.com/css?family=Akaya+Kanadaka:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Akaya Kanadaka', sans-serif"
  },
  "Gamja Flower": {
    "link": "https://fonts.googleapis.com/css?family=Gamja+Flower:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gamja Flower', sans-serif"
  },
  "Chau Philomene One": {
    "link": "https://fonts.googleapis.com/css?family=Chau+Philomene+One:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Chau Philomene One', sans-serif"
  },
  "Belgrano": {
    "link": "https://fonts.googleapis.com/css?family=Belgrano:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Belgrano', sans-serif"
  },
  "Tauri": {
    "link": "https://fonts.googleapis.com/css?family=Tauri:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Tauri', sans-serif"
  },
  "Peralta": {
    "link": "https://fonts.googleapis.com/css?family=Peralta:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Peralta', sans-serif"
  },
  "Macondo Swash Caps": {
    "link": "https://fonts.googleapis.com/css?family=Macondo+Swash+Caps:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Macondo Swash Caps', sans-serif"
  },
  "Corinthia": {
    "link": "https://fonts.googleapis.com/css?family=Corinthia:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Corinthia', sans-serif"
  },
  "Varta": {
    "link": "https://fonts.googleapis.com/css?family=Varta:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Varta', sans-serif"
  },
  "Pavanam": {
    "link": "https://fonts.googleapis.com/css?family=Pavanam:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Pavanam', sans-serif"
  },
  "Ranchers": {
    "link": "https://fonts.googleapis.com/css?family=Ranchers:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ranchers', sans-serif"
  },
  "Alkalami": {
    "link": "https://fonts.googleapis.com/css?family=Alkalami:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Alkalami', sans-serif"
  },
  "Tillana": {
    "link": "https://fonts.googleapis.com/css?family=Tillana:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Tillana', sans-serif"
  },
  "Hachi Maru Pop": {
    "link": "https://fonts.googleapis.com/css?family=Hachi+Maru+Pop:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Hachi Maru Pop', sans-serif"
  },
  "Gayathri": {
    "link": "https://fonts.googleapis.com/css?family=Gayathri:wght@0,100;0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Gayathri', sans-serif"
  },
  "Baloo Bhaina 2": {
    "link": "https://fonts.googleapis.com/css?family=Baloo+Bhaina+2:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Baloo Bhaina 2', sans-serif"
  },
  "Gowun Batang": {
    "link": "https://fonts.googleapis.com/css?family=Gowun+Batang:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Gowun Batang', sans-serif"
  },
  "Shanti": {
    "link": "https://fonts.googleapis.com/css?family=Shanti:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Shanti', sans-serif"
  },
  "Protest Revolution": {
    "link": "https://fonts.googleapis.com/css?family=Protest+Revolution:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Protest Revolution', sans-serif"
  },
  "Asar": {
    "link": "https://fonts.googleapis.com/css?family=Asar:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Asar', sans-serif"
  },
  "Square Peg": {
    "link": "https://fonts.googleapis.com/css?family=Square+Peg:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Square Peg', sans-serif"
  },
  "Mochiy Pop P One": {
    "link": "https://fonts.googleapis.com/css?family=Mochiy+Pop+P+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mochiy Pop P One', sans-serif"
  },
  "Gowun Dodum": {
    "link": "https://fonts.googleapis.com/css?family=Gowun+Dodum:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gowun Dodum', sans-serif"
  },
  "Red Hat Mono": {
    "link": "https://fonts.googleapis.com/css?family=Red+Hat+Mono:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Red Hat Mono', sans-serif"
  },
  "Major Mono Display": {
    "link": "https://fonts.googleapis.com/css?family=Major+Mono+Display:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Major Mono Display', sans-serif"
  },
  "Rhodium Libre": {
    "link": "https://fonts.googleapis.com/css?family=Rhodium+Libre:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rhodium Libre', sans-serif"
  },
  "Rum Raisin": {
    "link": "https://fonts.googleapis.com/css?family=Rum+Raisin:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rum Raisin', sans-serif"
  },
  "Qwitcher Grypen": {
    "link": "https://fonts.googleapis.com/css?family=Qwitcher+Grypen:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Qwitcher Grypen', sans-serif"
  },
  "Murecho": {
    "link": "https://fonts.googleapis.com/css?family=Murecho:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Murecho', sans-serif"
  },
  "Noto Serif HK": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+HK:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif HK', sans-serif"
  },
  "Libre Barcode 128 Text": {
    "link": "https://fonts.googleapis.com/css?family=Libre+Barcode+128+Text:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Libre Barcode 128 Text', sans-serif"
  },
  "Agbalumo": {
    "link": "https://fonts.googleapis.com/css?family=Agbalumo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Agbalumo', sans-serif"
  },
  "ADLaM Display": {
    "link": "https://fonts.googleapis.com/css?family=ADLaM+Display:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'ADLaM Display', sans-serif"
  },
  "Habibi": {
    "link": "https://fonts.googleapis.com/css?family=Habibi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Habibi', sans-serif"
  },
  "Cherry Swash": {
    "link": "https://fonts.googleapis.com/css?family=Cherry+Swash:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Cherry Swash', sans-serif"
  },
  "Prociono": {
    "link": "https://fonts.googleapis.com/css?family=Prociono:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Prociono', sans-serif"
  },
  "Shalimar": {
    "link": "https://fonts.googleapis.com/css?family=Shalimar:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Shalimar', sans-serif"
  },
  "Redressed": {
    "link": "https://fonts.googleapis.com/css?family=Redressed:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Redressed', sans-serif"
  },
  "Modern Antiqua": {
    "link": "https://fonts.googleapis.com/css?family=Modern+Antiqua:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Modern Antiqua', sans-serif"
  },
  "Faster One": {
    "link": "https://fonts.googleapis.com/css?family=Faster+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Faster One', sans-serif"
  },
  "Delius Swash Caps": {
    "link": "https://fonts.googleapis.com/css?family=Delius+Swash+Caps:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Delius Swash Caps', sans-serif"
  },
  "Ramaraja": {
    "link": "https://fonts.googleapis.com/css?family=Ramaraja:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ramaraja', sans-serif"
  },
  "Akaya Telivigala": {
    "link": "https://fonts.googleapis.com/css?family=Akaya+Telivigala:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Akaya Telivigala', sans-serif"
  },
  "Noto Serif Georgian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Georgian:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Georgian', sans-serif"
  },
  "Noto Sans Khmer": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Khmer:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Khmer', sans-serif"
  },
  "East Sea Dokdo": {
    "link": "https://fonts.googleapis.com/css?family=East+Sea+Dokdo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'East Sea Dokdo', sans-serif"
  },
  "Jomolhari": {
    "link": "https://fonts.googleapis.com/css?family=Jomolhari:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Jomolhari', sans-serif"
  },
  "Gemunu Libre": {
    "link": "https://fonts.googleapis.com/css?family=Gemunu+Libre:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Gemunu Libre', sans-serif"
  },
  "Zilla Slab Highlight": {
    "link": "https://fonts.googleapis.com/css?family=Zilla+Slab+Highlight:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Zilla Slab Highlight', sans-serif"
  },
  "UnifrakturCook": {
    "link": "https://fonts.googleapis.com/css?family=UnifrakturCook:wght@0,700&subset=latin&display=swap",
    "fontFamily": "'UnifrakturCook', sans-serif"
  },
  "Song Myung": {
    "link": "https://fonts.googleapis.com/css?family=Song+Myung:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Song Myung', sans-serif"
  },
  "Gorditas": {
    "link": "https://fonts.googleapis.com/css?family=Gorditas:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Gorditas', sans-serif"
  },
  "Lexend Mega": {
    "link": "https://fonts.googleapis.com/css?family=Lexend+Mega:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Lexend Mega', sans-serif"
  },
  "Arima": {
    "link": "https://fonts.googleapis.com/css?family=Arima:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Arima', sans-serif"
  },
  "Strait": {
    "link": "https://fonts.googleapis.com/css?family=Strait:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Strait', sans-serif"
  },
  "Ruthie": {
    "link": "https://fonts.googleapis.com/css?family=Ruthie:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ruthie', sans-serif"
  },
  "IM Fell French Canon": {
    "link": "https://fonts.googleapis.com/css?family=IM+Fell+French+Canon:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'IM Fell French Canon', sans-serif"
  },
  "Pixelify Sans": {
    "link": "https://fonts.googleapis.com/css?family=Pixelify+Sans:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Pixelify Sans', sans-serif"
  },
  "Chango": {
    "link": "https://fonts.googleapis.com/css?family=Chango:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Chango', sans-serif"
  },
  "Crushed": {
    "link": "https://fonts.googleapis.com/css?family=Crushed:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Crushed', sans-serif"
  },
  "Anek Bangla": {
    "link": "https://fonts.googleapis.com/css?family=Anek+Bangla:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Anek Bangla', sans-serif"
  },
  "Dekko": {
    "link": "https://fonts.googleapis.com/css?family=Dekko:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Dekko', sans-serif"
  },
  "Kaisei HarunoUmi": {
    "link": "https://fonts.googleapis.com/css?family=Kaisei+HarunoUmi:wght@0,400;0,500;0,700&subset=latin&display=swap",
    "fontFamily": "'Kaisei HarunoUmi', sans-serif"
  },
  "Ribeye": {
    "link": "https://fonts.googleapis.com/css?family=Ribeye:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ribeye', sans-serif"
  },
  "Flow Circular": {
    "link": "https://fonts.googleapis.com/css?family=Flow+Circular:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Flow Circular', sans-serif"
  },
  "Nosifer": {
    "link": "https://fonts.googleapis.com/css?family=Nosifer:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Nosifer', sans-serif"
  },
  "Monofett": {
    "link": "https://fonts.googleapis.com/css?family=Monofett:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Monofett', sans-serif"
  },
  "Stylish": {
    "link": "https://fonts.googleapis.com/css?family=Stylish:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Stylish', sans-serif"
  },
  "Swanky and Moo Moo": {
    "link": "https://fonts.googleapis.com/css?family=Swanky+and+Moo+Moo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Swanky and Moo Moo', sans-serif"
  },
  "Tektur": {
    "link": "https://fonts.googleapis.com/css?family=Tektur:wght@0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Tektur', sans-serif"
  },
  "Fasthand": {
    "link": "https://fonts.googleapis.com/css?family=Fasthand:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Fasthand', sans-serif"
  },
  "Gulzar": {
    "link": "https://fonts.googleapis.com/css?family=Gulzar:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gulzar', sans-serif"
  },
  "Bona Nova": {
    "link": "https://fonts.googleapis.com/css?family=Bona+Nova:ital,wght@0,400;1,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Bona Nova', sans-serif"
  },
  "Moul": {
    "link": "https://fonts.googleapis.com/css?family=Moul:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Moul', sans-serif"
  },
  "Fenix": {
    "link": "https://fonts.googleapis.com/css?family=Fenix:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Fenix', sans-serif"
  },
  "Noto Serif Telugu": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Telugu:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Telugu', sans-serif"
  },
  "Chathura": {
    "link": "https://fonts.googleapis.com/css?family=Chathura:wght@0,100;0,300;0,400;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Chathura', sans-serif"
  },
  "Spline Sans Mono": {
    "link": "https://fonts.googleapis.com/css?family=Spline+Sans+Mono:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Spline Sans Mono', sans-serif"
  },
  "IBM Plex Sans Hebrew": {
    "link": "https://fonts.googleapis.com/css?family=IBM+Plex+Sans+Hebrew:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'IBM Plex Sans Hebrew', sans-serif"
  },
  "Rosarivo": {
    "link": "https://fonts.googleapis.com/css?family=Rosarivo:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Rosarivo', sans-serif"
  },
  "Kalnia": {
    "link": "https://fonts.googleapis.com/css?family=Kalnia:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Kalnia', sans-serif"
  },
  "Carrois Gothic SC": {
    "link": "https://fonts.googleapis.com/css?family=Carrois+Gothic+SC:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Carrois Gothic SC', sans-serif"
  },
  "Cantora One": {
    "link": "https://fonts.googleapis.com/css?family=Cantora+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Cantora One', sans-serif"
  },
  "Port Lligat Sans": {
    "link": "https://fonts.googleapis.com/css?family=Port+Lligat+Sans:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Port Lligat Sans', sans-serif"
  },
  "IM Fell DW Pica SC": {
    "link": "https://fonts.googleapis.com/css?family=IM+Fell+DW+Pica+SC:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'IM Fell DW Pica SC', sans-serif"
  },
  "Sonsie One": {
    "link": "https://fonts.googleapis.com/css?family=Sonsie+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sonsie One', sans-serif"
  },
  "Shippori Antique": {
    "link": "https://fonts.googleapis.com/css?family=Shippori+Antique:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Shippori Antique', sans-serif"
  },
  "Akronim": {
    "link": "https://fonts.googleapis.com/css?family=Akronim:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Akronim', sans-serif"
  },
  "MonteCarlo": {
    "link": "https://fonts.googleapis.com/css?family=MonteCarlo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'MonteCarlo', sans-serif"
  },
  "Kotta One": {
    "link": "https://fonts.googleapis.com/css?family=Kotta+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kotta One', sans-serif"
  },
  "Metal Mania": {
    "link": "https://fonts.googleapis.com/css?family=Metal+Mania:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Metal Mania', sans-serif"
  },
  "Galdeano": {
    "link": "https://fonts.googleapis.com/css?family=Galdeano:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Galdeano', sans-serif"
  },
  "Stalemate": {
    "link": "https://fonts.googleapis.com/css?family=Stalemate:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Stalemate', sans-serif"
  },
  "ZCOOL KuaiLe": {
    "link": "https://fonts.googleapis.com/css?family=ZCOOL+KuaiLe:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'ZCOOL KuaiLe', sans-serif"
  },
  "Meow Script": {
    "link": "https://fonts.googleapis.com/css?family=Meow+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Meow Script', sans-serif"
  },
  "REM": {
    "link": "https://fonts.googleapis.com/css?family=REM:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'REM', sans-serif"
  },
  "Lovers Quarrel": {
    "link": "https://fonts.googleapis.com/css?family=Lovers+Quarrel:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Lovers Quarrel', sans-serif"
  },
  "Cute Font": {
    "link": "https://fonts.googleapis.com/css?family=Cute+Font:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Cute Font', sans-serif"
  },
  "Milonga": {
    "link": "https://fonts.googleapis.com/css?family=Milonga:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Milonga', sans-serif"
  },
  "Barrio": {
    "link": "https://fonts.googleapis.com/css?family=Barrio:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Barrio', sans-serif"
  },
  "Fuzzy Bubbles": {
    "link": "https://fonts.googleapis.com/css?family=Fuzzy+Bubbles:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Fuzzy Bubbles', sans-serif"
  },
  "Kite One": {
    "link": "https://fonts.googleapis.com/css?family=Kite+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kite One', sans-serif"
  },
  "Caprasimo": {
    "link": "https://fonts.googleapis.com/css?family=Caprasimo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Caprasimo', sans-serif"
  },
  "Denk One": {
    "link": "https://fonts.googleapis.com/css?family=Denk+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Denk One', sans-serif"
  },
  "Iceberg": {
    "link": "https://fonts.googleapis.com/css?family=Iceberg:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Iceberg', sans-serif"
  },
  "Yuji Syuku": {
    "link": "https://fonts.googleapis.com/css?family=Yuji+Syuku:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Yuji Syuku', sans-serif"
  },
  "Anybody": {
    "link": "https://fonts.googleapis.com/css?family=Anybody:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Anybody', sans-serif"
  },
  "Lexend Giga": {
    "link": "https://fonts.googleapis.com/css?family=Lexend+Giga:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Lexend Giga', sans-serif"
  },
  "Suwannaphum": {
    "link": "https://fonts.googleapis.com/css?family=Suwannaphum:wght@0,100;0,300;0,400;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Suwannaphum', sans-serif"
  },
  "Kantumruy Pro": {
    "link": "https://fonts.googleapis.com/css?family=Kantumruy+Pro:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Kantumruy Pro', sans-serif"
  },
  "Uncial Antiqua": {
    "link": "https://fonts.googleapis.com/css?family=Uncial+Antiqua:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Uncial Antiqua', sans-serif"
  },
  "Kulim Park": {
    "link": "https://fonts.googleapis.com/css?family=Kulim+Park:ital,wght@0,200;1,200;0,300;1,300;0,400;1,400;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Kulim Park', sans-serif"
  },
  "Train One": {
    "link": "https://fonts.googleapis.com/css?family=Train+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Train One', sans-serif"
  },
  "Piazzolla": {
    "link": "https://fonts.googleapis.com/css?family=Piazzolla:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Piazzolla', sans-serif"
  },
  "Stoke": {
    "link": "https://fonts.googleapis.com/css?family=Stoke:wght@0,300;0,400&subset=latin&display=swap",
    "fontFamily": "'Stoke', sans-serif"
  },
  "Delicious Handrawn": {
    "link": "https://fonts.googleapis.com/css?family=Delicious+Handrawn:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Delicious Handrawn', sans-serif"
  },
  "Tiro Kannada": {
    "link": "https://fonts.googleapis.com/css?family=Tiro+Kannada:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Tiro Kannada', sans-serif"
  },
  "Sunshiney": {
    "link": "https://fonts.googleapis.com/css?family=Sunshiney:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sunshiney', sans-serif"
  },
  "Stint Ultra Condensed": {
    "link": "https://fonts.googleapis.com/css?family=Stint+Ultra+Condensed:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Stint Ultra Condensed', sans-serif"
  },
  "Alkatra": {
    "link": "https://fonts.googleapis.com/css?family=Alkatra:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Alkatra', sans-serif"
  },
  "Nova Flat": {
    "link": "https://fonts.googleapis.com/css?family=Nova+Flat:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Nova Flat', sans-serif"
  },
  "Vujahday Script": {
    "link": "https://fonts.googleapis.com/css?family=Vujahday+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Vujahday Script', sans-serif"
  },
  "Noto Sans Adlam": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Adlam:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Adlam', sans-serif"
  },
  "Donegal One": {
    "link": "https://fonts.googleapis.com/css?family=Donegal+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Donegal One', sans-serif"
  },
  "Smooch": {
    "link": "https://fonts.googleapis.com/css?family=Smooch:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Smooch', sans-serif"
  },
  "Rationale": {
    "link": "https://fonts.googleapis.com/css?family=Rationale:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rationale', sans-serif"
  },
  "Jolly Lodger": {
    "link": "https://fonts.googleapis.com/css?family=Jolly+Lodger:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Jolly Lodger', sans-serif"
  },
  "Anek Telugu": {
    "link": "https://fonts.googleapis.com/css?family=Anek+Telugu:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Anek Telugu', sans-serif"
  },
  "Unlock": {
    "link": "https://fonts.googleapis.com/css?family=Unlock:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Unlock', sans-serif"
  },
  "Farsan": {
    "link": "https://fonts.googleapis.com/css?family=Farsan:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Farsan', sans-serif"
  },
  "AR One Sans": {
    "link": "https://fonts.googleapis.com/css?family=AR+One+Sans:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'AR One Sans', sans-serif"
  },
  "Autour One": {
    "link": "https://fonts.googleapis.com/css?family=Autour+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Autour One', sans-serif"
  },
  "Yomogi": {
    "link": "https://fonts.googleapis.com/css?family=Yomogi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Yomogi', sans-serif"
  },
  "IM Fell Great Primer": {
    "link": "https://fonts.googleapis.com/css?family=IM+Fell+Great+Primer:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'IM Fell Great Primer', sans-serif"
  },
  "Margarine": {
    "link": "https://fonts.googleapis.com/css?family=Margarine:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Margarine', sans-serif"
  },
  "Maiden Orange": {
    "link": "https://fonts.googleapis.com/css?family=Maiden+Orange:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Maiden Orange', sans-serif"
  },
  "Stick No Bills": {
    "link": "https://fonts.googleapis.com/css?family=Stick+No+Bills:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Stick No Bills', sans-serif"
  },
  "IBM Plex Sans Thai Looped": {
    "link": "https://fonts.googleapis.com/css?family=IBM+Plex+Sans+Thai+Looped:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'IBM Plex Sans Thai Looped', sans-serif"
  },
  "Paprika": {
    "link": "https://fonts.googleapis.com/css?family=Paprika:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Paprika', sans-serif"
  },
  "Tiro Devanagari Hindi": {
    "link": "https://fonts.googleapis.com/css?family=Tiro+Devanagari+Hindi:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Tiro Devanagari Hindi', sans-serif"
  },
  "Sancreek": {
    "link": "https://fonts.googleapis.com/css?family=Sancreek:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sancreek', sans-serif"
  },
  "Sree Krushnadevaraya": {
    "link": "https://fonts.googleapis.com/css?family=Sree+Krushnadevaraya:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sree Krushnadevaraya', sans-serif"
  },
  "Poor Story": {
    "link": "https://fonts.googleapis.com/css?family=Poor+Story:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Poor Story', sans-serif"
  },
  "Stint Ultra Expanded": {
    "link": "https://fonts.googleapis.com/css?family=Stint+Ultra+Expanded:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Stint Ultra Expanded', sans-serif"
  },
  "Protest Riot": {
    "link": "https://fonts.googleapis.com/css?family=Protest+Riot:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Protest Riot', sans-serif"
  },
  "Marhey": {
    "link": "https://fonts.googleapis.com/css?family=Marhey:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Marhey', sans-serif"
  },
  "Mystery Quest": {
    "link": "https://fonts.googleapis.com/css?family=Mystery+Quest:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mystery Quest', sans-serif"
  },
  "Engagement": {
    "link": "https://fonts.googleapis.com/css?family=Engagement:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Engagement', sans-serif"
  },
  "Buda": {
    "link": "https://fonts.googleapis.com/css?family=Buda:wght@0,300&subset=latin&display=swap",
    "fontFamily": "'Buda', sans-serif"
  },
  "Junge": {
    "link": "https://fonts.googleapis.com/css?family=Junge:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Junge', sans-serif"
  },
  "Redacted": {
    "link": "https://fonts.googleapis.com/css?family=Redacted:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Redacted', sans-serif"
  },
  "Eagle Lake": {
    "link": "https://fonts.googleapis.com/css?family=Eagle+Lake:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Eagle Lake', sans-serif"
  },
  "Underdog": {
    "link": "https://fonts.googleapis.com/css?family=Underdog:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Underdog', sans-serif"
  },
  "Anta": {
    "link": "https://fonts.googleapis.com/css?family=Anta:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Anta', sans-serif"
  },
  "Finlandica": {
    "link": "https://fonts.googleapis.com/css?family=Finlandica:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Finlandica', sans-serif"
  },
  "Averia Gruesa Libre": {
    "link": "https://fonts.googleapis.com/css?family=Averia+Gruesa+Libre:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Averia Gruesa Libre', sans-serif"
  },
  "Moon Dance": {
    "link": "https://fonts.googleapis.com/css?family=Moon+Dance:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Moon Dance', sans-serif"
  },
  "Girassol": {
    "link": "https://fonts.googleapis.com/css?family=Girassol:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Girassol', sans-serif"
  },
  "Sura": {
    "link": "https://fonts.googleapis.com/css?family=Sura:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Sura', sans-serif"
  },
  "Beth Ellen": {
    "link": "https://fonts.googleapis.com/css?family=Beth+Ellen:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Beth Ellen', sans-serif"
  },
  "Genos": {
    "link": "https://fonts.googleapis.com/css?family=Genos:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Genos', sans-serif"
  },
  "Martian Mono": {
    "link": "https://fonts.googleapis.com/css?family=Martian+Mono:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Martian Mono', sans-serif"
  },
  "Caesar Dressing": {
    "link": "https://fonts.googleapis.com/css?family=Caesar+Dressing:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Caesar Dressing', sans-serif"
  },
  "Dorsa": {
    "link": "https://fonts.googleapis.com/css?family=Dorsa:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Dorsa', sans-serif"
  },
  "Keania One": {
    "link": "https://fonts.googleapis.com/css?family=Keania+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Keania One', sans-serif"
  },
  "Seymour One": {
    "link": "https://fonts.googleapis.com/css?family=Seymour+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Seymour One', sans-serif"
  },
  "Jacques Francois": {
    "link": "https://fonts.googleapis.com/css?family=Jacques+Francois:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Jacques Francois', sans-serif"
  },
  "Sarina": {
    "link": "https://fonts.googleapis.com/css?family=Sarina:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sarina', sans-serif"
  },
  "Fascinate Inline": {
    "link": "https://fonts.googleapis.com/css?family=Fascinate+Inline:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Fascinate Inline', sans-serif"
  },
  "IM Fell French Canon SC": {
    "link": "https://fonts.googleapis.com/css?family=IM+Fell+French+Canon+SC:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'IM Fell French Canon SC', sans-serif"
  },
  "Offside": {
    "link": "https://fonts.googleapis.com/css?family=Offside:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Offside', sans-serif"
  },
  "Asset": {
    "link": "https://fonts.googleapis.com/css?family=Asset:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Asset', sans-serif"
  },
  "Chicle": {
    "link": "https://fonts.googleapis.com/css?family=Chicle:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Chicle', sans-serif"
  },
  "Licorice": {
    "link": "https://fonts.googleapis.com/css?family=Licorice:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Licorice', sans-serif"
  },
  "Cagliostro": {
    "link": "https://fonts.googleapis.com/css?family=Cagliostro:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Cagliostro', sans-serif"
  },
  "Port Lligat Slab": {
    "link": "https://fonts.googleapis.com/css?family=Port+Lligat+Slab:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Port Lligat Slab', sans-serif"
  },
  "Texturina": {
    "link": "https://fonts.googleapis.com/css?family=Texturina:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Texturina', sans-serif"
  },
  "Smythe": {
    "link": "https://fonts.googleapis.com/css?family=Smythe:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Smythe', sans-serif"
  },
  "Charis SIL": {
    "link": "https://fonts.googleapis.com/css?family=Charis+SIL:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Charis SIL', sans-serif"
  },
  "Vampiro One": {
    "link": "https://fonts.googleapis.com/css?family=Vampiro+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Vampiro One', sans-serif"
  },
  "Srisakdi": {
    "link": "https://fonts.googleapis.com/css?family=Srisakdi:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Srisakdi', sans-serif"
  },
  "Waterfall": {
    "link": "https://fonts.googleapis.com/css?family=Waterfall:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Waterfall', sans-serif"
  },
  "Anek Devanagari": {
    "link": "https://fonts.googleapis.com/css?family=Anek+Devanagari:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Anek Devanagari', sans-serif"
  },
  "Bruno Ace SC": {
    "link": "https://fonts.googleapis.com/css?family=Bruno+Ace+SC:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bruno Ace SC', sans-serif"
  },
  "Kenia": {
    "link": "https://fonts.googleapis.com/css?family=Kenia:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kenia', sans-serif"
  },
  "Bungee Hairline": {
    "link": "https://fonts.googleapis.com/css?family=Bungee+Hairline:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bungee Hairline', sans-serif"
  },
  "Passions Conflict": {
    "link": "https://fonts.googleapis.com/css?family=Passions+Conflict:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Passions Conflict', sans-serif"
  },
  "Comforter": {
    "link": "https://fonts.googleapis.com/css?family=Comforter:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Comforter', sans-serif"
  },
  "Jim Nightshade": {
    "link": "https://fonts.googleapis.com/css?family=Jim+Nightshade:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Jim Nightshade', sans-serif"
  },
  "Felipa": {
    "link": "https://fonts.googleapis.com/css?family=Felipa:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Felipa', sans-serif"
  },
  "Text Me One": {
    "link": "https://fonts.googleapis.com/css?family=Text+Me+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Text Me One', sans-serif"
  },
  "Imbue": {
    "link": "https://fonts.googleapis.com/css?family=Imbue:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Imbue', sans-serif"
  },
  "Rubik Gemstones": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Gemstones:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Gemstones', sans-serif"
  },
  "Lexend Peta": {
    "link": "https://fonts.googleapis.com/css?family=Lexend+Peta:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Lexend Peta', sans-serif"
  },
  "Marko One": {
    "link": "https://fonts.googleapis.com/css?family=Marko+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Marko One', sans-serif"
  },
  "Bilbo": {
    "link": "https://fonts.googleapis.com/css?family=Bilbo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bilbo', sans-serif"
  },
  "Aoboshi One": {
    "link": "https://fonts.googleapis.com/css?family=Aoboshi+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Aoboshi One', sans-serif"
  },
  "Noto Sans Thai Looped": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Thai+Looped:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Thai Looped', sans-serif"
  },
  "Molle": {
    "link": "https://fonts.googleapis.com/css?family=Molle:ital,wght@1,400&subset=latin&display=swap",
    "fontFamily": "'Molle', sans-serif"
  },
  "Nova Slim": {
    "link": "https://fonts.googleapis.com/css?family=Nova+Slim:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Nova Slim', sans-serif"
  },
  "Kavoon": {
    "link": "https://fonts.googleapis.com/css?family=Kavoon:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kavoon', sans-serif"
  },
  "Praise": {
    "link": "https://fonts.googleapis.com/css?family=Praise:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Praise', sans-serif"
  },
  "Englebert": {
    "link": "https://fonts.googleapis.com/css?family=Englebert:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Englebert', sans-serif"
  },
  "Kumar One": {
    "link": "https://fonts.googleapis.com/css?family=Kumar+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kumar One', sans-serif"
  },
  "Yeon Sung": {
    "link": "https://fonts.googleapis.com/css?family=Yeon+Sung:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Yeon Sung', sans-serif"
  },
  "Tiro Bangla": {
    "link": "https://fonts.googleapis.com/css?family=Tiro+Bangla:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Tiro Bangla', sans-serif"
  },
  "Simonetta": {
    "link": "https://fonts.googleapis.com/css?family=Simonetta:ital,wght@0,400;1,400;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Simonetta', sans-serif"
  },
  "Spirax": {
    "link": "https://fonts.googleapis.com/css?family=Spirax:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Spirax', sans-serif"
  },
  "IM Fell Great Primer SC": {
    "link": "https://fonts.googleapis.com/css?family=IM+Fell+Great+Primer+SC:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'IM Fell Great Primer SC', sans-serif"
  },
  "Astloch": {
    "link": "https://fonts.googleapis.com/css?family=Astloch:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Astloch', sans-serif"
  },
  "Libre Barcode 39 Extended": {
    "link": "https://fonts.googleapis.com/css?family=Libre+Barcode+39+Extended:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Libre Barcode 39 Extended', sans-serif"
  },
  "Chilanka": {
    "link": "https://fonts.googleapis.com/css?family=Chilanka:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Chilanka', sans-serif"
  },
  "Phudu": {
    "link": "https://fonts.googleapis.com/css?family=Phudu:wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Phudu', sans-serif"
  },
  "Shippori Antique B1": {
    "link": "https://fonts.googleapis.com/css?family=Shippori+Antique+B1:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Shippori Antique B1', sans-serif"
  },
  "New Rocker": {
    "link": "https://fonts.googleapis.com/css?family=New+Rocker:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'New Rocker', sans-serif"
  },
  "Zhi Mang Xing": {
    "link": "https://fonts.googleapis.com/css?family=Zhi+Mang+Xing:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Zhi Mang Xing', sans-serif"
  },
  "Noto Sans Symbols 2": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Symbols+2:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Symbols 2', sans-serif"
  },
  "Birthstone Bounce": {
    "link": "https://fonts.googleapis.com/css?family=Birthstone+Bounce:wght@0,400;0,500&subset=latin&display=swap",
    "fontFamily": "'Birthstone Bounce', sans-serif"
  },
  "Arbutus": {
    "link": "https://fonts.googleapis.com/css?family=Arbutus:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Arbutus', sans-serif"
  },
  "Kavivanar": {
    "link": "https://fonts.googleapis.com/css?family=Kavivanar:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kavivanar', sans-serif"
  },
  "The Nautigal": {
    "link": "https://fonts.googleapis.com/css?family=The+Nautigal:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'The Nautigal', sans-serif"
  },
  "Nova Script": {
    "link": "https://fonts.googleapis.com/css?family=Nova+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Nova Script', sans-serif"
  },
  "M PLUS 1 Code": {
    "link": "https://fonts.googleapis.com/css?family=M+PLUS+1+Code:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'M PLUS 1 Code', sans-serif"
  },
  "Wellfleet": {
    "link": "https://fonts.googleapis.com/css?family=Wellfleet:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Wellfleet', sans-serif"
  },
  "Miltonian Tattoo": {
    "link": "https://fonts.googleapis.com/css?family=Miltonian+Tattoo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Miltonian Tattoo', sans-serif"
  },
  "Benne": {
    "link": "https://fonts.googleapis.com/css?family=Benne:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Benne', sans-serif"
  },
  "IM Fell Double Pica SC": {
    "link": "https://fonts.googleapis.com/css?family=IM+Fell+Double+Pica+SC:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'IM Fell Double Pica SC', sans-serif"
  },
  "Tilt Neon": {
    "link": "https://fonts.googleapis.com/css?family=Tilt+Neon:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Tilt Neon', sans-serif"
  },
  "Beau Rivage": {
    "link": "https://fonts.googleapis.com/css?family=Beau+Rivage:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Beau Rivage', sans-serif"
  },
  "Nova Cut": {
    "link": "https://fonts.googleapis.com/css?family=Nova+Cut:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Nova Cut', sans-serif"
  },
  "Carattere": {
    "link": "https://fonts.googleapis.com/css?family=Carattere:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Carattere', sans-serif"
  },
  "Tilt Prism": {
    "link": "https://fonts.googleapis.com/css?family=Tilt+Prism:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Tilt Prism', sans-serif"
  },
  "Inika": {
    "link": "https://fonts.googleapis.com/css?family=Inika:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Inika', sans-serif"
  },
  "Fascinate": {
    "link": "https://fonts.googleapis.com/css?family=Fascinate:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Fascinate', sans-serif"
  },
  "Ruluko": {
    "link": "https://fonts.googleapis.com/css?family=Ruluko:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ruluko', sans-serif"
  },
  "Condiment": {
    "link": "https://fonts.googleapis.com/css?family=Condiment:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Condiment', sans-serif"
  },
  "Romanesco": {
    "link": "https://fonts.googleapis.com/css?family=Romanesco:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Romanesco', sans-serif"
  },
  "Mrs Sheppards": {
    "link": "https://fonts.googleapis.com/css?family=Mrs+Sheppards:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mrs Sheppards', sans-serif"
  },
  "Kirang Haerang": {
    "link": "https://fonts.googleapis.com/css?family=Kirang+Haerang:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kirang Haerang', sans-serif"
  },
  "Rubik Doodle Shadow": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Doodle+Shadow:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Doodle Shadow', sans-serif"
  },
  "Nova Oval": {
    "link": "https://fonts.googleapis.com/css?family=Nova+Oval:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Nova Oval', sans-serif"
  },
  "Carlito": {
    "link": "https://fonts.googleapis.com/css?family=Carlito:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Carlito', sans-serif"
  },
  "Liu Jian Mao Cao": {
    "link": "https://fonts.googleapis.com/css?family=Liu+Jian+Mao+Cao:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Liu Jian Mao Cao', sans-serif"
  },
  "New Tegomin": {
    "link": "https://fonts.googleapis.com/css?family=New+Tegomin:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'New Tegomin', sans-serif"
  },
  "Akatab": {
    "link": "https://fonts.googleapis.com/css?family=Akatab:wght@0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Akatab', sans-serif"
  },
  "Tulpen One": {
    "link": "https://fonts.googleapis.com/css?family=Tulpen+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Tulpen One', sans-serif"
  },
  "Plaster": {
    "link": "https://fonts.googleapis.com/css?family=Plaster:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Plaster', sans-serif"
  },
  "Bahiana": {
    "link": "https://fonts.googleapis.com/css?family=Bahiana:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bahiana', sans-serif"
  },
  "Amiri Quran": {
    "link": "https://fonts.googleapis.com/css?family=Amiri+Quran:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Amiri Quran', sans-serif"
  },
  "Black And White Picture": {
    "link": "https://fonts.googleapis.com/css?family=Black+And+White+Picture:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Black And White Picture', sans-serif"
  },
  "Kode Mono": {
    "link": "https://fonts.googleapis.com/css?family=Kode+Mono:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Kode Mono', sans-serif"
  },
  "Miltonian": {
    "link": "https://fonts.googleapis.com/css?family=Miltonian:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Miltonian', sans-serif"
  },
  "BIZ UDMincho": {
    "link": "https://fonts.googleapis.com/css?family=BIZ+UDMincho:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'BIZ UDMincho', sans-serif"
  },
  "Playpen Sans": {
    "link": "https://fonts.googleapis.com/css?family=Playpen+Sans:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Playpen Sans', sans-serif"
  },
  "Noto Sans Lao": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Lao:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Lao', sans-serif"
  },
  "Yaldevi": {
    "link": "https://fonts.googleapis.com/css?family=Yaldevi:wght@0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Yaldevi', sans-serif"
  },
  "Imperial Script": {
    "link": "https://fonts.googleapis.com/css?family=Imperial+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Imperial Script', sans-serif"
  },
  "Sedgwick Ave Display": {
    "link": "https://fonts.googleapis.com/css?family=Sedgwick+Ave+Display:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sedgwick Ave Display', sans-serif"
  },
  "Piedra": {
    "link": "https://fonts.googleapis.com/css?family=Piedra:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Piedra', sans-serif"
  },
  "Gentium Book Plus": {
    "link": "https://fonts.googleapis.com/css?family=Gentium+Book+Plus:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Gentium Book Plus', sans-serif"
  },
  "Trispace": {
    "link": "https://fonts.googleapis.com/css?family=Trispace:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Trispace', sans-serif"
  },
  "Ravi Prakash": {
    "link": "https://fonts.googleapis.com/css?family=Ravi+Prakash:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ravi Prakash', sans-serif"
  },
  "Big Shoulders Stencil Display": {
    "link": "https://fonts.googleapis.com/css?family=Big+Shoulders+Stencil+Display:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Big Shoulders Stencil Display', sans-serif"
  },
  "Protest Strike": {
    "link": "https://fonts.googleapis.com/css?family=Protest+Strike:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Protest Strike', sans-serif"
  },
  "Long Cang": {
    "link": "https://fonts.googleapis.com/css?family=Long+Cang:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Long Cang', sans-serif"
  },
  "Elsie Swash Caps": {
    "link": "https://fonts.googleapis.com/css?family=Elsie+Swash+Caps:wght@0,400;0,900&subset=latin&display=swap",
    "fontFamily": "'Elsie Swash Caps', sans-serif"
  },
  "Noto Sans Cham": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Cham:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Cham', sans-serif"
  },
  "Glass Antiqua": {
    "link": "https://fonts.googleapis.com/css?family=Glass+Antiqua:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Glass Antiqua', sans-serif"
  },
  "Sono": {
    "link": "https://fonts.googleapis.com/css?family=Sono:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Sono', sans-serif"
  },
  "Kumar One Outline": {
    "link": "https://fonts.googleapis.com/css?family=Kumar+One+Outline:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kumar One Outline', sans-serif"
  },
  "Anek Tamil": {
    "link": "https://fonts.googleapis.com/css?family=Anek+Tamil:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Anek Tamil', sans-serif"
  },
  "Risque": {
    "link": "https://fonts.googleapis.com/css?family=Risque:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Risque', sans-serif"
  },
  "Bonheur Royale": {
    "link": "https://fonts.googleapis.com/css?family=Bonheur+Royale:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bonheur Royale', sans-serif"
  },
  "Smokum": {
    "link": "https://fonts.googleapis.com/css?family=Smokum:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Smokum', sans-serif"
  },
  "Gupter": {
    "link": "https://fonts.googleapis.com/css?family=Gupter:wght@0,400;0,500;0,700&subset=latin&display=swap",
    "fontFamily": "'Gupter', sans-serif"
  },
  "Luxurious Script": {
    "link": "https://fonts.googleapis.com/css?family=Luxurious+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Luxurious Script', sans-serif"
  },
  "Oldenburg": {
    "link": "https://fonts.googleapis.com/css?family=Oldenburg:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Oldenburg', sans-serif"
  },
  "Londrina Shadow": {
    "link": "https://fonts.googleapis.com/css?family=Londrina+Shadow:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Londrina Shadow', sans-serif"
  },
  "Atomic Age": {
    "link": "https://fonts.googleapis.com/css?family=Atomic+Age:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Atomic Age', sans-serif"
  },
  "Princess Sofia": {
    "link": "https://fonts.googleapis.com/css?family=Princess+Sofia:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Princess Sofia', sans-serif"
  },
  "Alumni Sans Inline One": {
    "link": "https://fonts.googleapis.com/css?family=Alumni+Sans+Inline+One:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Alumni Sans Inline One', sans-serif"
  },
  "Odor Mean Chey": {
    "link": "https://fonts.googleapis.com/css?family=Odor+Mean+Chey:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Odor Mean Chey', sans-serif"
  },
  "Linden Hill": {
    "link": "https://fonts.googleapis.com/css?family=Linden+Hill:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Linden Hill', sans-serif"
  },
  "Ribeye Marrow": {
    "link": "https://fonts.googleapis.com/css?family=Ribeye+Marrow:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ribeye Marrow', sans-serif"
  },
  "Noto Sans Ethiopic": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Ethiopic:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Ethiopic', sans-serif"
  },
  "Water Brush": {
    "link": "https://fonts.googleapis.com/css?family=Water+Brush:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Water Brush', sans-serif"
  },
  "Galindo": {
    "link": "https://fonts.googleapis.com/css?family=Galindo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Galindo', sans-serif"
  },
  "Afacad": {
    "link": "https://fonts.googleapis.com/css?family=Afacad:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Afacad', sans-serif"
  },
  "Rock 3D": {
    "link": "https://fonts.googleapis.com/css?family=Rock+3D:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rock 3D', sans-serif"
  },
  "Rethink Sans": {
    "link": "https://fonts.googleapis.com/css?family=Rethink+Sans:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800&subset=latin&display=swap",
    "fontFamily": "'Rethink Sans', sans-serif"
  },
  "Braah One": {
    "link": "https://fonts.googleapis.com/css?family=Braah+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Braah One', sans-serif"
  },
  "Federant": {
    "link": "https://fonts.googleapis.com/css?family=Federant:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Federant', sans-serif"
  },
  "Belanosima": {
    "link": "https://fonts.googleapis.com/css?family=Belanosima:wght@0,400;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Belanosima', sans-serif"
  },
  "Joti One": {
    "link": "https://fonts.googleapis.com/css?family=Joti+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Joti One', sans-serif"
  },
  "Sahitya": {
    "link": "https://fonts.googleapis.com/css?family=Sahitya:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Sahitya', sans-serif"
  },
  "Sirin Stencil": {
    "link": "https://fonts.googleapis.com/css?family=Sirin+Stencil:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sirin Stencil', sans-serif"
  },
  "Noto Serif Armenian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Armenian:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Armenian', sans-serif"
  },
  "Anek Gujarati": {
    "link": "https://fonts.googleapis.com/css?family=Anek+Gujarati:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Anek Gujarati', sans-serif"
  },
  "DynaPuff": {
    "link": "https://fonts.googleapis.com/css?family=DynaPuff:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'DynaPuff', sans-serif"
  },
  "Almendra SC": {
    "link": "https://fonts.googleapis.com/css?family=Almendra+SC:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Almendra SC', sans-serif"
  },
  "Chela One": {
    "link": "https://fonts.googleapis.com/css?family=Chela+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Chela One', sans-serif"
  },
  "Jacques Francois Shadow": {
    "link": "https://fonts.googleapis.com/css?family=Jacques+Francois+Shadow:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Jacques Francois Shadow', sans-serif"
  },
  "Big Shoulders Stencil Text": {
    "link": "https://fonts.googleapis.com/css?family=Big+Shoulders+Stencil+Text:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Big Shoulders Stencil Text', sans-serif"
  },
  "Lancelot": {
    "link": "https://fonts.googleapis.com/css?family=Lancelot:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Lancelot', sans-serif"
  },
  "Encode Sans SC": {
    "link": "https://fonts.googleapis.com/css?family=Encode+Sans+SC:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Encode Sans SC', sans-serif"
  },
  "Bahianita": {
    "link": "https://fonts.googleapis.com/css?family=Bahianita:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bahianita', sans-serif"
  },
  "Bungee Spice": {
    "link": "https://fonts.googleapis.com/css?family=Bungee+Spice:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bungee Spice', sans-serif"
  },
  "Griffy": {
    "link": "https://fonts.googleapis.com/css?family=Griffy:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Griffy', sans-serif"
  },
  "Revalia": {
    "link": "https://fonts.googleapis.com/css?family=Revalia:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Revalia', sans-serif"
  },
  "Lakki Reddy": {
    "link": "https://fonts.googleapis.com/css?family=Lakki+Reddy:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Lakki Reddy', sans-serif"
  },
  "Gentium Plus": {
    "link": "https://fonts.googleapis.com/css?family=Gentium+Plus:ital,wght@0,400;1,400;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Gentium Plus', sans-serif"
  },
  "Noto Sans Gothic": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Gothic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Gothic', sans-serif"
  },
  "Zen Tokyo Zoo": {
    "link": "https://fonts.googleapis.com/css?family=Zen+Tokyo+Zoo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Zen Tokyo Zoo', sans-serif"
  },
  "Lavishly Yours": {
    "link": "https://fonts.googleapis.com/css?family=Lavishly+Yours:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Lavishly Yours', sans-serif"
  },
  "Preahvihear": {
    "link": "https://fonts.googleapis.com/css?family=Preahvihear:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Preahvihear', sans-serif"
  },
  "Flavors": {
    "link": "https://fonts.googleapis.com/css?family=Flavors:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Flavors', sans-serif"
  },
  "Dhurjati": {
    "link": "https://fonts.googleapis.com/css?family=Dhurjati:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Dhurjati', sans-serif"
  },
  "Emblema One": {
    "link": "https://fonts.googleapis.com/css?family=Emblema+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Emblema One', sans-serif"
  },
  "Victor Mono": {
    "link": "https://fonts.googleapis.com/css?family=Victor+Mono:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Victor Mono', sans-serif"
  },
  "Ewert": {
    "link": "https://fonts.googleapis.com/css?family=Ewert:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ewert', sans-serif"
  },
  "Festive": {
    "link": "https://fonts.googleapis.com/css?family=Festive:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Festive', sans-serif"
  },
  "Ysabeau Office": {
    "link": "https://fonts.googleapis.com/css?family=Ysabeau+Office:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Ysabeau Office', sans-serif"
  },
  "Lexend Tera": {
    "link": "https://fonts.googleapis.com/css?family=Lexend+Tera:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Lexend Tera', sans-serif"
  },
  "Ysabeau": {
    "link": "https://fonts.googleapis.com/css?family=Ysabeau:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Ysabeau', sans-serif"
  },
  "Labrada": {
    "link": "https://fonts.googleapis.com/css?family=Labrada:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Labrada', sans-serif"
  },
  "Anek Gurmukhi": {
    "link": "https://fonts.googleapis.com/css?family=Anek+Gurmukhi:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Anek Gurmukhi', sans-serif"
  },
  "Noto Sans Tangsa": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Tangsa:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Tangsa', sans-serif"
  },
  "Dangrek": {
    "link": "https://fonts.googleapis.com/css?family=Dangrek:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Dangrek', sans-serif"
  },
  "Noto Sans Samaritan": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Samaritan:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Samaritan', sans-serif"
  },
  "Diplomata SC": {
    "link": "https://fonts.googleapis.com/css?family=Diplomata+SC:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Diplomata SC', sans-serif"
  },
  "Hubballi": {
    "link": "https://fonts.googleapis.com/css?family=Hubballi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Hubballi', sans-serif"
  },
  "Bungee Outline": {
    "link": "https://fonts.googleapis.com/css?family=Bungee+Outline:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bungee Outline', sans-serif"
  },
  "Libre Barcode EAN13 Text": {
    "link": "https://fonts.googleapis.com/css?family=Libre+Barcode+EAN13+Text:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Libre Barcode EAN13 Text', sans-serif"
  },
  "Stalinist One": {
    "link": "https://fonts.googleapis.com/css?family=Stalinist+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Stalinist One', sans-serif"
  },
  "Dr Sugiyama": {
    "link": "https://fonts.googleapis.com/css?family=Dr+Sugiyama:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Dr Sugiyama', sans-serif"
  },
  "BioRhyme Expanded": {
    "link": "https://fonts.googleapis.com/css?family=BioRhyme+Expanded:wght@0,200;0,300;0,400;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'BioRhyme Expanded', sans-serif"
  },
  "Climate Crisis": {
    "link": "https://fonts.googleapis.com/css?family=Climate+Crisis:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Climate Crisis', sans-serif"
  },
  "Noto Sans Anatolian Hieroglyphs": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Anatolian+Hieroglyphs:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Anatolian Hieroglyphs', sans-serif"
  },
  "Almendra Display": {
    "link": "https://fonts.googleapis.com/css?family=Almendra+Display:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Almendra Display', sans-serif"
  },
  "Snippet": {
    "link": "https://fonts.googleapis.com/css?family=Snippet:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Snippet', sans-serif"
  },
  "Lacquer": {
    "link": "https://fonts.googleapis.com/css?family=Lacquer:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Lacquer', sans-serif"
  },
  "Qahiri": {
    "link": "https://fonts.googleapis.com/css?family=Qahiri:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Qahiri', sans-serif"
  },
  "Solitreo": {
    "link": "https://fonts.googleapis.com/css?family=Solitreo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Solitreo', sans-serif"
  },
  "Noto Sans Lepcha": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Lepcha:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Lepcha', sans-serif"
  },
  "Peddana": {
    "link": "https://fonts.googleapis.com/css?family=Peddana:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Peddana', sans-serif"
  },
  "Bigelow Rules": {
    "link": "https://fonts.googleapis.com/css?family=Bigelow+Rules:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bigelow Rules', sans-serif"
  },
  "Erica One": {
    "link": "https://fonts.googleapis.com/css?family=Erica+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Erica One', sans-serif"
  },
  "Sometype Mono": {
    "link": "https://fonts.googleapis.com/css?family=Sometype+Mono:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&subset=latin&display=swap",
    "fontFamily": "'Sometype Mono', sans-serif"
  },
  "Cairo Play": {
    "link": "https://fonts.googleapis.com/css?family=Cairo+Play:wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Cairo Play', sans-serif"
  },
  "Borel": {
    "link": "https://fonts.googleapis.com/css?family=Borel:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Borel', sans-serif"
  },
  "Butcherman": {
    "link": "https://fonts.googleapis.com/css?family=Butcherman:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Butcherman', sans-serif"
  },
  "Noto Sans Tai Viet": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Tai+Viet:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Tai Viet', sans-serif"
  },
  "Koh Santepheap": {
    "link": "https://fonts.googleapis.com/css?family=Koh+Santepheap:wght@0,100;0,300;0,400;0,700;0,900&subset=latin&display=swap",
    "fontFamily": "'Koh Santepheap', sans-serif"
  },
  "Big Shoulders Inline Text": {
    "link": "https://fonts.googleapis.com/css?family=Big+Shoulders+Inline+Text:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Big Shoulders Inline Text', sans-serif"
  },
  "Edu TAS Beginner": {
    "link": "https://fonts.googleapis.com/css?family=Edu+TAS+Beginner:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Edu TAS Beginner', sans-serif"
  },
  "Noto Sans Osmanya": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Osmanya:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Osmanya', sans-serif"
  },
  "Devonshire": {
    "link": "https://fonts.googleapis.com/css?family=Devonshire:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Devonshire', sans-serif"
  },
  "Mea Culpa": {
    "link": "https://fonts.googleapis.com/css?family=Mea+Culpa:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mea Culpa', sans-serif"
  },
  "Inspiration": {
    "link": "https://fonts.googleapis.com/css?family=Inspiration:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Inspiration', sans-serif"
  },
  "IBM Plex Sans Devanagari": {
    "link": "https://fonts.googleapis.com/css?family=IBM+Plex+Sans+Devanagari:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'IBM Plex Sans Devanagari', sans-serif"
  },
  "Gidugu": {
    "link": "https://fonts.googleapis.com/css?family=Gidugu:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gidugu', sans-serif"
  },
  "Agdasima": {
    "link": "https://fonts.googleapis.com/css?family=Agdasima:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Agdasima', sans-serif"
  },
  "Bokor": {
    "link": "https://fonts.googleapis.com/css?family=Bokor:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bokor', sans-serif"
  },
  "Tiro Telugu": {
    "link": "https://fonts.googleapis.com/css?family=Tiro+Telugu:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Tiro Telugu', sans-serif"
  },
  "Lumanosimo": {
    "link": "https://fonts.googleapis.com/css?family=Lumanosimo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Lumanosimo', sans-serif"
  },
  "Tiro Devanagari Sanskrit": {
    "link": "https://fonts.googleapis.com/css?family=Tiro+Devanagari+Sanskrit:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Tiro Devanagari Sanskrit', sans-serif"
  },
  "Rubik Glitch": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Glitch:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Glitch', sans-serif"
  },
  "Noto Sans Glagolitic": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Glagolitic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Glagolitic', sans-serif"
  },
  "Mr Bedfort": {
    "link": "https://fonts.googleapis.com/css?family=Mr+Bedfort:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mr Bedfort', sans-serif"
  },
  "Vibes": {
    "link": "https://fonts.googleapis.com/css?family=Vibes:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Vibes', sans-serif"
  },
  "Combo": {
    "link": "https://fonts.googleapis.com/css?family=Combo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Combo', sans-serif"
  },
  "Passero One": {
    "link": "https://fonts.googleapis.com/css?family=Passero+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Passero One', sans-serif"
  },
  "Londrina Sketch": {
    "link": "https://fonts.googleapis.com/css?family=Londrina+Sketch:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Londrina Sketch', sans-serif"
  },
  "Foldit": {
    "link": "https://fonts.googleapis.com/css?family=Foldit:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Foldit', sans-serif"
  },
  "Ysabeau Infant": {
    "link": "https://fonts.googleapis.com/css?family=Ysabeau+Infant:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Ysabeau Infant', sans-serif"
  },
  "Noto Serif Kannada": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Kannada:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Kannada', sans-serif"
  },
  "Konkhmer Sleokchher": {
    "link": "https://fonts.googleapis.com/css?family=Konkhmer+Sleokchher:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Konkhmer Sleokchher', sans-serif"
  },
  "Diplomata": {
    "link": "https://fonts.googleapis.com/css?family=Diplomata:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Diplomata', sans-serif"
  },
  "Noto Music": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Music:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Music', sans-serif"
  },
  "Metal": {
    "link": "https://fonts.googleapis.com/css?family=Metal:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Metal', sans-serif"
  },
  "Hedvig Letters Serif": {
    "link": "https://fonts.googleapis.com/css?family=Hedvig+Letters+Serif:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Hedvig Letters Serif', sans-serif"
  },
  "Hanalei Fill": {
    "link": "https://fonts.googleapis.com/css?family=Hanalei+Fill:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Hanalei Fill', sans-serif"
  },
  "Alumni Sans Collegiate One": {
    "link": "https://fonts.googleapis.com/css?family=Alumni+Sans+Collegiate+One:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Alumni Sans Collegiate One', sans-serif"
  },
  "Comme": {
    "link": "https://fonts.googleapis.com/css?family=Comme:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Comme', sans-serif"
  },
  "Rubik Distressed": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Distressed:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Distressed', sans-serif"
  },
  "Luxurious Roman": {
    "link": "https://fonts.googleapis.com/css?family=Luxurious+Roman:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Luxurious Roman', sans-serif"
  },
  "Gideon Roman": {
    "link": "https://fonts.googleapis.com/css?family=Gideon+Roman:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gideon Roman', sans-serif"
  },
  "Neonderthaw": {
    "link": "https://fonts.googleapis.com/css?family=Neonderthaw:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Neonderthaw', sans-serif"
  },
  "Joan": {
    "link": "https://fonts.googleapis.com/css?family=Joan:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Joan', sans-serif"
  },
  "Noto Serif Khojki": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Khojki:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Khojki', sans-serif"
  },
  "Aubrey": {
    "link": "https://fonts.googleapis.com/css?family=Aubrey:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Aubrey', sans-serif"
  },
  "Gasoek One": {
    "link": "https://fonts.googleapis.com/css?family=Gasoek+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gasoek One', sans-serif"
  },
  "Micro 5": {
    "link": "https://fonts.googleapis.com/css?family=Micro+5:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Micro 5', sans-serif"
  },
  "Anek Kannada": {
    "link": "https://fonts.googleapis.com/css?family=Anek+Kannada:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Anek Kannada', sans-serif"
  },
  "Rubik Wet Paint": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Wet+Paint:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Wet Paint', sans-serif"
  },
  "Fruktur": {
    "link": "https://fonts.googleapis.com/css?family=Fruktur:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Fruktur', sans-serif"
  },
  "Rubik Iso": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Iso:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Iso', sans-serif"
  },
  "Tourney": {
    "link": "https://fonts.googleapis.com/css?family=Tourney:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Tourney', sans-serif"
  },
  "Miss Fajardose": {
    "link": "https://fonts.googleapis.com/css?family=Miss+Fajardose:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Miss Fajardose', sans-serif"
  },
  "Noto Serif Khmer": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Khmer:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Khmer', sans-serif"
  },
  "Ballet": {
    "link": "https://fonts.googleapis.com/css?family=Ballet:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ballet', sans-serif"
  },
  "Rubik Beastly": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Beastly:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Beastly', sans-serif"
  },
  "Butterfly Kids": {
    "link": "https://fonts.googleapis.com/css?family=Butterfly+Kids:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Butterfly Kids', sans-serif"
  },
  "Uchen": {
    "link": "https://fonts.googleapis.com/css?family=Uchen:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Uchen', sans-serif"
  },
  "Redacted Script": {
    "link": "https://fonts.googleapis.com/css?family=Redacted+Script:wght@0,300;0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Redacted Script', sans-serif"
  },
  "Noto Serif Sinhala": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Sinhala:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Sinhala', sans-serif"
  },
  "Babylonica": {
    "link": "https://fonts.googleapis.com/css?family=Babylonica:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Babylonica', sans-serif"
  },
  "Reem Kufi Fun": {
    "link": "https://fonts.googleapis.com/css?family=Reem+Kufi+Fun:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Reem Kufi Fun', sans-serif"
  },
  "Island Moments": {
    "link": "https://fonts.googleapis.com/css?family=Island+Moments:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Island Moments', sans-serif"
  },
  "Caramel": {
    "link": "https://fonts.googleapis.com/css?family=Caramel:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Caramel', sans-serif"
  },
  "Gwendolyn": {
    "link": "https://fonts.googleapis.com/css?family=Gwendolyn:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Gwendolyn', sans-serif"
  },
  "Jacquarda Bastarda 9": {
    "link": "https://fonts.googleapis.com/css?family=Jacquarda+Bastarda+9:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Jacquarda Bastarda 9', sans-serif"
  },
  "Anek Odia": {
    "link": "https://fonts.googleapis.com/css?family=Anek+Odia:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Anek Odia', sans-serif"
  },
  "Bagel Fat One": {
    "link": "https://fonts.googleapis.com/css?family=Bagel+Fat+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bagel Fat One', sans-serif"
  },
  "Honk": {
    "link": "https://fonts.googleapis.com/css?family=Honk:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Honk', sans-serif"
  },
  "Tiro Devanagari Marathi": {
    "link": "https://fonts.googleapis.com/css?family=Tiro+Devanagari+Marathi:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Tiro Devanagari Marathi', sans-serif"
  },
  "Noto Serif Vithkuqi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Vithkuqi:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Vithkuqi', sans-serif"
  },
  "Love Light": {
    "link": "https://fonts.googleapis.com/css?family=Love+Light:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Love Light', sans-serif"
  },
  "Annapurna SIL": {
    "link": "https://fonts.googleapis.com/css?family=Annapurna+SIL:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Annapurna SIL', sans-serif"
  },
  "Trochut": {
    "link": "https://fonts.googleapis.com/css?family=Trochut:ital,wght@0,400;1,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Trochut', sans-serif"
  },
  "Yuji Boku": {
    "link": "https://fonts.googleapis.com/css?family=Yuji+Boku:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Yuji Boku', sans-serif"
  },
  "Mooli": {
    "link": "https://fonts.googleapis.com/css?family=Mooli:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mooli', sans-serif"
  },
  "Updock": {
    "link": "https://fonts.googleapis.com/css?family=Updock:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Updock', sans-serif"
  },
  "Namdhinggo": {
    "link": "https://fonts.googleapis.com/css?family=Namdhinggo:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Namdhinggo', sans-serif"
  },
  "Nabla": {
    "link": "https://fonts.googleapis.com/css?family=Nabla:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Nabla', sans-serif"
  },
  "Snowburst One": {
    "link": "https://fonts.googleapis.com/css?family=Snowburst+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Snowburst One', sans-serif"
  },
  "Geostar": {
    "link": "https://fonts.googleapis.com/css?family=Geostar:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Geostar', sans-serif"
  },
  "Sofadi One": {
    "link": "https://fonts.googleapis.com/css?family=Sofadi+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sofadi One', sans-serif"
  },
  "Tai Heritage Pro": {
    "link": "https://fonts.googleapis.com/css?family=Tai+Heritage+Pro:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Tai Heritage Pro', sans-serif"
  },
  "Suravaram": {
    "link": "https://fonts.googleapis.com/css?family=Suravaram:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Suravaram', sans-serif"
  },
  "Aref Ruqaa Ink": {
    "link": "https://fonts.googleapis.com/css?family=Aref+Ruqaa+Ink:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Aref Ruqaa Ink', sans-serif"
  },
  "Bruno Ace": {
    "link": "https://fonts.googleapis.com/css?family=Bruno+Ace:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bruno Ace', sans-serif"
  },
  "Ruge Boogie": {
    "link": "https://fonts.googleapis.com/css?family=Ruge+Boogie:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ruge Boogie', sans-serif"
  },
  "Noto Serif Gujarati": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Gujarati:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Gujarati', sans-serif"
  },
  "Moulpali": {
    "link": "https://fonts.googleapis.com/css?family=Moulpali:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Moulpali', sans-serif"
  },
  "Purple Purse": {
    "link": "https://fonts.googleapis.com/css?family=Purple+Purse:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Purple Purse', sans-serif"
  },
  "Hedvig Letters Sans": {
    "link": "https://fonts.googleapis.com/css?family=Hedvig+Letters+Sans:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Hedvig Letters Sans', sans-serif"
  },
  "Castoro Titling": {
    "link": "https://fonts.googleapis.com/css?family=Castoro+Titling:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Castoro Titling', sans-serif"
  },
  "Bonbon": {
    "link": "https://fonts.googleapis.com/css?family=Bonbon:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bonbon', sans-serif"
  },
  "Explora": {
    "link": "https://fonts.googleapis.com/css?family=Explora:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Explora', sans-serif"
  },
  "My Soul": {
    "link": "https://fonts.googleapis.com/css?family=My+Soul:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'My Soul', sans-serif"
  },
  "Noto Rashi Hebrew": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Rashi+Hebrew:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Rashi Hebrew', sans-serif"
  },
  "Mynerve": {
    "link": "https://fonts.googleapis.com/css?family=Mynerve:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mynerve', sans-serif"
  },
  "Nuosu SIL": {
    "link": "https://fonts.googleapis.com/css?family=Nuosu+SIL:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Nuosu SIL', sans-serif"
  },
  "Rubik Vinyl": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Vinyl:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Vinyl', sans-serif"
  },
  "Edu NSW ACT Foundation": {
    "link": "https://fonts.googleapis.com/css?family=Edu+NSW+ACT+Foundation:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Edu NSW ACT Foundation', sans-serif"
  },
  "Langar": {
    "link": "https://fonts.googleapis.com/css?family=Langar:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Langar', sans-serif"
  },
  "Handjet": {
    "link": "https://fonts.googleapis.com/css?family=Handjet:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Handjet', sans-serif"
  },
  "Noto Sans Javanese": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Javanese:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Javanese', sans-serif"
  },
  "Darumadrop One": {
    "link": "https://fonts.googleapis.com/css?family=Darumadrop+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Darumadrop One', sans-serif"
  },
  "Noto Serif Tibetan": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Tibetan:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Tibetan', sans-serif"
  },
  "Cherry Bomb One": {
    "link": "https://fonts.googleapis.com/css?family=Cherry+Bomb+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Cherry Bomb One', sans-serif"
  },
  "Sassy Frass": {
    "link": "https://fonts.googleapis.com/css?family=Sassy+Frass:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sassy Frass', sans-serif"
  },
  "Blaka": {
    "link": "https://fonts.googleapis.com/css?family=Blaka:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Blaka', sans-serif"
  },
  "Yuji Mai": {
    "link": "https://fonts.googleapis.com/css?family=Yuji+Mai:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Yuji Mai', sans-serif"
  },
  "Sigmar": {
    "link": "https://fonts.googleapis.com/css?family=Sigmar:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sigmar', sans-serif"
  },
  "Tiro Tamil": {
    "link": "https://fonts.googleapis.com/css?family=Tiro+Tamil:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Tiro Tamil', sans-serif"
  },
  "Flow Block": {
    "link": "https://fonts.googleapis.com/css?family=Flow+Block:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Flow Block', sans-serif"
  },
  "Reem Kufi Ink": {
    "link": "https://fonts.googleapis.com/css?family=Reem+Kufi+Ink:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Reem Kufi Ink', sans-serif"
  },
  "Protest Guerrilla": {
    "link": "https://fonts.googleapis.com/css?family=Protest+Guerrilla:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Protest Guerrilla', sans-serif"
  },
  "Splash": {
    "link": "https://fonts.googleapis.com/css?family=Splash:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Splash', sans-serif"
  },
  "Taprom": {
    "link": "https://fonts.googleapis.com/css?family=Taprom:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Taprom', sans-serif"
  },
  "Alumni Sans Pinstripe": {
    "link": "https://fonts.googleapis.com/css?family=Alumni+Sans+Pinstripe:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Alumni Sans Pinstripe', sans-serif"
  },
  "Bacasime Antique": {
    "link": "https://fonts.googleapis.com/css?family=Bacasime+Antique:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Bacasime Antique', sans-serif"
  },
  "Oi": {
    "link": "https://fonts.googleapis.com/css?family=Oi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Oi', sans-serif"
  },
  "Tsukimi Rounded": {
    "link": "https://fonts.googleapis.com/css?family=Tsukimi+Rounded:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Tsukimi Rounded', sans-serif"
  },
  "Sixtyfour": {
    "link": "https://fonts.googleapis.com/css?family=Sixtyfour:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Sixtyfour', sans-serif"
  },
  "Noto Sans Mongolian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Mongolian:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Mongolian', sans-serif"
  },
  "Big Shoulders Inline Display": {
    "link": "https://fonts.googleapis.com/css?family=Big+Shoulders+Inline+Display:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Big Shoulders Inline Display', sans-serif"
  },
  "Inclusive Sans": {
    "link": "https://fonts.googleapis.com/css?family=Inclusive+Sans:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Inclusive Sans', sans-serif"
  },
  "Geostar Fill": {
    "link": "https://fonts.googleapis.com/css?family=Geostar+Fill:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Geostar Fill', sans-serif"
  },
  "Flow Rounded": {
    "link": "https://fonts.googleapis.com/css?family=Flow+Rounded:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Flow Rounded', sans-serif"
  },
  "Fleur De Leah": {
    "link": "https://fonts.googleapis.com/css?family=Fleur+De+Leah:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Fleur De Leah', sans-serif"
  },
  "Kolker Brush": {
    "link": "https://fonts.googleapis.com/css?family=Kolker+Brush:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kolker Brush', sans-serif"
  },
  "Edu VIC WA NT Beginner": {
    "link": "https://fonts.googleapis.com/css?family=Edu+VIC+WA+NT+Beginner:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Edu VIC WA NT Beginner', sans-serif"
  },
  "Noto Serif Balinese": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Balinese:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Balinese', sans-serif"
  },
  "Send Flowers": {
    "link": "https://fonts.googleapis.com/css?family=Send+Flowers:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Send Flowers', sans-serif"
  },
  "Moirai One": {
    "link": "https://fonts.googleapis.com/css?family=Moirai+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Moirai One', sans-serif"
  },
  "Syne Tactile": {
    "link": "https://fonts.googleapis.com/css?family=Syne+Tactile:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Syne Tactile', sans-serif"
  },
  "Grechen Fuemen": {
    "link": "https://fonts.googleapis.com/css?family=Grechen+Fuemen:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Grechen Fuemen', sans-serif"
  },
  "Petemoss": {
    "link": "https://fonts.googleapis.com/css?family=Petemoss:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Petemoss', sans-serif"
  },
  "Ysabeau SC": {
    "link": "https://fonts.googleapis.com/css?family=Ysabeau+SC:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Ysabeau SC', sans-serif"
  },
  "Rubik Maps": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Maps:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Maps', sans-serif"
  },
  "Diphylleia": {
    "link": "https://fonts.googleapis.com/css?family=Diphylleia:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Diphylleia', sans-serif"
  },
  "Noto Sans Coptic": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Coptic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Coptic', sans-serif"
  },
  "Dai Banna SIL": {
    "link": "https://fonts.googleapis.com/css?family=Dai+Banna+SIL:ital,wght@0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700&subset=latin&display=swap",
    "fontFamily": "'Dai Banna SIL', sans-serif"
  },
  "Noto Serif Tangut": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Tangut:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Tangut', sans-serif"
  },
  "Are You Serious": {
    "link": "https://fonts.googleapis.com/css?family=Are+You+Serious:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Are You Serious', sans-serif"
  },
  "Zen Loop": {
    "link": "https://fonts.googleapis.com/css?family=Zen+Loop:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Zen Loop', sans-serif"
  },
  "Gajraj One": {
    "link": "https://fonts.googleapis.com/css?family=Gajraj+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Gajraj One', sans-serif"
  },
  "Noto Sans Tagalog": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Tagalog:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Tagalog', sans-serif"
  },
  "Noto Sans Canadian Aboriginal": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Canadian+Aboriginal:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Canadian Aboriginal', sans-serif"
  },
  "Palette Mosaic": {
    "link": "https://fonts.googleapis.com/css?family=Palette+Mosaic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Palette Mosaic', sans-serif"
  },
  "Noto Serif Lao": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Lao:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Lao', sans-serif"
  },
  "Grey Qo": {
    "link": "https://fonts.googleapis.com/css?family=Grey+Qo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Grey Qo', sans-serif"
  },
  "Rubik Glitch Pop": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Glitch+Pop:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Glitch Pop', sans-serif"
  },
  "Noto Sans Syloti Nagri": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Syloti+Nagri:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Syloti Nagri', sans-serif"
  },
  "Noto Serif Tamil": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Tamil:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Tamil', sans-serif"
  },
  "Rubik 80s Fade": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+80s+Fade:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik 80s Fade', sans-serif"
  },
  "Kablammo": {
    "link": "https://fonts.googleapis.com/css?family=Kablammo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kablammo', sans-serif"
  },
  "Rubik Spray Paint": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Spray+Paint:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Spray Paint', sans-serif"
  },
  "Tiro Gurmukhi": {
    "link": "https://fonts.googleapis.com/css?family=Tiro+Gurmukhi:ital,wght@0,400;1,400&subset=latin&display=swap",
    "fontFamily": "'Tiro Gurmukhi', sans-serif"
  },
  "Noto Serif Ethiopic": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Ethiopic:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Ethiopic', sans-serif"
  },
  "Noto Serif NP Hmong": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+NP+Hmong:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Serif NP Hmong', sans-serif"
  },
  "Lunasima": {
    "link": "https://fonts.googleapis.com/css?family=Lunasima:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Lunasima', sans-serif"
  },
  "Shizuru": {
    "link": "https://fonts.googleapis.com/css?family=Shizuru:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Shizuru', sans-serif"
  },
  "Noto Sans Mende Kikakui": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Mende+Kikakui:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Mende Kikakui', sans-serif"
  },
  "Grandiflora One": {
    "link": "https://fonts.googleapis.com/css?family=Grandiflora+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Grandiflora One', sans-serif"
  },
  "Workbench": {
    "link": "https://fonts.googleapis.com/css?family=Workbench:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Workbench', sans-serif"
  },
  "Ruwudu": {
    "link": "https://fonts.googleapis.com/css?family=Ruwudu:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Ruwudu', sans-serif"
  },
  "Noto Serif Toto": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Toto:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Toto', sans-serif"
  },
  "Rubik Scribble": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Scribble:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Scribble', sans-serif"
  },
  "Noto Sans Sora Sompeng": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Sora+Sompeng:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Sora Sompeng', sans-serif"
  },
  "Rubik Pixels": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Pixels:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Pixels', sans-serif"
  },
  "Warnes": {
    "link": "https://fonts.googleapis.com/css?family=Warnes:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Warnes', sans-serif"
  },
  "Rubik Microbe": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Microbe:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Microbe', sans-serif"
  },
  "Estonia": {
    "link": "https://fonts.googleapis.com/css?family=Estonia:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Estonia', sans-serif"
  },
  "Orbit": {
    "link": "https://fonts.googleapis.com/css?family=Orbit:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Orbit', sans-serif"
  },
  "Twinkle Star": {
    "link": "https://fonts.googleapis.com/css?family=Twinkle+Star:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Twinkle Star', sans-serif"
  },
  "Tapestry": {
    "link": "https://fonts.googleapis.com/css?family=Tapestry:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Tapestry', sans-serif"
  },
  "Edu QLD Beginner": {
    "link": "https://fonts.googleapis.com/css?family=Edu+QLD+Beginner:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Edu QLD Beginner', sans-serif"
  },
  "Moo Lah Lah": {
    "link": "https://fonts.googleapis.com/css?family=Moo+Lah+Lah:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Moo Lah Lah', sans-serif"
  },
  "Noto Serif Ottoman Siyaq": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Ottoman+Siyaq:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Ottoman Siyaq', sans-serif"
  },
  "Noto Sans Egyptian Hieroglyphs": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Egyptian+Hieroglyphs:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Egyptian Hieroglyphs', sans-serif"
  },
  "Cherish": {
    "link": "https://fonts.googleapis.com/css?family=Cherish:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Cherish', sans-serif"
  },
  "Blaka Hollow": {
    "link": "https://fonts.googleapis.com/css?family=Blaka+Hollow:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Blaka Hollow', sans-serif"
  },
  "M PLUS Code Latin": {
    "link": "https://fonts.googleapis.com/css?family=M+PLUS+Code+Latin:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'M PLUS Code Latin', sans-serif"
  },
  "Rubik Storm": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Storm:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Storm', sans-serif"
  },
  "Rubik Puddles": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Puddles:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Puddles', sans-serif"
  },
  "Rubik Burned": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Burned:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Burned', sans-serif"
  },
  "Noto Sans Imperial Aramaic": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Imperial+Aramaic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Imperial Aramaic', sans-serif"
  },
  "Lugrasimo": {
    "link": "https://fonts.googleapis.com/css?family=Lugrasimo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Lugrasimo', sans-serif"
  },
  "Hanalei": {
    "link": "https://fonts.googleapis.com/css?family=Hanalei:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Hanalei', sans-serif"
  },
  "Noto Sans Chorasmian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Chorasmian:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Chorasmian', sans-serif"
  },
  "Lisu Bosa": {
    "link": "https://fonts.googleapis.com/css?family=Lisu+Bosa:ital,wght@0,200;1,200;0,300;1,300;0,400;1,400;0,500;1,500;0,600;1,600;0,700;1,700;0,800;1,800;0,900;1,900&subset=latin&display=swap",
    "fontFamily": "'Lisu Bosa', sans-serif"
  },
  "Noto Sans Old Italic": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Old+Italic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Old Italic', sans-serif"
  },
  "Noto Sans Tifinagh": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Tifinagh:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Tifinagh', sans-serif"
  },
  "Ole": {
    "link": "https://fonts.googleapis.com/css?family=Ole:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ole', sans-serif"
  },
  "Noto Sans Thaana": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Thaana:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Thaana', sans-serif"
  },
  "Noto Sans Cherokee": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Cherokee:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Cherokee', sans-serif"
  },
  "Rubik Marker Hatch": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Marker+Hatch:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Marker Hatch', sans-serif"
  },
  "Noto Sans Balinese": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Balinese:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Balinese', sans-serif"
  },
  "Kings": {
    "link": "https://fonts.googleapis.com/css?family=Kings:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Kings', sans-serif"
  },
  "Puppies Play": {
    "link": "https://fonts.googleapis.com/css?family=Puppies+Play:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Puppies Play', sans-serif"
  },
  "Noto Sans Vithkuqi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Vithkuqi:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Vithkuqi', sans-serif"
  },
  "Noto Sans Miao": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Miao:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Miao', sans-serif"
  },
  "Ingrid Darling": {
    "link": "https://fonts.googleapis.com/css?family=Ingrid+Darling:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Ingrid Darling', sans-serif"
  },
  "Blaka Ink": {
    "link": "https://fonts.googleapis.com/css?family=Blaka+Ink:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Blaka Ink', sans-serif"
  },
  "Noto Sans Cypro Minoan": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Cypro+Minoan:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Cypro Minoan', sans-serif"
  },
  "Noto Sans Old Hungarian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Old+Hungarian:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Old Hungarian', sans-serif"
  },
  "Noto Sans Buhid": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Buhid:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Buhid', sans-serif"
  },
  "Noto Serif Ahom": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Ahom:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Ahom', sans-serif"
  },
  "Noto Traditional Nushu": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Traditional+Nushu:wght@0,300;0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Traditional Nushu', sans-serif"
  },
  "Noto Sans Warang Citi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Warang+Citi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Warang Citi', sans-serif"
  },
  "Noto Sans Bamum": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Bamum:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Bamum', sans-serif"
  },
  "Noto Sans Tamil Supplement": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Tamil+Supplement:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Tamil Supplement', sans-serif"
  },
  "Noto Sans Kaithi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Kaithi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Kaithi', sans-serif"
  },
  "Noto Sans Kawi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Kawi:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Kawi', sans-serif"
  },
  "Noto Sans Kayah Li": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Kayah+Li:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Kayah Li', sans-serif"
  },
  "Noto Sans Zanabazar Square": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Zanabazar+Square:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Zanabazar Square', sans-serif"
  },
  "Noto Sans Linear A": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Linear+A:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Linear A', sans-serif"
  },
  "Noto Sans Carian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Carian:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Carian', sans-serif"
  },
  "Noto Sans Nandinagari": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Nandinagari:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Nandinagari', sans-serif"
  },
  "Rubik Broken Fax": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Broken+Fax:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Broken Fax', sans-serif"
  },
  "Noto Serif Oriya": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Oriya:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Oriya', sans-serif"
  },
  "Noto Sans Vai": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Vai:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Vai', sans-serif"
  },
  "Noto Sans Deseret": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Deseret:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Deseret', sans-serif"
  },
  "Noto Sans Nag Mundari": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Nag+Mundari:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Nag Mundari', sans-serif"
  },
  "Yuji Hentaigana Akari": {
    "link": "https://fonts.googleapis.com/css?family=Yuji+Hentaigana+Akari:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Yuji Hentaigana Akari', sans-serif"
  },
  "Rubik Maze": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Maze:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Maze', sans-serif"
  },
  "Noto Sans Bassa Vah": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Bassa+Vah:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Bassa Vah', sans-serif"
  },
  "Rubik Doodle Triangles": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Doodle+Triangles:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Doodle Triangles', sans-serif"
  },
  "Noto Sans Marchen": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Marchen:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Marchen', sans-serif"
  },
  "Mingzat": {
    "link": "https://fonts.googleapis.com/css?family=Mingzat:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Mingzat', sans-serif"
  },
  "Noto Sans Pau Cin Hau": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Pau+Cin+Hau:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Pau Cin Hau', sans-serif"
  },
  "Noto Sans Avestan": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Avestan:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Avestan', sans-serif"
  },
  "Noto Sans Sundanese": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Sundanese:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Sundanese', sans-serif"
  },
  "Noto Sans Masaram Gondi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Masaram+Gondi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Masaram Gondi', sans-serif"
  },
  "Noto Serif Dogra": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Dogra:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Dogra', sans-serif"
  },
  "Kay Pho Du": {
    "link": "https://fonts.googleapis.com/css?family=Kay+Pho+Du:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Kay Pho Du', sans-serif"
  },
  "Noto Sans Old Sogdian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Old+Sogdian:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Old Sogdian', sans-serif"
  },
  "Noto Sans Nushu": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Nushu:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Nushu', sans-serif"
  },
  "Noto Sans Old South Arabian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Old+South+Arabian:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Old South Arabian', sans-serif"
  },
  "Noto Sans Batak": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Batak:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Batak', sans-serif"
  },
  "Rubik Lines": {
    "link": "https://fonts.googleapis.com/css?family=Rubik+Lines:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Rubik Lines', sans-serif"
  },
  "Noto Sans Elymaic": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Elymaic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Elymaic', sans-serif"
  },
  "Noto Sans Soyombo": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Soyombo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Soyombo', sans-serif"
  },
  "Noto Sans Runic": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Runic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Runic', sans-serif"
  },
  "Noto Sans Manichaean": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Manichaean:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Manichaean', sans-serif"
  },
  "Noto Sans Linear B": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Linear+B:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Linear B', sans-serif"
  },
  "Noto Sans Old Persian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Old+Persian:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Old Persian', sans-serif"
  },
  "Noto Sans NKo": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+NKo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans NKo', sans-serif"
  },
  "Noto Sans Limbu": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Limbu:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Limbu', sans-serif"
  },
  "Noto Sans Yi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Yi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Yi', sans-serif"
  },
  "Noto Sans Ugaritic": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Ugaritic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Ugaritic', sans-serif"
  },
  "Noto Sans Pahawh Hmong": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Pahawh+Hmong:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Pahawh Hmong', sans-serif"
  },
  "Noto Serif Yezidi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Yezidi:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Yezidi', sans-serif"
  },
  "Noto Sans Hanunoo": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Hanunoo:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Hanunoo', sans-serif"
  },
  "Noto Sans Tai Tham": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Tai+Tham:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Tai Tham', sans-serif"
  },
  "Noto Sans Inscriptional Pahlavi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Inscriptional+Pahlavi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Inscriptional Pahlavi', sans-serif"
  },
  "Noto Serif Grantha": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Grantha:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Grantha', sans-serif"
  },
  "Noto Sans Sharada": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Sharada:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Sharada', sans-serif"
  },
  "Noto Sans Ol Chiki": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Ol+Chiki:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Ol Chiki', sans-serif"
  },
  "Noto Serif Old Uyghur": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Old+Uyghur:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Old Uyghur', sans-serif"
  },
  "Padyakke Expanded One": {
    "link": "https://fonts.googleapis.com/css?family=Padyakke+Expanded+One:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Padyakke Expanded One', sans-serif"
  },
  "Noto Sans Adlam Unjoined": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Adlam+Unjoined:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Adlam Unjoined', sans-serif"
  },
  "Noto Sans Chakma": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Chakma:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Chakma', sans-serif"
  },
  "Noto Sans Medefaidrin": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Medefaidrin:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Medefaidrin', sans-serif"
  },
  "Noto Sans Khudawadi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Khudawadi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Khudawadi', sans-serif"
  },
  "Noto Sans Brahmi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Brahmi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Brahmi', sans-serif"
  },
  "Noto Serif Khitan Small Script": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Khitan+Small+Script:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Khitan Small Script', sans-serif"
  },
  "Noto Serif Makasar": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Makasar:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Makasar', sans-serif"
  },
  "Yuji Hentaigana Akebono": {
    "link": "https://fonts.googleapis.com/css?family=Yuji+Hentaigana+Akebono:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Yuji Hentaigana Akebono', sans-serif"
  },
  "Noto Sans Tirhuta": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Tirhuta:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Tirhuta', sans-serif"
  },
  "Narnoor": {
    "link": "https://fonts.googleapis.com/css?family=Narnoor:wght@0,400;0,500;0,600;0,700;0,800&subset=latin&display=swap",
    "fontFamily": "'Narnoor', sans-serif"
  },
  "Noto Sans Psalter Pahlavi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Psalter+Pahlavi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Psalter Pahlavi', sans-serif"
  },
  "Noto Sans Cypriot": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Cypriot:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Cypriot', sans-serif"
  },
  "Noto Sans Old Turkic": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Old+Turkic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Old Turkic', sans-serif"
  },
  "Noto Sans Tagbanwa": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Tagbanwa:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Tagbanwa', sans-serif"
  },
  "Noto Sans Indic Siyaq Numbers": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Indic+Siyaq+Numbers:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Indic Siyaq Numbers', sans-serif"
  },
  "Noto Sans Palmyrene": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Palmyrene:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Palmyrene', sans-serif"
  },
  "Noto Sans Modi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Modi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Modi', sans-serif"
  },
  "Noto Sans Lisu": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Lisu:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Lisu', sans-serif"
  },
  "Noto Sans Multani": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Multani:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Multani', sans-serif"
  },
  "Noto Sans Lydian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Lydian:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Lydian', sans-serif"
  },
  "Noto Serif Gurmukhi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Serif+Gurmukhi:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Serif Gurmukhi', sans-serif"
  },
  "Noto Sans Cuneiform": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Cuneiform:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Cuneiform', sans-serif"
  },
  "Noto Sans Newa": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Newa:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Newa', sans-serif"
  },
  "Noto Sans Osage": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Osage:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Osage', sans-serif"
  },
  "Noto Sans Wancho": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Wancho:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Wancho', sans-serif"
  },
  "Noto Sans Syriac Eastern": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Syriac+Eastern:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Syriac Eastern', sans-serif"
  },
  "Noto Sans Inscriptional Parthian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Inscriptional+Parthian:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Inscriptional Parthian', sans-serif"
  },
  "Noto Sans Takri": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Takri:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Takri', sans-serif"
  },
  "Noto Sans Buginese": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Buginese:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Buginese', sans-serif"
  },
  "Noto Sans Mayan Numerals": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Mayan+Numerals:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Mayan Numerals', sans-serif"
  },
  "Noto Sans Old North Arabian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Old+North+Arabian:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Old North Arabian', sans-serif"
  },
  "Chokokutai": {
    "link": "https://fonts.googleapis.com/css?family=Chokokutai:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Chokokutai', sans-serif"
  },
  "Noto Sans Duployan": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Duployan:wght@0,400;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Duployan', sans-serif"
  },
  "Noto Sans Tai Le": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Tai+Le:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Tai Le', sans-serif"
  },
  "Noto Sans Saurashtra": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Saurashtra:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Saurashtra', sans-serif"
  },
  "Noto Sans Grantha": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Grantha:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Grantha', sans-serif"
  },
  "Noto Sans Old Permic": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Old+Permic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Old Permic', sans-serif"
  },
  "Noto Sans Siddham": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Siddham:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Siddham', sans-serif"
  },
  "Noto Sans Nabataean": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Nabataean:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Nabataean', sans-serif"
  },
  "Noto Sans Hanifi Rohingya": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Hanifi+Rohingya:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Hanifi Rohingya', sans-serif"
  },
  "Noto Sans Hatran": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Hatran:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Hatran', sans-serif"
  },
  "Noto Sans Bhaiksuki": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Bhaiksuki:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Bhaiksuki', sans-serif"
  },
  "Noto Sans Shavian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Shavian:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Shavian', sans-serif"
  },
  "Noto Sans Rejang": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Rejang:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Rejang', sans-serif"
  },
  "Noto Sans Syriac": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Syriac:wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Syriac', sans-serif"
  },
  "Noto Sans Gunjala Gondi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Gunjala+Gondi:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Gunjala Gondi', sans-serif"
  },
  "Noto Sans Sogdian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Sogdian:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Sogdian', sans-serif"
  },
  "Noto Sans Mro": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Mro:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Mro', sans-serif"
  },
  "Noto Sans Caucasian Albanian": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Caucasian+Albanian:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Caucasian Albanian', sans-serif"
  },
  "Noto Sans Mandaic": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Mandaic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Mandaic', sans-serif"
  },
  "Noto Sans Ogham": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Ogham:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Ogham', sans-serif"
  },
  "Noto Sans New Tai Lue": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+New+Tai+Lue:wght@0,400;0,500;0,600;0,700&subset=latin&display=swap",
    "fontFamily": "'Noto Sans New Tai Lue', sans-serif"
  },
  "Noto Sans Elbasan": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Elbasan:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Elbasan', sans-serif"
  },
  "Noto Sans Phoenician": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Phoenician:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Phoenician', sans-serif"
  },
  "Noto Sans Mahajani": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Mahajani:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Mahajani', sans-serif"
  },
  "Noto Sans SignWriting": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+SignWriting:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans SignWriting', sans-serif"
  },
  "Noto Sans Kharoshthi": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Kharoshthi:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Kharoshthi', sans-serif"
  },
  "Noto Sans Meroitic": {
    "link": "https://fonts.googleapis.com/css?family=Noto+Sans+Meroitic:wght@0,400&subset=latin&display=swap",
    "fontFamily": "'Noto Sans Meroitic', sans-serif"
  }
};

export default googleFonts;
